/**********************************************************************************
*** CONTENTS OF FILE IS AUTOGENERATED
*** DATE        : 2024-03-04
*** APPLICATION : Compilator.Mvc.JsUrlGenerator (1.9.1.0)
**********************************************************************************/

var compilator = compilator || {};
compilator.url = compilator.url || {};

compilator.url.TyreHotelMVC = {
  TireScan : {
    Index: {
      url: function(plate, scId, eqsId, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/TyreHotelMVC/TireScan/Index';
        }
        var f_args = this.argsObject(plate, scId, eqsId, branchId);
        return $menu.getRootUrl() + '/TyreHotelMVC/TireScan/Index' + '?' + $.param(f_args);
      },
      argsObject: function(plate, scId, eqsId, branchId) {
        var f_args = {
          plate: plate,
          scId: scId,
          eqsId: eqsId,
          branchId: branchId,
        };
        return f_args;
      },
      kendoWindow: function(plate, scId, eqsId, branchId, kendoWindowOptions) {
        var f_url = this.url(plate, scId, eqsId, branchId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(plate,scId,eqsId,branchId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetScans: {
      url: function(selectedStorageCard, branchId, licensePlateSearch, includeAlreadyConnectedTireScans, page, pageSize) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/TyreHotelMVC/TireScan/GetScans';
        }
        var f_args = this.argsObject(selectedStorageCard, branchId, licensePlateSearch, includeAlreadyConnectedTireScans, page, pageSize);
        return $menu.getRootUrl() + '/TyreHotelMVC/TireScan/GetScans' + '?' + $.param(f_args);
      },
      argsObject: function(selectedStorageCard, branchId, licensePlateSearch, includeAlreadyConnectedTireScans, page, pageSize) {
        var f_args = {
          selectedStorageCard: selectedStorageCard,
          branchId: branchId,
          licensePlateSearch: licensePlateSearch,
          includeAlreadyConnectedTireScans: includeAlreadyConnectedTireScans,
          page: page,
          pageSize: pageSize,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    SetSeason: {
      url: function() {
        return $menu.getRootUrl() + '/TyreHotelMVC/TireScan/SetSeason';
      },
      argsObject: function(tireScanId, seasonId) {
        var f_args = {
          tireScanId: tireScanId,
          seasonId: seasonId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'PUT', ajaxOptions, 'json', ajaxData);
      },
    },
    EmailEditor: {
      url: function(id) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/TyreHotelMVC/TireScan/EmailEditor';
        }
        var f_args = this.argsObject(id);
        return $menu.getRootUrl() + '/TyreHotelMVC/TireScan/EmailEditor' + '?' + $.param(f_args);
      },
      argsObject: function(id) {
        var f_args = {
          id: id,
        };
        return f_args;
      },
      kendoWindow: function(id, kendoWindowOptions) {
        var f_url = this.url(id);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(id, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SendEmail: {
      url: function() {
        return $menu.getRootUrl() + '/TyreHotelMVC/TireScan/SendEmail';
      },
      argsObject: function(emailInfo_Recipients, emailInfo_Subject, emailInfo_Body, emailInfo_TireScanId) {
        var f_args = {
          emailInfo: {
            Recipients: emailInfo_Recipients,
            Subject: emailInfo_Subject,
            Body: emailInfo_Body,
            TireScanId: emailInfo_TireScanId,
          },
        };
        return f_args;
      },
      kendoWindow: function(data, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow('', kendoWindowOptions);
        f_window.refresh({
          url: f_url,
          data: JSON.stringify(data),
          contentType: 'application/json',
          type: 'POST'
        });
        return f_window;
      },
    },
    ReportInfo: {
      url: function(id, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/TyreHotelMVC/TireScan/ReportInfo';
        }
        var f_args = this.argsObject(id, branchId);
        return $menu.getRootUrl() + '/TyreHotelMVC/TireScan/ReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(id, branchId) {
        var f_args = {
          id: id,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    ConnectionEditor: {
      url: function(scanId, scId, eqsId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/TyreHotelMVC/TireScan/ConnectionEditor';
        }
        var f_args = this.argsObject(scanId, scId, eqsId);
        return $menu.getRootUrl() + '/TyreHotelMVC/TireScan/ConnectionEditor' + '?' + $.param(f_args);
      },
      argsObject: function(scanId, scId, eqsId) {
        var f_args = {
          scanId: scanId,
          scId: scId,
          eqsId: eqsId,
        };
        return f_args;
      },
      kendoWindow: function(scanId, scId, eqsId, kendoWindowOptions) {
        var f_url = this.url(scanId, scId, eqsId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(scanId,scId,eqsId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    ConnectScanToEquipmentSet: {
      url: function() {
        return $menu.getRootUrl() + '/TyreHotelMVC/TireScan/ConnectScanToEquipmentSet';
      },
      argsObject: function(model_TireScanId, model_BranchId, model_StorageCardId, model_SeasonId, model_TirePositions) {
        var f_args = {
          model: {
            TireScanId: model_TireScanId,
            BranchId: model_BranchId,
            StorageCardId: model_StorageCardId,
            SeasonId: model_SeasonId,
            TirePositions: model_TirePositions,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'PUT', ajaxOptions, 'json', ajaxData);
      },
    },
    Delete: {
      url: function(tireScanId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/TyreHotelMVC/TireScan/Delete';
        }
        var f_args = this.argsObject(tireScanId);
        return $menu.getRootUrl() + '/TyreHotelMVC/TireScan/Delete' + '?' + $.param(f_args);
      },
      argsObject: function(tireScanId) {
        var f_args = {
          tireScanId: tireScanId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'DELETE', ajaxOptions, 'json', ajaxData);
      },
    },
    GetImage: {
      url: function(wheelId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/TyreHotelMVC/TireScan/GetImage';
        }
        var f_args = this.argsObject(wheelId);
        return $menu.getRootUrl() + '/TyreHotelMVC/TireScan/GetImage' + '?' + $.param(f_args);
      },
      argsObject: function(wheelId) {
        var f_args = {
          wheelId: wheelId,
        };
        return f_args;
      },
      kendoWindow: function(wheelId, kendoWindowOptions) {
        var f_url = this.url(wheelId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(wheelId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetOpenStorageCardsForLicensePlate: {
      url: function(licensePlate) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/TyreHotelMVC/TireScan/GetOpenStorageCardsForLicensePlate';
        }
        var f_args = this.argsObject(licensePlate);
        return $menu.getRootUrl() + '/TyreHotelMVC/TireScan/GetOpenStorageCardsForLicensePlate' + '?' + $.param(f_args);
      },
      argsObject: function(licensePlate) {
        var f_args = {
          licensePlate: licensePlate,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  Preplanning : {
    ConfirmDeactivationWindow: {
      url: function() {
        return $menu.getRootUrl() + '/TyreHotelMVC/Preplanning/ConfirmDeactivationWindow';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    Activate: {
      url: function() {
        return $menu.getRootUrl() + '/TyreHotelMVC/Preplanning/Activate';
      },
      argsObject: function(model_UseDirectMailOnly, model_Id, model_BranchId, model_BranchName, model_Name, model_Status, model_Season, model_StartDate, model_EndDate, model_HasBookingPeriodChanged, model_Reminder1Date, model_Reminder2Date, model_Tpms, model_CompleteWheel, model_TyresOnly, model_Studs, model_Friction, model_DebitModelId, model_VehicleTypeId, model_VehicleClassId, model_Stocks, model_Calendars, model_MessageChannels, model_StorageCards, model_RemainingStorageCardsCount, model_CustomerId, model_CustomerName, model_Changed, model_ChangedBy, model_Created, model_CreatedBy, model_LastActivated, model_LastActivatedBy, model_DispatchDate, model_Active, model_MakeBookings, model_ReminderTimeEmail, model_ReminderTimeSMS, model_ContainsDirectMailBookings, model_DeleteDirectMailBookings, model_HasStorageCardsAlreadyExistingInPreplanning, model_PreplanningTimeSlotDuration, model_PreplanningTimeSlotPadding) {
        var f_args = {
          model: {
            UseDirectMailOnly: model_UseDirectMailOnly,
            Id: model_Id,
            BranchId: model_BranchId,
            BranchName: model_BranchName,
            Name: model_Name,
            Status: model_Status,
            Season: model_Season,
            StartDate: model_StartDate,
            EndDate: model_EndDate,
            HasBookingPeriodChanged: model_HasBookingPeriodChanged,
            Reminder1Date: model_Reminder1Date,
            Reminder2Date: model_Reminder2Date,
            Tpms: model_Tpms,
            CompleteWheel: model_CompleteWheel,
            TyresOnly: model_TyresOnly,
            Studs: model_Studs,
            Friction: model_Friction,
            DebitModelId: model_DebitModelId,
            VehicleTypeId: model_VehicleTypeId,
            VehicleClassId: model_VehicleClassId,
            Stocks: model_Stocks,
            Calendars: model_Calendars,
            MessageChannels: model_MessageChannels,
            StorageCards: model_StorageCards,
            RemainingStorageCardsCount: model_RemainingStorageCardsCount,
            CustomerId: model_CustomerId,
            CustomerName: model_CustomerName,
            Changed: model_Changed,
            ChangedBy: model_ChangedBy,
            Created: model_Created,
            CreatedBy: model_CreatedBy,
            LastActivated: model_LastActivated,
            LastActivatedBy: model_LastActivatedBy,
            DispatchDate: model_DispatchDate,
            Active: model_Active,
            MakeBookings: model_MakeBookings,
            ReminderTimeEmail: model_ReminderTimeEmail,
            ReminderTimeSMS: model_ReminderTimeSMS,
            ContainsDirectMailBookings: model_ContainsDirectMailBookings,
            DeleteDirectMailBookings: model_DeleteDirectMailBookings,
            HasStorageCardsAlreadyExistingInPreplanning: model_HasStorageCardsAlreadyExistingInPreplanning,
            PreplanningTimeSlotDuration: model_PreplanningTimeSlotDuration,
            PreplanningTimeSlotPadding: model_PreplanningTimeSlotPadding,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    Deactivate: {
      url: function() {
        return $menu.getRootUrl() + '/TyreHotelMVC/Preplanning/Deactivate';
      },
      argsObject: function(model_UseDirectMailOnly, model_Id, model_BranchId, model_BranchName, model_Name, model_Status, model_Season, model_StartDate, model_EndDate, model_HasBookingPeriodChanged, model_Reminder1Date, model_Reminder2Date, model_Tpms, model_CompleteWheel, model_TyresOnly, model_Studs, model_Friction, model_DebitModelId, model_VehicleTypeId, model_VehicleClassId, model_Stocks, model_Calendars, model_MessageChannels, model_StorageCards, model_RemainingStorageCardsCount, model_CustomerId, model_CustomerName, model_Changed, model_ChangedBy, model_Created, model_CreatedBy, model_LastActivated, model_LastActivatedBy, model_DispatchDate, model_Active, model_MakeBookings, model_ReminderTimeEmail, model_ReminderTimeSMS, model_ContainsDirectMailBookings, model_DeleteDirectMailBookings, model_HasStorageCardsAlreadyExistingInPreplanning, model_PreplanningTimeSlotDuration, model_PreplanningTimeSlotPadding) {
        var f_args = {
          model: {
            UseDirectMailOnly: model_UseDirectMailOnly,
            Id: model_Id,
            BranchId: model_BranchId,
            BranchName: model_BranchName,
            Name: model_Name,
            Status: model_Status,
            Season: model_Season,
            StartDate: model_StartDate,
            EndDate: model_EndDate,
            HasBookingPeriodChanged: model_HasBookingPeriodChanged,
            Reminder1Date: model_Reminder1Date,
            Reminder2Date: model_Reminder2Date,
            Tpms: model_Tpms,
            CompleteWheel: model_CompleteWheel,
            TyresOnly: model_TyresOnly,
            Studs: model_Studs,
            Friction: model_Friction,
            DebitModelId: model_DebitModelId,
            VehicleTypeId: model_VehicleTypeId,
            VehicleClassId: model_VehicleClassId,
            Stocks: model_Stocks,
            Calendars: model_Calendars,
            MessageChannels: model_MessageChannels,
            StorageCards: model_StorageCards,
            RemainingStorageCardsCount: model_RemainingStorageCardsCount,
            CustomerId: model_CustomerId,
            CustomerName: model_CustomerName,
            Changed: model_Changed,
            ChangedBy: model_ChangedBy,
            Created: model_Created,
            CreatedBy: model_CreatedBy,
            LastActivated: model_LastActivated,
            LastActivatedBy: model_LastActivatedBy,
            DispatchDate: model_DispatchDate,
            Active: model_Active,
            MakeBookings: model_MakeBookings,
            ReminderTimeEmail: model_ReminderTimeEmail,
            ReminderTimeSMS: model_ReminderTimeSMS,
            ContainsDirectMailBookings: model_ContainsDirectMailBookings,
            DeleteDirectMailBookings: model_DeleteDirectMailBookings,
            HasStorageCardsAlreadyExistingInPreplanning: model_HasStorageCardsAlreadyExistingInPreplanning,
            PreplanningTimeSlotDuration: model_PreplanningTimeSlotDuration,
            PreplanningTimeSlotPadding: model_PreplanningTimeSlotPadding,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    PollStatus: {
      url: function() {
        return $menu.getRootUrl() + '/TyreHotelMVC/Preplanning/PollStatus';
      },
      argsObject: function(preplanningIds) {
        var f_args = {
          preplanningIds: preplanningIds,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    CheckAddonsActivated: {
      url: function() {
        return $menu.getRootUrl() + '/TyreHotelMVC/Preplanning/CheckAddonsActivated';
      },
      argsObject: function(model_UseDirectMailOnly, model_Id, model_BranchId, model_BranchName, model_Name, model_Status, model_Season, model_StartDate, model_EndDate, model_HasBookingPeriodChanged, model_Reminder1Date, model_Reminder2Date, model_Tpms, model_CompleteWheel, model_TyresOnly, model_Studs, model_Friction, model_DebitModelId, model_VehicleTypeId, model_VehicleClassId, model_Stocks, model_Calendars, model_MessageChannels, model_StorageCards, model_RemainingStorageCardsCount, model_CustomerId, model_CustomerName, model_Changed, model_ChangedBy, model_Created, model_CreatedBy, model_LastActivated, model_LastActivatedBy, model_DispatchDate, model_Active, model_MakeBookings, model_ReminderTimeEmail, model_ReminderTimeSMS, model_ContainsDirectMailBookings, model_DeleteDirectMailBookings, model_HasStorageCardsAlreadyExistingInPreplanning, model_PreplanningTimeSlotDuration, model_PreplanningTimeSlotPadding) {
        var f_args = {
          model: {
            UseDirectMailOnly: model_UseDirectMailOnly,
            Id: model_Id,
            BranchId: model_BranchId,
            BranchName: model_BranchName,
            Name: model_Name,
            Status: model_Status,
            Season: model_Season,
            StartDate: model_StartDate,
            EndDate: model_EndDate,
            HasBookingPeriodChanged: model_HasBookingPeriodChanged,
            Reminder1Date: model_Reminder1Date,
            Reminder2Date: model_Reminder2Date,
            Tpms: model_Tpms,
            CompleteWheel: model_CompleteWheel,
            TyresOnly: model_TyresOnly,
            Studs: model_Studs,
            Friction: model_Friction,
            DebitModelId: model_DebitModelId,
            VehicleTypeId: model_VehicleTypeId,
            VehicleClassId: model_VehicleClassId,
            Stocks: model_Stocks,
            Calendars: model_Calendars,
            MessageChannels: model_MessageChannels,
            StorageCards: model_StorageCards,
            RemainingStorageCardsCount: model_RemainingStorageCardsCount,
            CustomerId: model_CustomerId,
            CustomerName: model_CustomerName,
            Changed: model_Changed,
            ChangedBy: model_ChangedBy,
            Created: model_Created,
            CreatedBy: model_CreatedBy,
            LastActivated: model_LastActivated,
            LastActivatedBy: model_LastActivatedBy,
            DispatchDate: model_DispatchDate,
            Active: model_Active,
            MakeBookings: model_MakeBookings,
            ReminderTimeEmail: model_ReminderTimeEmail,
            ReminderTimeSMS: model_ReminderTimeSMS,
            ContainsDirectMailBookings: model_ContainsDirectMailBookings,
            DeleteDirectMailBookings: model_DeleteDirectMailBookings,
            HasStorageCardsAlreadyExistingInPreplanning: model_HasStorageCardsAlreadyExistingInPreplanning,
            PreplanningTimeSlotDuration: model_PreplanningTimeSlotDuration,
            PreplanningTimeSlotPadding: model_PreplanningTimeSlotPadding,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    Delete: {
      url: function(id) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/TyreHotelMVC/Preplanning/Delete';
        }
        var f_args = this.argsObject(id);
        return $menu.getRootUrl() + '/TyreHotelMVC/Preplanning/Delete' + '?' + $.param(f_args);
      },
      argsObject: function(id) {
        var f_args = {
          id: id,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'DELETE', ajaxOptions, 'json', ajaxData);
      },
    },
    GetPreplannintStatistics: {
      url: function() {
        return $menu.getRootUrl() + '/TyreHotelMVC/Preplanning/GetPreplannintStatistics';
      },
      argsObject: function(model_UseDirectMailOnly, model_Id, model_BranchId, model_BranchName, model_Name, model_Status, model_Season, model_StartDate, model_EndDate, model_HasBookingPeriodChanged, model_Reminder1Date, model_Reminder2Date, model_Tpms, model_CompleteWheel, model_TyresOnly, model_Studs, model_Friction, model_DebitModelId, model_VehicleTypeId, model_VehicleClassId, model_Stocks, model_Calendars, model_MessageChannels, model_StorageCards, model_RemainingStorageCardsCount, model_CustomerId, model_CustomerName, model_Changed, model_ChangedBy, model_Created, model_CreatedBy, model_LastActivated, model_LastActivatedBy, model_DispatchDate, model_Active, model_MakeBookings, model_ReminderTimeEmail, model_ReminderTimeSMS, model_ContainsDirectMailBookings, model_DeleteDirectMailBookings, model_HasStorageCardsAlreadyExistingInPreplanning, model_PreplanningTimeSlotDuration, model_PreplanningTimeSlotPadding) {
        var f_args = {
          model: {
            UseDirectMailOnly: model_UseDirectMailOnly,
            Id: model_Id,
            BranchId: model_BranchId,
            BranchName: model_BranchName,
            Name: model_Name,
            Status: model_Status,
            Season: model_Season,
            StartDate: model_StartDate,
            EndDate: model_EndDate,
            HasBookingPeriodChanged: model_HasBookingPeriodChanged,
            Reminder1Date: model_Reminder1Date,
            Reminder2Date: model_Reminder2Date,
            Tpms: model_Tpms,
            CompleteWheel: model_CompleteWheel,
            TyresOnly: model_TyresOnly,
            Studs: model_Studs,
            Friction: model_Friction,
            DebitModelId: model_DebitModelId,
            VehicleTypeId: model_VehicleTypeId,
            VehicleClassId: model_VehicleClassId,
            Stocks: model_Stocks,
            Calendars: model_Calendars,
            MessageChannels: model_MessageChannels,
            StorageCards: model_StorageCards,
            RemainingStorageCardsCount: model_RemainingStorageCardsCount,
            CustomerId: model_CustomerId,
            CustomerName: model_CustomerName,
            Changed: model_Changed,
            ChangedBy: model_ChangedBy,
            Created: model_Created,
            CreatedBy: model_CreatedBy,
            LastActivated: model_LastActivated,
            LastActivatedBy: model_LastActivatedBy,
            DispatchDate: model_DispatchDate,
            Active: model_Active,
            MakeBookings: model_MakeBookings,
            ReminderTimeEmail: model_ReminderTimeEmail,
            ReminderTimeSMS: model_ReminderTimeSMS,
            ContainsDirectMailBookings: model_ContainsDirectMailBookings,
            DeleteDirectMailBookings: model_DeleteDirectMailBookings,
            HasStorageCardsAlreadyExistingInPreplanning: model_HasStorageCardsAlreadyExistingInPreplanning,
            PreplanningTimeSlotDuration: model_PreplanningTimeSlotDuration,
            PreplanningTimeSlotPadding: model_PreplanningTimeSlotPadding,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    New: {
      url: function(branchId, startDate, endDate) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/TyreHotelMVC/Preplanning/New';
        }
        var f_args = this.argsObject(branchId, startDate, endDate);
        return $menu.getRootUrl() + '/TyreHotelMVC/Preplanning/New' + '?' + $.param(f_args);
      },
      argsObject: function(branchId, startDate, endDate) {
        var f_args = {
          branchId: branchId,
          startDate: startDate,
          endDate: endDate,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    Details: {
      url: function(id, copyFromId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/TyreHotelMVC/Preplanning/Details';
        }
        var f_args = this.argsObject(id, copyFromId);
        return $menu.getRootUrl() + '/TyreHotelMVC/Preplanning/Details' + '?' + $.param(f_args);
      },
      argsObject: function(id, copyFromId) {
        var f_args = {
          id: id,
          copyFromId: copyFromId,
        };
        return f_args;
      },
      browserWindow: function(id, copyFromId) {
        var f_url = this.url(id, copyFromId);
        var f_args = [id, copyFromId];
        var f_winId = f_args.join('_')
        var f_windowName = undefined;
        if(f_winId.replace(/_/g, '') != '') {
          f_windowName = 'Details_' + f_args.join('_');
        }
        compilator.windowHandler.openWindowWithFocus(f_url, f_windowName, arguments.length > 0);
      },
    },
    PrintDirectMail: {
      url: function() {
        return $menu.getRootUrl() + '/TyreHotelMVC/Preplanning/PrintDirectMail';
      },
      argsObject: function(preplanningDirectMailParams_BranchId, preplanningDirectMailParams_FormatId, preplanningDirectMailParams_PreplanningId, preplanningDirectMailParams_TypeId, preplanningDirectMailParams_UseCustomerAddress, preplanningDirectMailParams_UseStorageCardExternalNote, preplanningDirectMailParams_Preview) {
        var f_args = {
          preplanningDirectMailParams: {
            BranchId: preplanningDirectMailParams_BranchId,
            FormatId: preplanningDirectMailParams_FormatId,
            PreplanningId: preplanningDirectMailParams_PreplanningId,
            TypeId: preplanningDirectMailParams_TypeId,
            UseCustomerAddress: preplanningDirectMailParams_UseCustomerAddress,
            UseStorageCardExternalNote: preplanningDirectMailParams_UseStorageCardExternalNote,
            Preview: preplanningDirectMailParams_Preview,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    PrintDirectMailWindow: {
      url: function(branchId, preplanningId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/TyreHotelMVC/Preplanning/PrintDirectMailWindow';
        }
        var f_args = this.argsObject(branchId, preplanningId);
        return $menu.getRootUrl() + '/TyreHotelMVC/Preplanning/PrintDirectMailWindow' + '?' + $.param(f_args);
      },
      argsObject: function(branchId, preplanningId) {
        var f_args = {
          branchId: branchId,
          preplanningId: preplanningId,
        };
        return f_args;
      },
      kendoWindow: function(branchId, preplanningId, kendoWindowOptions) {
        var f_url = this.url(branchId, preplanningId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(branchId,preplanningId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    CheckSMSAddonAndNumber: {
      url: function(branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/TyreHotelMVC/Preplanning/CheckSMSAddonAndNumber';
        }
        var f_args = this.argsObject(branchId);
        return $menu.getRootUrl() + '/TyreHotelMVC/Preplanning/CheckSMSAddonAndNumber' + '?' + $.param(f_args);
      },
      argsObject: function(branchId) {
        var f_args = {
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  StorageCard : {
    ChangeVehicle: {
      url1: function(storageCardId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/TyreHotelMVC/StorageCard/ChangeVehicle';
        }
        var f_args = this.argsObject1(storageCardId);
        return $menu.getRootUrl() + '/TyreHotelMVC/StorageCard/ChangeVehicle' + '?' + $.param(f_args);
      },
      argsObject1: function(storageCardId) {
        var f_args = {
          storageCardId: storageCardId,
        };
        return f_args;
      },
      kendoWindow1: function(storageCardId, kendoWindowOptions) {
        var f_url = this.url1(storageCardId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects1: function(storageCardId, kendoWindowOptions) {
        var f_url = this.url1();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      url2: function() {
        return $menu.getRootUrl() + '/TyreHotelMVC/StorageCard/ChangeVehicle';
      },
      argsObject2: function(changeVehicle_LicensePlateNumber, changeVehicle_CopyCustomerAndContact, changeVehicle_CopyFromStorageCardId, changeVehicle_CloseExistingStorageCard, changeVehicle_PrintCloseConfirmation, changeVehicle_GoodsReturned, changeVehicle_KeepStockPlace, changeVehicle_StockId, changeVehicle_StockPlaceId, changeVehicle_StockPlace, changeVehicle_StoredEquipmentSetId, changeVehicle_PreviousEquipmentSetId, changeVehicle_SetStoredEquipmentSetInStorage, changeVehicle_StoredEquipmentSetDimensionDisplayString, changeVehicle_PreviousEquipmentSetDisplayString, changeVehicle_CopyStoredEquipmentSet, changeVehicle_CopyPreviousEquipmentSet, changeVehicle_CopyInternalNote, changeVehicle_CopyExternalNote, changeVehicle_InternalNote, changeVehicle_ExternalNote, changeVehicle_PrintStorageReceipt, changeVehicle_PrintLabel) {
        var f_args = {
          changeVehicle: {
            LicensePlateNumber: changeVehicle_LicensePlateNumber,
            CopyCustomerAndContact: changeVehicle_CopyCustomerAndContact,
            CopyFromStorageCardId: changeVehicle_CopyFromStorageCardId,
            CloseExistingStorageCard: changeVehicle_CloseExistingStorageCard,
            PrintCloseConfirmation: changeVehicle_PrintCloseConfirmation,
            GoodsReturned: changeVehicle_GoodsReturned,
            KeepStockPlace: changeVehicle_KeepStockPlace,
            StockId: changeVehicle_StockId,
            StockPlaceId: changeVehicle_StockPlaceId,
            StockPlace: changeVehicle_StockPlace,
            StoredEquipmentSetId: changeVehicle_StoredEquipmentSetId,
            PreviousEquipmentSetId: changeVehicle_PreviousEquipmentSetId,
            SetStoredEquipmentSetInStorage: changeVehicle_SetStoredEquipmentSetInStorage,
            StoredEquipmentSetDimensionDisplayString: changeVehicle_StoredEquipmentSetDimensionDisplayString,
            PreviousEquipmentSetDisplayString: changeVehicle_PreviousEquipmentSetDisplayString,
            CopyStoredEquipmentSet: changeVehicle_CopyStoredEquipmentSet,
            CopyPreviousEquipmentSet: changeVehicle_CopyPreviousEquipmentSet,
            CopyInternalNote: changeVehicle_CopyInternalNote,
            CopyExternalNote: changeVehicle_CopyExternalNote,
            InternalNote: changeVehicle_InternalNote,
            ExternalNote: changeVehicle_ExternalNote,
            PrintStorageReceipt: changeVehicle_PrintStorageReceipt,
            PrintLabel: changeVehicle_PrintLabel,
          },
        };
        return f_args;
      },
      kendoWindow2: function(data, kendoWindowOptions) {
        var f_url = this.url2();
        var f_window = $kendo.openNewKendoWindow('', kendoWindowOptions);
        f_window.refresh({
          url: f_url,
          data: JSON.stringify(data),
          contentType: 'application/json',
          type: 'POST'
        });
        return f_window;
      },
    },
    GetStorageCards: {
      url: function(licensePlate, eventId, storageCardId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/TyreHotelMVC/StorageCard/GetStorageCards';
        }
        var f_args = this.argsObject(licensePlate, eventId, storageCardId);
        return $menu.getRootUrl() + '/TyreHotelMVC/StorageCard/GetStorageCards' + '?' + $.param(f_args);
      },
      argsObject: function(licensePlate, eventId, storageCardId) {
        var f_args = {
          licensePlate: licensePlate,
          eventId: eventId,
          storageCardId: storageCardId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    StorageCardPilemarkDialog: {
      url: function() {
        return $menu.getRootUrl() + '/TyreHotelMVC/StorageCard/StorageCardPilemarkDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    HasOrderConnectedAlready: {
      url: function(storageCardId, orderId, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/TyreHotelMVC/StorageCard/HasOrderConnectedAlready';
        }
        var f_args = this.argsObject(storageCardId, orderId, branchId);
        return $menu.getRootUrl() + '/TyreHotelMVC/StorageCard/HasOrderConnectedAlready' + '?' + $.param(f_args);
      },
      argsObject: function(storageCardId, orderId, branchId) {
        var f_args = {
          storageCardId: storageCardId,
          orderId: orderId,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    PrintStorageCardLabels: {
      url: function(storageCardId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/TyreHotelMVC/StorageCard/PrintStorageCardLabels';
        }
        var f_args = this.argsObject(storageCardId);
        return $menu.getRootUrl() + '/TyreHotelMVC/StorageCard/PrintStorageCardLabels' + '?' + $.param(f_args);
      },
      argsObject: function(storageCardId) {
        var f_args = {
          storageCardId: storageCardId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    OpenOrCreateNewOrder: {
      url: function(orderId, branchId, licensePlate, customerNo, contactId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/TyreHotelMVC/StorageCard/OpenOrCreateNewOrder';
        }
        var f_args = this.argsObject(orderId, branchId, licensePlate, customerNo, contactId);
        return $menu.getRootUrl() + '/TyreHotelMVC/StorageCard/OpenOrCreateNewOrder' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, branchId, licensePlate, customerNo, contactId) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
          licensePlate: licensePlate,
          customerNo: customerNo,
          contactId: contactId,
        };
        return f_args;
      },
      kendoWindow: function(orderId, branchId, licensePlate, customerNo, contactId, kendoWindowOptions) {
        var f_url = this.url(orderId, branchId, licensePlate, customerNo, contactId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(orderId,branchId,licensePlate,customerNo,contactId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    PrintClosedStorage: {
      url: function() {
        return $menu.getRootUrl() + '/TyreHotelMVC/StorageCard/PrintClosedStorage';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
};

compilator.url.SystemSettingsMVC = {
  Accounting : {
    CostCentreDialog: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Accounting/CostCentreDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    AccountsListDialog: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Accounting/AccountsListDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SyncAccountsDialog: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Accounting/SyncAccountsDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SyncAccounts: {
      url: function(updateNames) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Accounting/SyncAccounts';
        }
        var f_args = this.argsObject(updateNames);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Accounting/SyncAccounts' + '?' + $.param(f_args);
      },
      argsObject: function(updateNames) {
        var f_args = {
          updateNames: updateNames,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    SynchCostCentreResult: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Accounting/SynchCostCentreResult';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    ImportAccountsDialog: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Accounting/ImportAccountsDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    ImportAccounts: {
      url: function(files, updateAccountName) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Accounting/ImportAccounts';
        }
        var f_args = this.argsObject(files, updateAccountName);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Accounting/ImportAccounts' + '?' + $.param(f_args);
      },
      argsObject: function(files, updateAccountName) {
        var f_args = {
          files: files,
          updateAccountName: updateAccountName,
        };
        return f_args;
      },
      kendoWindow: function(files, updateAccountName, kendoWindowOptions) {
        var f_url = this.url(files, updateAccountName);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(files,updateAccountName, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  AccountsPayable : {
    Index: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/AccountsPayable/Index';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SaveAccountsPayableSettings: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/AccountsPayable/SaveAccountsPayableSettings';
      },
      argsObject: function(model_CompanyId, model_BankgiroCustomerNumber, model_EnableExport, model_IncludePGExport, model_ReceiveEInvoice, model_ExportType, model_OutgoingPaymentAccount, model_OutgoingPaymentAccountTypes, model_RoundingAccountId, model_CurrencyProfitsAccountId, model_CurrencyLossesAccountId, model_DefaultReceivablesAccountId, model_DeductionAccountId, model_BankPaymentFeeAccountId, model_DefaultSupplierPurchaseAccountId, model_DefaultShippingCostAccoundId, model_DefaultPurchaseAccountId, model_DefaultModeOfPaymentTypes) {
        var f_args = {
          model: {
            CompanyId: model_CompanyId,
            BankgiroCustomerNumber: model_BankgiroCustomerNumber,
            EnableExport: model_EnableExport,
            IncludePGExport: model_IncludePGExport,
            ReceiveEInvoice: model_ReceiveEInvoice,
            ExportType: model_ExportType,
            OutgoingPaymentAccount: model_OutgoingPaymentAccount,
            OutgoingPaymentAccountTypes: model_OutgoingPaymentAccountTypes,
            RoundingAccountId: model_RoundingAccountId,
            CurrencyProfitsAccountId: model_CurrencyProfitsAccountId,
            CurrencyLossesAccountId: model_CurrencyLossesAccountId,
            DefaultReceivablesAccountId: model_DefaultReceivablesAccountId,
            DeductionAccountId: model_DeductionAccountId,
            BankPaymentFeeAccountId: model_BankPaymentFeeAccountId,
            DefaultSupplierPurchaseAccountId: model_DefaultSupplierPurchaseAccountId,
            DefaultShippingCostAccoundId: model_DefaultShippingCostAccoundId,
            DefaultPurchaseAccountId: model_DefaultPurchaseAccountId,
            DefaultModeOfPaymentTypes: model_DefaultModeOfPaymentTypes,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  AdyenAddon : {
    SetupAccountHolder: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/AdyenAddon/SetupAccountHolder';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetOnboardingUrl: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/AdyenAddon/GetOnboardingUrl';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
    SaveAccountHolder: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/AdyenAddon/SaveAccountHolder';
      },
      argsObject: function(accountHolder_AccountHolderCode, accountHolder_OrgNo, accountHolder_VatNo, accountHolder_DoingBusinessAs, accountHolder_LegalBusinessName, accountHolder_CompanyEmail, accountHolder_CountryCode, accountHolder_BankAccountDetail, accountHolder_PrimaryBankAccountDetail, accountHolder_BusinessAddress, accountHolder_ShareHolders) {
        var f_args = {
          accountHolder: {
            AccountHolderCode: accountHolder_AccountHolderCode,
            OrgNo: accountHolder_OrgNo,
            VatNo: accountHolder_VatNo,
            DoingBusinessAs: accountHolder_DoingBusinessAs,
            LegalBusinessName: accountHolder_LegalBusinessName,
            CompanyEmail: accountHolder_CompanyEmail,
            CountryCode: accountHolder_CountryCode,
            BankAccountDetail: accountHolder_BankAccountDetail,
            PrimaryBankAccountDetail: accountHolder_PrimaryBankAccountDetail,
            BusinessAddress: accountHolder_BusinessAddress,
            ShareHolders: accountHolder_ShareHolders,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    DeactivateAdyen: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/AdyenAddon/DeactivateAdyen';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json');
      },
    },
    SetupBranchStore: {
      url: function(branchId, storeId, accountHolderId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/AdyenAddon/SetupBranchStore';
        }
        var f_args = this.argsObject(branchId, storeId, accountHolderId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/AdyenAddon/SetupBranchStore' + '?' + $.param(f_args);
      },
      argsObject: function(branchId, storeId, accountHolderId) {
        var f_args = {
          branchId: branchId,
          storeId: storeId,
          accountHolderId: accountHolderId,
        };
        return f_args;
      },
      kendoWindow: function(branchId, storeId, accountHolderId, kendoWindowOptions) {
        var f_url = this.url(branchId, storeId, accountHolderId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(branchId,storeId,accountHolderId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SaveBranchStore: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/AdyenAddon/SaveBranchStore';
      },
      argsObject: function(branchStore_AccountHolderId, branchStore_BranchId, branchStore_BranchName, branchStore_StoreId, branchStore_TransactionAccountId, branchStore_PayoutAccountId, branchStore_StoreName, branchStore_HouseNumber, branchStore_Address, branchStore_PostalCode, branchStore_Town, branchStore_CountryCode, branchStore_PhoneNumber) {
        var f_args = {
          branchStore: {
            AccountHolderId: branchStore_AccountHolderId,
            BranchId: branchStore_BranchId,
            BranchName: branchStore_BranchName,
            StoreId: branchStore_StoreId,
            TransactionAccountId: branchStore_TransactionAccountId,
            PayoutAccountId: branchStore_PayoutAccountId,
            StoreName: branchStore_StoreName,
            HouseNumber: branchStore_HouseNumber,
            Address: branchStore_Address,
            PostalCode: branchStore_PostalCode,
            Town: branchStore_Town,
            CountryCode: branchStore_CountryCode,
            PhoneNumber: branchStore_PhoneNumber,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    SetupPayout: {
      url: function(accountHolderId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/AdyenAddon/SetupPayout';
        }
        var f_args = this.argsObject(accountHolderId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/AdyenAddon/SetupPayout' + '?' + $.param(f_args);
      },
      argsObject: function(accountHolderId) {
        var f_args = {
          accountHolderId: accountHolderId,
        };
        return f_args;
      },
      kendoWindow: function(accountHolderId, kendoWindowOptions) {
        var f_url = this.url(accountHolderId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(accountHolderId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  BrilliantAddon : {
    GetSettingsView: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/BrilliantAddon/GetSettingsView';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    DeactivateBrilliantAddon: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/BrilliantAddon/DeactivateBrilliantAddon';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json');
      },
    },
  },
  DackPartner : {
    Index: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/DackPartner/Index';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    ActivateAddOn: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/DackPartner/ActivateAddOn';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
    DeactivateAddOn: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/DackPartner/DeactivateAddOn';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
  },
  ResursBankAddon : {
    DeactivateResursBank: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/ResursBankAddon/DeactivateResursBank';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json');
      },
    },
    GetBranchesAvailableForStoreIdConnection: {
      url: function(branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/ResursBankAddon/GetBranchesAvailableForStoreIdConnection';
        }
        var f_args = this.argsObject(branchId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/ResursBankAddon/GetBranchesAvailableForStoreIdConnection' + '?' + $.param(f_args);
      },
      argsObject: function(branchId) {
        var f_args = {
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  MichelinFenXAddon : {
    DeactivateMichelinFenX: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/MichelinFenXAddon/DeactivateMichelinFenX';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json');
      },
    },
  },
  PandaDocAddon : {
    DeactivatePandaDoc: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/PandaDocAddon/DeactivatePandaDoc';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json');
      },
    },
  },
  Company : {
    Index: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Company/Index';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SaveCompanySettings: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Company/SaveCompanySettings';
      },
      argsObject: function(model_Company) {
        var f_args = {
          model: {
            Company: model_Company,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    SaveSmsSenderSetting: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Company/SaveSmsSenderSetting';
      },
      argsObject: function(request_Page, request_PageSize, request_Sorts, request_Filters, request_Groups, request_Aggregates, model_BranchId, model_SmsSender, model_IsReplyable) {
        var f_args = {
          request: {
            Page: request_Page,
            PageSize: request_PageSize,
            Sorts: request_Sorts,
            Filters: request_Filters,
            Groups: request_Groups,
            Aggregates: request_Aggregates,
          },
          model: {
            BranchId: model_BranchId,
            SmsSender: model_SmsSender,
            IsReplyable: model_IsReplyable,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    Currencies: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Company/Currencies';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    Units: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Company/Units';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    CostCentre: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Company/CostCentre';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    Sie4Export: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Company/Sie4Export';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    DownloadSie4Export: {
      url: function(username, fromDate, toDate, format, useQueue) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Company/DownloadSie4Export';
        }
        var f_args = this.argsObject(username, fromDate, toDate, format, useQueue);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Company/DownloadSie4Export' + '?' + $.param(f_args);
      },
      argsObject: function(username, fromDate, toDate, format, useQueue) {
        var f_args = {
          username: username,
          fromDate: fromDate,
          toDate: toDate,
          format: format,
          useQueue: useQueue,
        };
        return f_args;
      },
      kendoWindow: function(username, fromDate, toDate, format, useQueue, kendoWindowOptions) {
        var f_url = this.url(username, fromDate, toDate, format, useQueue);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(username,fromDate,toDate,format,useQueue, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    VatSettings: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Company/VatSettings';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    CompanyHasIBANAndSwift: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Company/CompanyHasIBANAndSwift';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
  },
  Fortnox : {
    Index: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Fortnox/Index';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    DeactivateAddon: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Fortnox/DeactivateAddon';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
    AccountingVouchersErrorList: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Fortnox/AccountingVouchersErrorList';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    ManuallyHandledVoucher: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Fortnox/ManuallyHandledVoucher';
      },
      argsObject: function(voucher_Id, voucher_Type, voucher_Description, voucher_Date, voucher_Message) {
        var f_args = {
          voucher: {
            Id: voucher_Id,
            Type: voucher_Type,
            Description: voucher_Description,
            Date: voucher_Date,
            Message: voucher_Message,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    ResendVoucher: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Fortnox/ResendVoucher';
      },
      argsObject: function(voucher_Id, voucher_Type, voucher_Description, voucher_Date, voucher_Message) {
        var f_args = {
          voucher: {
            Id: voucher_Id,
            Type: voucher_Type,
            Description: voucher_Description,
            Date: voucher_Date,
            Message: voucher_Message,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  BasketAddon : {
    GetCompanySettings: {
      url: function(addonId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/GetCompanySettings';
        }
        var f_args = this.argsObject(addonId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/GetCompanySettings' + '?' + $.param(f_args);
      },
      argsObject: function(addonId) {
        var f_args = {
          addonId: addonId,
        };
        return f_args;
      },
      kendoWindow: function(addonId, kendoWindowOptions) {
        var f_url = this.url(addonId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(addonId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetBranchSettings: {
      url: function(addonId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/GetBranchSettings';
        }
        var f_args = this.argsObject(addonId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/GetBranchSettings' + '?' + $.param(f_args);
      },
      argsObject: function(addonId) {
        var f_args = {
          addonId: addonId,
        };
        return f_args;
      },
      kendoWindow: function(addonId, kendoWindowOptions) {
        var f_url = this.url(addonId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(addonId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetBranchSettingsForGrid: {
      url: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, basketTypeId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/GetBranchSettingsForGrid';
        }
        var f_args = this.argsObject(Page, PageSize, Sorts, Filters, Groups, Aggregates, basketTypeId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/GetBranchSettingsForGrid' + '?' + $.param(f_args);
      },
      argsObject: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, basketTypeId) {
        var f_args = {
          Page: Page,
          PageSize: PageSize,
          Sorts: Sorts,
          Filters: Filters,
          Groups: Groups,
          Aggregates: Aggregates,
          basketTypeId: basketTypeId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    UpdateBranchSetting: {
      url: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, OldBranchId, BranchId, UserName, Password, DefaultShippingMethod, basketTypeId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/UpdateBranchSetting';
        }
        var f_args = this.argsObject(Page, PageSize, Sorts, Filters, Groups, Aggregates, OldBranchId, BranchId, UserName, Password, DefaultShippingMethod, basketTypeId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/UpdateBranchSetting' + '?' + $.param(f_args);
      },
      argsObject: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, OldBranchId, BranchId, UserName, Password, DefaultShippingMethod, basketTypeId) {
        var f_args = {
          Page: Page,
          PageSize: PageSize,
          Sorts: Sorts,
          Filters: Filters,
          Groups: Groups,
          Aggregates: Aggregates,
          OldBranchId: OldBranchId,
          BranchId: BranchId,
          UserName: UserName,
          Password: Password,
          DefaultShippingMethod: DefaultShippingMethod,
          basketTypeId: basketTypeId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    AddBranchSetting: {
      url: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, OldBranchId, BranchId, UserName, Password, DefaultShippingMethod, basketTypeId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/AddBranchSetting';
        }
        var f_args = this.argsObject(Page, PageSize, Sorts, Filters, Groups, Aggregates, OldBranchId, BranchId, UserName, Password, DefaultShippingMethod, basketTypeId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/AddBranchSetting' + '?' + $.param(f_args);
      },
      argsObject: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, OldBranchId, BranchId, UserName, Password, DefaultShippingMethod, basketTypeId) {
        var f_args = {
          Page: Page,
          PageSize: PageSize,
          Sorts: Sorts,
          Filters: Filters,
          Groups: Groups,
          Aggregates: Aggregates,
          OldBranchId: OldBranchId,
          BranchId: BranchId,
          UserName: UserName,
          Password: Password,
          DefaultShippingMethod: DefaultShippingMethod,
          basketTypeId: basketTypeId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    DeleteBranchSetting: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/DeleteBranchSetting';
      },
      argsObject: function(view_OldBranchId, view_BranchId, view_UserName, view_Password, view_DefaultShippingMethod, basketTypeId) {
        var f_args = {
          view: {
            OldBranchId: view_OldBranchId,
            BranchId: view_BranchId,
            UserName: view_UserName,
            Password: view_Password,
            DefaultShippingMethod: view_DefaultShippingMethod,
          },
          basketTypeId: basketTypeId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    SaveCompanySettings: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/SaveCompanySettings';
      },
      argsObject: function(view_GoodsArticleNo, view_FeeArticleNo, view_WorkArticleNo, view_SupplierId, view_SupplierName, view_SupplierNo, view_MatchingTable, view_AddDescription, view_Active, view_Surcharge, view_PriceFromExternalBasket, view_Addon, view_DepositArticleNo) {
        var f_args = {
          view: {
            GoodsArticleNo: view_GoodsArticleNo,
            FeeArticleNo: view_FeeArticleNo,
            WorkArticleNo: view_WorkArticleNo,
            SupplierId: view_SupplierId,
            SupplierName: view_SupplierName,
            SupplierNo: view_SupplierNo,
            MatchingTable: view_MatchingTable,
            AddDescription: view_AddDescription,
            Active: view_Active,
            Surcharge: view_Surcharge,
            PriceFromExternalBasket: view_PriceFromExternalBasket,
            Addon: view_Addon,
            DepositArticleNo: view_DepositArticleNo,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    SearchArticleAutoSuggest: {
      url: function(searchText) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/SearchArticleAutoSuggest';
        }
        var f_args = this.argsObject(searchText);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/SearchArticleAutoSuggest' + '?' + $.param(f_args);
      },
      argsObject: function(searchText) {
        var f_args = {
          searchText: searchText,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    SearchSupplierAutoSuggest: {
      url: function(searchText) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/SearchSupplierAutoSuggest';
        }
        var f_args = this.argsObject(searchText);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/SearchSupplierAutoSuggest' + '?' + $.param(f_args);
      },
      argsObject: function(searchText) {
        var f_args = {
          searchText: searchText,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    Deactivate: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/Deactivate';
      },
      argsObject: function(addonId) {
        var f_args = {
          addonId: addonId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    BasketCommodityGroupSettings: {
      url: function(addonId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/BasketCommodityGroupSettings';
        }
        var f_args = this.argsObject(addonId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/BasketCommodityGroupSettings' + '?' + $.param(f_args);
      },
      argsObject: function(addonId) {
        var f_args = {
          addonId: addonId,
        };
        return f_args;
      },
      kendoWindow: function(addonId, kendoWindowOptions) {
        var f_url = this.url(addonId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(addonId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetCommodityGroupSettings: {
      url: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, addon) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/GetCommodityGroupSettings';
        }
        var f_args = this.argsObject(Page, PageSize, Sorts, Filters, Groups, Aggregates, addon);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/GetCommodityGroupSettings' + '?' + $.param(f_args);
      },
      argsObject: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, addon) {
        var f_args = {
          Page: Page,
          PageSize: PageSize,
          Sorts: Sorts,
          Filters: Filters,
          Groups: Groups,
          Aggregates: Aggregates,
          addon: addon,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    UpdateMECACommodityGroupSetting: {
      url: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/UpdateMECACommodityGroupSetting';
        }
        var f_args = this.argsObject(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/UpdateMECACommodityGroupSetting' + '?' + $.param(f_args);
      },
      argsObject: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc) {
        var f_args = {
          Page: Page,
          PageSize: PageSize,
          Sorts: Sorts,
          Filters: Filters,
          Groups: Groups,
          Aggregates: Aggregates,
          CommodityGroup: CommodityGroup,
          ArticleNo: ArticleNo,
          ArticleDesc: ArticleDesc,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    AddFTZCommodityGroupSetting: {
      url: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, CompositId, CommodityGroup, CommodityGroup2, ArticleNo, ArticleDesc) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/AddFTZCommodityGroupSetting';
        }
        var f_args = this.argsObject(Page, PageSize, Sorts, Filters, Groups, Aggregates, CompositId, CommodityGroup, CommodityGroup2, ArticleNo, ArticleDesc);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/AddFTZCommodityGroupSetting' + '?' + $.param(f_args);
      },
      argsObject: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, CompositId, CommodityGroup, CommodityGroup2, ArticleNo, ArticleDesc) {
        var f_args = {
          Page: Page,
          PageSize: PageSize,
          Sorts: Sorts,
          Filters: Filters,
          Groups: Groups,
          Aggregates: Aggregates,
          CompositId: CompositId,
          CommodityGroup: CommodityGroup,
          CommodityGroup2: CommodityGroup2,
          ArticleNo: ArticleNo,
          ArticleDesc: ArticleDesc,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    AddOrumCommodityGroupSetting: {
      url: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/AddOrumCommodityGroupSetting';
        }
        var f_args = this.argsObject(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/AddOrumCommodityGroupSetting' + '?' + $.param(f_args);
      },
      argsObject: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc) {
        var f_args = {
          Page: Page,
          PageSize: PageSize,
          Sorts: Sorts,
          Filters: Filters,
          Groups: Groups,
          Aggregates: Aggregates,
          CommodityGroup: CommodityGroup,
          ArticleNo: ArticleNo,
          ArticleDesc: ArticleDesc,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    AddMECACommodityGroupSetting: {
      url: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/AddMECACommodityGroupSetting';
        }
        var f_args = this.argsObject(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/AddMECACommodityGroupSetting' + '?' + $.param(f_args);
      },
      argsObject: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc) {
        var f_args = {
          Page: Page,
          PageSize: PageSize,
          Sorts: Sorts,
          Filters: Filters,
          Groups: Groups,
          Aggregates: Aggregates,
          CommodityGroup: CommodityGroup,
          ArticleNo: ArticleNo,
          ArticleDesc: ArticleDesc,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    AddCommodityGroupSetting: {
      url: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc, addon) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/AddCommodityGroupSetting';
        }
        var f_args = this.argsObject(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc, addon);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/AddCommodityGroupSetting' + '?' + $.param(f_args);
      },
      argsObject: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc, addon) {
        var f_args = {
          Page: Page,
          PageSize: PageSize,
          Sorts: Sorts,
          Filters: Filters,
          Groups: Groups,
          Aggregates: Aggregates,
          CommodityGroup: CommodityGroup,
          ArticleNo: ArticleNo,
          ArticleDesc: ArticleDesc,
          addon: addon,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    DeleteMECACommodityGroupSetting: {
      url: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/DeleteMECACommodityGroupSetting';
        }
        var f_args = this.argsObject(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/DeleteMECACommodityGroupSetting' + '?' + $.param(f_args);
      },
      argsObject: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc) {
        var f_args = {
          Page: Page,
          PageSize: PageSize,
          Sorts: Sorts,
          Filters: Filters,
          Groups: Groups,
          Aggregates: Aggregates,
          CommodityGroup: CommodityGroup,
          ArticleNo: ArticleNo,
          ArticleDesc: ArticleDesc,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    DeleteOrumCommodityGroupSetting: {
      url: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/DeleteOrumCommodityGroupSetting';
        }
        var f_args = this.argsObject(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/DeleteOrumCommodityGroupSetting' + '?' + $.param(f_args);
      },
      argsObject: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc) {
        var f_args = {
          Page: Page,
          PageSize: PageSize,
          Sorts: Sorts,
          Filters: Filters,
          Groups: Groups,
          Aggregates: Aggregates,
          CommodityGroup: CommodityGroup,
          ArticleNo: ArticleNo,
          ArticleDesc: ArticleDesc,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    DeleteFTZCommodityGroupSetting: {
      url: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, CompositId, CommodityGroup, CommodityGroup2, ArticleNo, ArticleDesc) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/DeleteFTZCommodityGroupSetting';
        }
        var f_args = this.argsObject(Page, PageSize, Sorts, Filters, Groups, Aggregates, CompositId, CommodityGroup, CommodityGroup2, ArticleNo, ArticleDesc);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/DeleteFTZCommodityGroupSetting' + '?' + $.param(f_args);
      },
      argsObject: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, CompositId, CommodityGroup, CommodityGroup2, ArticleNo, ArticleDesc) {
        var f_args = {
          Page: Page,
          PageSize: PageSize,
          Sorts: Sorts,
          Filters: Filters,
          Groups: Groups,
          Aggregates: Aggregates,
          CompositId: CompositId,
          CommodityGroup: CommodityGroup,
          CommodityGroup2: CommodityGroup2,
          ArticleNo: ArticleNo,
          ArticleDesc: ArticleDesc,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    DeleteCommodityGroupSetting: {
      url: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc, addon) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/DeleteCommodityGroupSetting';
        }
        var f_args = this.argsObject(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc, addon);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/DeleteCommodityGroupSetting' + '?' + $.param(f_args);
      },
      argsObject: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, CommodityGroup, ArticleNo, ArticleDesc, addon) {
        var f_args = {
          Page: Page,
          PageSize: PageSize,
          Sorts: Sorts,
          Filters: Filters,
          Groups: Groups,
          Aggregates: Aggregates,
          CommodityGroup: CommodityGroup,
          ArticleNo: ArticleNo,
          ArticleDesc: ArticleDesc,
          addon: addon,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    SearchArticleCommodityGroupSettings: {
      url: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, searchText) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/SearchArticleCommodityGroupSettings';
        }
        var f_args = this.argsObject(Page, PageSize, Sorts, Filters, Groups, Aggregates, searchText);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/SearchArticleCommodityGroupSettings' + '?' + $.param(f_args);
      },
      argsObject: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, searchText) {
        var f_args = {
          Page: Page,
          PageSize: PageSize,
          Sorts: Sorts,
          Filters: Filters,
          Groups: Groups,
          Aggregates: Aggregates,
          searchText: searchText,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetLocalizedTemplate: {
      url: function(templateId, cultureId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/GetLocalizedTemplate';
        }
        var f_args = this.argsObject(templateId, cultureId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/BasketAddon/GetLocalizedTemplate' + '?' + $.param(f_args);
      },
      argsObject: function(templateId, cultureId) {
        var f_args = {
          templateId: templateId,
          cultureId: cultureId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  Navision : {
    Index: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Navision/Index';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    Import: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Navision/Import';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
    ExportCustomer: {
      url: function(exportType) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Navision/ExportCustomer';
        }
        var f_args = this.argsObject(exportType);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Navision/ExportCustomer' + '?' + $.param(f_args);
      },
      argsObject: function(exportType) {
        var f_args = {
          exportType: exportType,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  NtcAddon : {
    Index: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/NtcAddon/Index';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    CreateAccount: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/NtcAddon/CreateAccount';
      },
      argsObject: function(account_NtcUsername, account_NtcPassword, account_UserId, account_AuthenticationKey, account_Username, account_DisplayName, account_Groups, account_IsNew) {
        var f_args = {
          account: {
            NtcUsername: account_NtcUsername,
            NtcPassword: account_NtcPassword,
            UserId: account_UserId,
            AuthenticationKey: account_AuthenticationKey,
            Username: account_Username,
            DisplayName: account_DisplayName,
            Groups: account_Groups,
            IsNew: account_IsNew,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    NewAccount: {
      url: function(userId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/NtcAddon/NewAccount';
        }
        var f_args = this.argsObject(userId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/NtcAddon/NewAccount' + '?' + $.param(f_args);
      },
      argsObject: function(userId) {
        var f_args = {
          userId: userId,
        };
        return f_args;
      },
      kendoWindow: function(userId, kendoWindowOptions) {
        var f_url = this.url(userId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(userId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    Deactivate: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/NtcAddon/Deactivate';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json');
      },
    },
  },
  PrinterSettings : {
    SelectPrinters: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/PrinterSettings/SelectPrinters';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SetPrinter: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/PrinterSettings/SetPrinter';
      },
      argsObject: function(printerSelection_PaperFormatId, printerSelection_SelectedPrinter, printerSelection_DefaultTray, printerSelection_SecondaryTray) {
        var f_args = {
          printerSelection: {
            PaperFormatId: printerSelection_PaperFormatId,
            SelectedPrinter: printerSelection_SelectedPrinter,
            DefaultTray: printerSelection_DefaultTray,
            SecondaryTray: printerSelection_SecondaryTray,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    SetPrinters: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/PrinterSettings/SetPrinters';
      },
      argsObject: function(printerSelection) {
        var f_args = {
          printerSelection: printerSelection,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  Sage : {
    Index: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Sage/Index';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SageSettings: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Sage/SageSettings';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SaveSageSettings: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Sage/SaveSageSettings';
      },
      argsObject: function(noCustomerAccount, defaultPricelistId, vatCodes) {
        var f_args = {
          noCustomerAccount: noCustomerAccount,
          defaultPricelistId: defaultPricelistId,
          vatCodes: vatCodes,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    ActivateAddon: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Sage/ActivateAddon';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
    DeactivateAddon: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Sage/DeactivateAddon';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
    QueueExportSupplier: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Sage/QueueExportSupplier';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
    QueueExportCustomer: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Sage/QueueExportCustomer';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
    QueueExportStockTransactions: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Sage/QueueExportStockTransactions';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
    QueueExportStockItems: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Sage/QueueExportStockItems';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
    QueueExportAuditTrails: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Sage/QueueExportAuditTrails';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
  },
  Stock : {
    BranchStockSettings: {
      url: function(id) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Stock/BranchStockSettings';
        }
        var f_args = this.argsObject(id);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Stock/BranchStockSettings' + '?' + $.param(f_args);
      },
      argsObject: function(id) {
        var f_args = {
          id: id,
        };
        return f_args;
      },
      browserWindow: function(id) {
        var f_url = this.url(id);
        var f_args = [id];
        var f_winId = f_args.join('_')
        var f_windowName = undefined;
        if(f_winId.replace(/_/g, '') != '') {
          f_windowName = 'BranchStockSettings_' + f_args.join('_');
        }
        compilator.windowHandler.openWindowWithFocus(f_url, f_windowName, arguments.length > 0);
      },
    },
    DeleteTradingStockForSettings: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Stock/DeleteTradingStockForSettings';
      },
      argsObject: function(tradingStock_IsActive, tradingStock_Responsible, tradingStock_CreatedBy, tradingStock_Created, tradingStock_Id, tradingStock_StockNumber, tradingStock_Name, tradingStock_IsDefault, tradingStock_Type, branchId) {
        var f_args = {
          tradingStock: {
            IsActive: tradingStock_IsActive,
            Responsible: tradingStock_Responsible,
            CreatedBy: tradingStock_CreatedBy,
            Created: tradingStock_Created,
            Id: tradingStock_Id,
            StockNumber: tradingStock_StockNumber,
            Name: tradingStock_Name,
            IsDefault: tradingStock_IsDefault,
            Type: tradingStock_Type,
          },
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  VippsAddon : {
    DeactivateVipps: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/VippsAddon/DeactivateVipps';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json');
      },
    },
  },
  XeroAddon : {
    IsConnectedToXero: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/XeroAddon/IsConnectedToXero';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
    Connect: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/XeroAddon/Connect';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  Role : {
    Details: {
      url: function(roleId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Role/Details';
        }
        var f_args = this.argsObject(roleId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Role/Details' + '?' + $.param(f_args);
      },
      argsObject: function(roleId) {
        var f_args = {
          roleId: roleId,
        };
        return f_args;
      },
      kendoWindow: function(roleId, kendoWindowOptions) {
        var f_url = this.url(roleId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(roleId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetRoleSecuritySettings: {
      url: function(roleId, isRoleSettingsPage, createUserRoleOnChange) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Role/GetRoleSecuritySettings';
        }
        var f_args = this.argsObject(roleId, isRoleSettingsPage, createUserRoleOnChange);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Role/GetRoleSecuritySettings' + '?' + $.param(f_args);
      },
      argsObject: function(roleId, isRoleSettingsPage, createUserRoleOnChange) {
        var f_args = {
          roleId: roleId,
          isRoleSettingsPage: isRoleSettingsPage,
          createUserRoleOnChange: createUserRoleOnChange,
        };
        return f_args;
      },
      kendoWindow: function(roleId, isRoleSettingsPage, createUserRoleOnChange, kendoWindowOptions) {
        var f_url = this.url(roleId, isRoleSettingsPage, createUserRoleOnChange);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(roleId,isRoleSettingsPage,createUserRoleOnChange, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    RoleUsers: {
      url: function(roleId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Role/RoleUsers';
        }
        var f_args = this.argsObject(roleId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Role/RoleUsers' + '?' + $.param(f_args);
      },
      argsObject: function(roleId) {
        var f_args = {
          roleId: roleId,
        };
        return f_args;
      },
      kendoWindow: function(roleId, kendoWindowOptions) {
        var f_url = this.url(roleId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(roleId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  User : {
    Post: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/User/Post';
      },
      argsObject: function(user_Id, user_Username, user_DisplayName, user_LastLogin, user_Created, user_CreatedBy, user_Changed, user_ChangedBy, user_Language, user_BranchId, user_Department, user_StartPage, user_AutoLogin, user_Phone, user_MobilePhone, user_Email, user_RoleId, user_IsActive, user_Image, user_ImageStr, user_UploadImageFilename, user_AutoDeactivatePeriod, user_RoleSettings, user_Password, user_PasswordConfirmation, user_ToggleActiveStatus, user_UnlockUser, user_IsLockedOut, user_Enabled, user_BranchAccesses, user_CurrentUserEditing, user_PasswordExpirationDate, user_AllowBackofficeLogin, user_UserAliases, user_TacdisUserId) {
        var f_args = {
          user: {
            Id: user_Id,
            Username: user_Username,
            DisplayName: user_DisplayName,
            LastLogin: user_LastLogin,
            Created: user_Created,
            CreatedBy: user_CreatedBy,
            Changed: user_Changed,
            ChangedBy: user_ChangedBy,
            Language: user_Language,
            BranchId: user_BranchId,
            Department: user_Department,
            StartPage: user_StartPage,
            AutoLogin: user_AutoLogin,
            Phone: user_Phone,
            MobilePhone: user_MobilePhone,
            Email: user_Email,
            RoleId: user_RoleId,
            IsActive: user_IsActive,
            Image: user_Image,
            ImageStr: user_ImageStr,
            UploadImageFilename: user_UploadImageFilename,
            AutoDeactivatePeriod: user_AutoDeactivatePeriod,
            RoleSettings: user_RoleSettings,
            Password: user_Password,
            PasswordConfirmation: user_PasswordConfirmation,
            ToggleActiveStatus: user_ToggleActiveStatus,
            UnlockUser: user_UnlockUser,
            IsLockedOut: user_IsLockedOut,
            Enabled: user_Enabled,
            BranchAccesses: user_BranchAccesses,
            CurrentUserEditing: user_CurrentUserEditing,
            PasswordExpirationDate: user_PasswordExpirationDate,
            AllowBackofficeLogin: user_AllowBackofficeLogin,
            UserAliases: user_UserAliases,
            TacdisUserId: user_TacdisUserId,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    Details: {
      url: function(id) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/User/Details';
        }
        var f_args = this.argsObject(id);
        return $menu.getRootUrl() + '/SystemSettingsMVC/User/Details' + '?' + $.param(f_args);
      },
      argsObject: function(id) {
        var f_args = {
          id: id,
        };
        return f_args;
      },
      browserWindow: function(id) {
        var f_url = this.url(id);
        var f_args = [id];
        var f_winId = f_args.join('_')
        var f_windowName = undefined;
        if(f_winId.replace(/_/g, '') != '') {
          f_windowName = 'Details_' + f_args.join('_');
        }
        compilator.windowHandler.openWindowWithFocus(f_url, f_windowName, arguments.length > 0);
      },
    },
    GetUserLicenseUtilization: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/User/GetUserLicenseUtilization';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
    IsUsernameAvailable: {
      url: function(username) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/User/IsUsernameAvailable';
        }
        var f_args = this.argsObject(username);
        return $menu.getRootUrl() + '/SystemSettingsMVC/User/IsUsernameAvailable' + '?' + $.param(f_args);
      },
      argsObject: function(username) {
        var f_args = {
          username: username,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    SaveFile: {
      url: function(files) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/User/SaveFile';
        }
        var f_args = this.argsObject(files);
        return $menu.getRootUrl() + '/SystemSettingsMVC/User/SaveFile' + '?' + $.param(f_args);
      },
      argsObject: function(files) {
        var f_args = {
          files: files,
        };
        return f_args;
      },
      kendoWindow: function(files, kendoWindowOptions) {
        var f_url = this.url(files);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(files, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    RemoveFile: {
      url: function(fileNames) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/User/RemoveFile';
        }
        var f_args = this.argsObject(fileNames);
        return $menu.getRootUrl() + '/SystemSettingsMVC/User/RemoveFile' + '?' + $.param(f_args);
      },
      argsObject: function(fileNames) {
        var f_args = {
          fileNames: fileNames,
        };
        return f_args;
      },
      kendoWindow: function(fileNames, kendoWindowOptions) {
        var f_url = this.url(fileNames);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(fileNames, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    DisableUsersWindow: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/User/DisableUsersWindow';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    DisableUsers: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/User/DisableUsers';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
  },
  TradingStock : {
    AddStockCleanup: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/TradingStock/AddStockCleanup';
      },
      argsObject: function(scheduledDateTime) {
        var f_args = {
          scheduledDateTime: scheduledDateTime,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, undefined, ajaxData);
      },
    },
    CancelStockCleanup: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/TradingStock/CancelStockCleanup';
      },
      argsObject: function(id) {
        var f_args = {
          id: id,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, undefined, ajaxData);
      },
    },
    ConfirmStockTransactionResetAndCleanup: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/TradingStock/ConfirmStockTransactionResetAndCleanup';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    ClearOldOpenOrdersDialog: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/TradingStock/ClearOldOpenOrdersDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  AddOn : {
    GetLocalizedTemplate: {
      url: function(templateId, cultureId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/AddOn/GetLocalizedTemplate';
        }
        var f_args = this.argsObject(templateId, cultureId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/AddOn/GetLocalizedTemplate' + '?' + $.param(f_args);
      },
      argsObject: function(templateId, cultureId) {
        var f_args = {
          templateId: templateId,
          cultureId: cultureId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  EmailAddon : {
    Index: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/EmailAddon/Index';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    DeactivateEmail: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/EmailAddon/DeactivateEmail';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json');
      },
    },
    PreviewTemplate: {
      url: function(templateName) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/EmailAddon/PreviewTemplate';
        }
        var f_args = this.argsObject(templateName);
        return $menu.getRootUrl() + '/SystemSettingsMVC/EmailAddon/PreviewTemplate' + '?' + $.param(f_args);
      },
      argsObject: function(templateName) {
        var f_args = {
          templateName: templateName,
        };
        return f_args;
      },
      kendoWindow: function(templateName, kendoWindowOptions) {
        var f_url = this.url(templateName);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(templateName, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    EmailTemplate: {
      url: function(id) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/EmailAddon/EmailTemplate';
        }
        var f_args = this.argsObject(id);
        return $menu.getRootUrl() + '/SystemSettingsMVC/EmailAddon/EmailTemplate' + '?' + $.param(f_args);
      },
      argsObject: function(id) {
        var f_args = {
          id: id,
        };
        return f_args;
      },
      kendoWindow: function(id, kendoWindowOptions) {
        var f_url = this.url(id);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(id, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SaveFile: {
      url: function(files, templateTypeId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/EmailAddon/SaveFile';
        }
        var f_args = this.argsObject(files, templateTypeId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/EmailAddon/SaveFile' + '?' + $.param(f_args);
      },
      argsObject: function(files, templateTypeId) {
        var f_args = {
          files: files,
          templateTypeId: templateTypeId,
        };
        return f_args;
      },
      kendoWindow: function(files, templateTypeId, kendoWindowOptions) {
        var f_url = this.url(files, templateTypeId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(files,templateTypeId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    RemoveFile: {
      url: function(fileNames) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/EmailAddon/RemoveFile';
        }
        var f_args = this.argsObject(fileNames);
        return $menu.getRootUrl() + '/SystemSettingsMVC/EmailAddon/RemoveFile' + '?' + $.param(f_args);
      },
      argsObject: function(fileNames) {
        var f_args = {
          fileNames: fileNames,
        };
        return f_args;
      },
      kendoWindow: function(fileNames, kendoWindowOptions) {
        var f_url = this.url(fileNames);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(fileNames, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    Submit: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/EmailAddon/Submit';
      },
      argsObject: function(id, fileName, name, culture, templateType, subject) {
        var f_args = {
          id: id,
          fileName: fileName,
          name: name,
          culture: culture,
          templateType: templateType,
          subject: subject,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    GetTemplates: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/EmailAddon/GetTemplates';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
    DeleteTemplate: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/EmailAddon/DeleteTemplate';
      },
      argsObject: function(id) {
        var f_args = {
          id: id,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    GetLocalizedTemplate: {
      url: function(templateId, cultureId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/EmailAddon/GetLocalizedTemplate';
        }
        var f_args = this.argsObject(templateId, cultureId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/EmailAddon/GetLocalizedTemplate' + '?' + $.param(f_args);
      },
      argsObject: function(templateId, cultureId) {
        var f_args = {
          templateId: templateId,
          cultureId: cultureId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  Order : {
    BranchOrderSettings: {
      url: function(id) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Order/BranchOrderSettings';
        }
        var f_args = this.argsObject(id);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Order/BranchOrderSettings' + '?' + $.param(f_args);
      },
      argsObject: function(id) {
        var f_args = {
          id: id,
        };
        return f_args;
      },
      browserWindow: function(id) {
        var f_url = this.url(id);
        var f_args = [id];
        var f_winId = f_args.join('_')
        var f_windowName = undefined;
        if(f_winId.replace(/_/g, '') != '') {
          f_windowName = 'BranchOrderSettings_' + f_args.join('_');
        }
        compilator.windowHandler.openWindowWithFocus(f_url, f_windowName, arguments.length > 0);
      },
    },
    GetOrderBranchSettingAsString: {
      url: function(branchId, settingsKey) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Order/GetOrderBranchSettingAsString';
        }
        var f_args = this.argsObject(branchId, settingsKey);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Order/GetOrderBranchSettingAsString' + '?' + $.param(f_args);
      },
      argsObject: function(branchId, settingsKey) {
        var f_args = {
          branchId: branchId,
          settingsKey: settingsKey,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    CompanyOrderSettings: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Order/CompanyOrderSettings';
      },
      browserWindow: function() {
        var f_url = this.url();
        var f_args = [];
        var f_winId = f_args.join('_')
        var f_windowName = undefined;
        if(f_winId.replace(/_/g, '') != '') {
          f_windowName = 'CompanyOrderSettings_' + f_args.join('_');
        }
        compilator.windowHandler.openWindowWithFocus(f_url, f_windowName, arguments.length > 0);
      },
    },
    UpdateBranchOrderSettings: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Order/UpdateBranchOrderSettings';
      },
      argsObject: function(model_BranchId, model_BranchName, model_DefaultMargin, model_DefaultArticlePackage, model_DefaultRecycleFee, model_DefaultPrintWorkorder, model_WarningForNegativePricesInDeliveryNotes, model_DoNotAllowSalesForNegativePricesInDeliveryNotes, model_WholeSaleEmailAddress, model_ChangeArticleDescription, model_ShowReservationAgreedDoneTime, model_ShowCurrency, model_ShowDeliveryDate, model_ShowExpiryDate, model_ShowInvoiceFee, model_ShowDownPayment, model_RequireCustomerNumber, model_RequireDeliveryAddress, model_RequireLicensePlate, model_RequireOdometer, model_RequireWorkOrderNumber, model_RequireYourReference, model_RequireRequisitionOrderNumber, model_AllowChangeWebOrders, model_SearchMarginCalculationFIFO, model_SaveMarginCalculationFIFO, model_AllowSalesOnArticleNotInStock, model_StartNewOrderAfterFinalize, model_AllowCashbackSwish, model_AllowCashbackVipps, model_AllowCashbackCreditcard, model_NewLineOnEnterField, model_CustomerSearchOnLicensePlate, model_InitialFocusOnNewOrder, model_DefaultSearchArticlesStockQuantity, model_ShowPriceOnDeliveryNote, model_DefaultReceiptPrintMode, model_Vat_Default_Set, model_SearchArticles_VAT_Default_Person, model_SearchArticles_VAT_Default_Company, model_SearchArticles_Use_All_Branches_StockBalance, model_ShowRowPricesIncludingVAT_Default_Company, model_ShowRowPricesIncludingVAT_Default_Person, model_ShowCheckBoxForPricesIncludingVAT, model_SearchCustomer_Default_Country, model_SearchCustomer_InitialCursorPosition, model_ShowDebitModelLineQuestionOnStorageCardDebit, model_AllowToCreateInvoiceAtPayment, model_PrintWaybillAtPaymentInvoiceOption, model_PrintInvoiceAtPaymentInvoiceOption, model_ImageUrlInvoiceEmail, model_DefaultPaymentTypeCustomer, model_DefaultPaymentType, model_FleetInfoCopyToField, model_DefaultSaveOrderType, model_ConnectToStorageCard, model_UseGenericButton, model_OnlyConnectReservations) {
        var f_args = {
          model: {
            BranchId: model_BranchId,
            BranchName: model_BranchName,
            DefaultMargin: model_DefaultMargin,
            DefaultArticlePackage: model_DefaultArticlePackage,
            DefaultRecycleFee: model_DefaultRecycleFee,
            DefaultPrintWorkorder: model_DefaultPrintWorkorder,
            WarningForNegativePricesInDeliveryNotes: model_WarningForNegativePricesInDeliveryNotes,
            DoNotAllowSalesForNegativePricesInDeliveryNotes: model_DoNotAllowSalesForNegativePricesInDeliveryNotes,
            WholeSaleEmailAddress: model_WholeSaleEmailAddress,
            ChangeArticleDescription: model_ChangeArticleDescription,
            ShowReservationAgreedDoneTime: model_ShowReservationAgreedDoneTime,
            ShowCurrency: model_ShowCurrency,
            ShowDeliveryDate: model_ShowDeliveryDate,
            ShowExpiryDate: model_ShowExpiryDate,
            ShowInvoiceFee: model_ShowInvoiceFee,
            ShowDownPayment: model_ShowDownPayment,
            RequireCustomerNumber: model_RequireCustomerNumber,
            RequireDeliveryAddress: model_RequireDeliveryAddress,
            RequireLicensePlate: model_RequireLicensePlate,
            RequireOdometer: model_RequireOdometer,
            RequireWorkOrderNumber: model_RequireWorkOrderNumber,
            RequireYourReference: model_RequireYourReference,
            RequireRequisitionOrderNumber: model_RequireRequisitionOrderNumber,
            AllowChangeWebOrders: model_AllowChangeWebOrders,
            SearchMarginCalculationFIFO: model_SearchMarginCalculationFIFO,
            SaveMarginCalculationFIFO: model_SaveMarginCalculationFIFO,
            AllowSalesOnArticleNotInStock: model_AllowSalesOnArticleNotInStock,
            StartNewOrderAfterFinalize: model_StartNewOrderAfterFinalize,
            AllowCashbackSwish: model_AllowCashbackSwish,
            AllowCashbackVipps: model_AllowCashbackVipps,
            AllowCashbackCreditcard: model_AllowCashbackCreditcard,
            NewLineOnEnterField: model_NewLineOnEnterField,
            CustomerSearchOnLicensePlate: model_CustomerSearchOnLicensePlate,
            InitialFocusOnNewOrder: model_InitialFocusOnNewOrder,
            DefaultSearchArticlesStockQuantity: model_DefaultSearchArticlesStockQuantity,
            ShowPriceOnDeliveryNote: model_ShowPriceOnDeliveryNote,
            DefaultReceiptPrintMode: model_DefaultReceiptPrintMode,
            Vat_Default_Set: model_Vat_Default_Set,
            SearchArticles_VAT_Default_Person: model_SearchArticles_VAT_Default_Person,
            SearchArticles_VAT_Default_Company: model_SearchArticles_VAT_Default_Company,
            SearchArticles_Use_All_Branches_StockBalance: model_SearchArticles_Use_All_Branches_StockBalance,
            ShowRowPricesIncludingVAT_Default_Company: model_ShowRowPricesIncludingVAT_Default_Company,
            ShowRowPricesIncludingVAT_Default_Person: model_ShowRowPricesIncludingVAT_Default_Person,
            ShowCheckBoxForPricesIncludingVAT: model_ShowCheckBoxForPricesIncludingVAT,
            SearchCustomer_Default_Country: model_SearchCustomer_Default_Country,
            SearchCustomer_InitialCursorPosition: model_SearchCustomer_InitialCursorPosition,
            ShowDebitModelLineQuestionOnStorageCardDebit: model_ShowDebitModelLineQuestionOnStorageCardDebit,
            AllowToCreateInvoiceAtPayment: model_AllowToCreateInvoiceAtPayment,
            PrintWaybillAtPaymentInvoiceOption: model_PrintWaybillAtPaymentInvoiceOption,
            PrintInvoiceAtPaymentInvoiceOption: model_PrintInvoiceAtPaymentInvoiceOption,
            ImageUrlInvoiceEmail: model_ImageUrlInvoiceEmail,
            DefaultPaymentTypeCustomer: model_DefaultPaymentTypeCustomer,
            DefaultPaymentType: model_DefaultPaymentType,
            FleetInfoCopyToField: model_FleetInfoCopyToField,
            DefaultSaveOrderType: model_DefaultSaveOrderType,
            ConnectToStorageCard: model_ConnectToStorageCard,
            UseGenericButton: model_UseGenericButton,
            OnlyConnectReservations: model_OnlyConnectReservations,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    GetAddPointOfSaleView: {
      url: function(branchId, posId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Order/GetAddPointOfSaleView';
        }
        var f_args = this.argsObject(branchId, posId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Order/GetAddPointOfSaleView' + '?' + $.param(f_args);
      },
      argsObject: function(branchId, posId) {
        var f_args = {
          branchId: branchId,
          posId: posId,
        };
        return f_args;
      },
      kendoWindow: function(branchId, posId, kendoWindowOptions) {
        var f_url = this.url(branchId, posId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(branchId,posId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetOrderGenericButtonLinks: {
      url: function(branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Order/GetOrderGenericButtonLinks';
        }
        var f_args = this.argsObject(branchId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Order/GetOrderGenericButtonLinks' + '?' + $.param(f_args);
      },
      argsObject: function(branchId) {
        var f_args = {
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetAddOrderGenericButtonLinkView: {
      url: function(branchId, orderGenericButtonLinkId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Order/GetAddOrderGenericButtonLinkView';
        }
        var f_args = this.argsObject(branchId, orderGenericButtonLinkId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Order/GetAddOrderGenericButtonLinkView' + '?' + $.param(f_args);
      },
      argsObject: function(branchId, orderGenericButtonLinkId) {
        var f_args = {
          branchId: branchId,
          orderGenericButtonLinkId: orderGenericButtonLinkId,
        };
        return f_args;
      },
      kendoWindow: function(branchId, orderGenericButtonLinkId, kendoWindowOptions) {
        var f_url = this.url(branchId, orderGenericButtonLinkId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(branchId,orderGenericButtonLinkId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    UpsertOrderGenericButtonLink: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Order/UpsertOrderGenericButtonLink';
      },
      argsObject: function(model_Id, model_BranchId, model_Priority, model_Name, model_URL, model_Type, model_Action) {
        var f_args = {
          model: {
            Id: model_Id,
            BranchId: model_BranchId,
            Priority: model_Priority,
            Name: model_Name,
            URL: model_URL,
            Type: model_Type,
            Action: model_Action,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    UpdateOrderGenericButtonLinkPriority: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Order/UpdateOrderGenericButtonLinkPriority';
      },
      argsObject: function(links) {
        var f_args = {
          links: links,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    DeleteOrderGenericButtonLink: {
      url: function(id) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Order/DeleteOrderGenericButtonLink';
        }
        var f_args = this.argsObject(id);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Order/DeleteOrderGenericButtonLink' + '?' + $.param(f_args);
      },
      argsObject: function(id) {
        var f_args = {
          id: id,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  SMSAddon : {
    Index: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/SMSAddon/Index';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetBranchSMSSenderSettings: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/SMSAddon/GetBranchSMSSenderSettings';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
    DeactivateSMS: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/SMSAddon/DeactivateSMS';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json');
      },
    },
    SaveLocalizedTemplate: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/SMSAddon/SaveLocalizedTemplate';
      },
      argsObject: function(template_Id, template_MessateTemplateId, template_TemplateContent, template_CultureId, template_CultureName, template_Default, template_SmsSender) {
        var f_args = {
          template: {
            Id: template_Id,
            MessateTemplateId: template_MessateTemplateId,
            TemplateContent: template_TemplateContent,
            CultureId: template_CultureId,
            CultureName: template_CultureName,
            Default: template_Default,
            SmsSender: template_SmsSender,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    GetLocalizedTemplate: {
      url: function(templateId, cultureId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/SMSAddon/GetLocalizedTemplate';
        }
        var f_args = this.argsObject(templateId, cultureId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/SMSAddon/GetLocalizedTemplate' + '?' + $.param(f_args);
      },
      argsObject: function(templateId, cultureId) {
        var f_args = {
          templateId: templateId,
          cultureId: cultureId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  Calendar : {
    Delete: {
      url: function(id) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/Delete';
        }
        var f_args = this.argsObject(id);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/Delete' + '?' + $.param(f_args);
      },
      argsObject: function(id) {
        var f_args = {
          id: id,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'DELETE', ajaxOptions, 'json', ajaxData);
      },
    },
    UpdateDetails: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/UpdateDetails';
      },
      argsObject: function(model_DontUseUrlShortening, model_EmailAddonActivated, model_SMSAddonActivated, model_Id, model_CalendarId, model_BranchId, model_IsNew, model_Name, model_TimeZone, model_Owner, model_ColorCode, model_Schedules, model_ScheduledEvents, model_ArticlePackages, model_FirstBookingDays, model_LatestCancellationDays, model_AllowBookingsBeforeToday, model_CloseWindow, model_SMSConfirmationTemplateId, model_SMSConfirmationTemplateName, model_SMSConfirmationTemplateDisplayName, model_SMSReminderTemplateId, model_SMSReminderTemplateName, model_SMSReminderTemplateDisplayName, model_SMSDefaultReminderTimeType, model_EmailConfirmationTemplateId, model_EmailConfirmationTemplateName, model_EmailConfirmationTemplateDisplayName, model_EmailReminderTemplateId, model_EmailReminderTemplateName, model_EmailReminderTemplateDisplayName, model_EmailDefaultReminderTimeType, model_SendConfirmationEmail, model_SendConfirmationSms, model_Email, model_Phone, model_CalendarProperties, model_BranchPublicTimebookPriorities, model_SMSMessageTemplates, model_SMSConfirmationTemplates, model_SMSConfirmationTemplateIds, model_SMSReminderTemplates, model_EmailMessageTemplates, model_EmailConfirmationTemplates, model_EmailReminderTemplates, model_BookingUrl, model_InfoToCustomer, model_MajorTick, model_MinorTick, model_CreatedBy, model_CreatedDateTime, model_ChangedBy, model_ChangedDateTime, model_Histories) {
        var f_args = {
          model: {
            DontUseUrlShortening: model_DontUseUrlShortening,
            EmailAddonActivated: model_EmailAddonActivated,
            SMSAddonActivated: model_SMSAddonActivated,
            Id: model_Id,
            CalendarId: model_CalendarId,
            BranchId: model_BranchId,
            IsNew: model_IsNew,
            Name: model_Name,
            TimeZone: model_TimeZone,
            Owner: model_Owner,
            ColorCode: model_ColorCode,
            Schedules: model_Schedules,
            ScheduledEvents: model_ScheduledEvents,
            ArticlePackages: model_ArticlePackages,
            FirstBookingDays: model_FirstBookingDays,
            LatestCancellationDays: model_LatestCancellationDays,
            AllowBookingsBeforeToday: model_AllowBookingsBeforeToday,
            CloseWindow: model_CloseWindow,
            SMSConfirmationTemplateId: model_SMSConfirmationTemplateId,
            SMSConfirmationTemplateName: model_SMSConfirmationTemplateName,
            SMSConfirmationTemplateDisplayName: model_SMSConfirmationTemplateDisplayName,
            SMSReminderTemplateId: model_SMSReminderTemplateId,
            SMSReminderTemplateName: model_SMSReminderTemplateName,
            SMSReminderTemplateDisplayName: model_SMSReminderTemplateDisplayName,
            SMSDefaultReminderTimeType: model_SMSDefaultReminderTimeType,
            EmailConfirmationTemplateId: model_EmailConfirmationTemplateId,
            EmailConfirmationTemplateName: model_EmailConfirmationTemplateName,
            EmailConfirmationTemplateDisplayName: model_EmailConfirmationTemplateDisplayName,
            EmailReminderTemplateId: model_EmailReminderTemplateId,
            EmailReminderTemplateName: model_EmailReminderTemplateName,
            EmailReminderTemplateDisplayName: model_EmailReminderTemplateDisplayName,
            EmailDefaultReminderTimeType: model_EmailDefaultReminderTimeType,
            SendConfirmationEmail: model_SendConfirmationEmail,
            SendConfirmationSms: model_SendConfirmationSms,
            Email: model_Email,
            Phone: model_Phone,
            CalendarProperties: model_CalendarProperties,
            BranchPublicTimebookPriorities: model_BranchPublicTimebookPriorities,
            SMSMessageTemplates: model_SMSMessageTemplates,
            SMSConfirmationTemplates: model_SMSConfirmationTemplates,
            SMSConfirmationTemplateIds: model_SMSConfirmationTemplateIds,
            SMSReminderTemplates: model_SMSReminderTemplates,
            EmailMessageTemplates: model_EmailMessageTemplates,
            EmailConfirmationTemplates: model_EmailConfirmationTemplates,
            EmailReminderTemplates: model_EmailReminderTemplates,
            BookingUrl: model_BookingUrl,
            InfoToCustomer: model_InfoToCustomer,
            MajorTick: model_MajorTick,
            MinorTick: model_MinorTick,
            CreatedBy: model_CreatedBy,
            CreatedDateTime: model_CreatedDateTime,
            ChangedBy: model_ChangedBy,
            ChangedDateTime: model_ChangedDateTime,
            Histories: model_Histories,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    Details: {
      url: function(id) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/Details';
        }
        var f_args = this.argsObject(id);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/Details' + '?' + $.param(f_args);
      },
      argsObject: function(id) {
        var f_args = {
          id: id,
        };
        return f_args;
      },
      browserWindow: function(id) {
        var f_url = this.url(id);
        var f_args = [id];
        var f_winId = f_args.join('_')
        var f_windowName = undefined;
        if(f_winId.replace(/_/g, '') != '') {
          f_windowName = 'Details_' + f_args.join('_');
        }
        compilator.windowHandler.openWindowWithFocus(f_url, f_windowName, arguments.length > 0);
      },
    },
    ScheduleDetails: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/ScheduleDetails';
      },
      argsObject: function(schedule_Id, schedule_ScheduleName, schedule_StartDate, schedule_EndDate, schedule_ExternalOccupancyRateFactor, schedule_ExternalOccupancyRate, schedule_Deleted, schedule_IsNew, schedule_DaySchedules, schedule_Further) {
        var f_args = {
          schedule: {
            Id: schedule_Id,
            ScheduleName: schedule_ScheduleName,
            StartDate: schedule_StartDate,
            EndDate: schedule_EndDate,
            ExternalOccupancyRateFactor: schedule_ExternalOccupancyRateFactor,
            ExternalOccupancyRate: schedule_ExternalOccupancyRate,
            Deleted: schedule_Deleted,
            IsNew: schedule_IsNew,
            DaySchedules: schedule_DaySchedules,
            Further: schedule_Further,
          },
        };
        return f_args;
      },
      kendoWindow: function(data, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow('', kendoWindowOptions);
        f_window.refresh({
          url: f_url,
          data: JSON.stringify(data),
          contentType: 'application/json',
          type: 'POST'
        });
        return f_window;
      },
    },
    ScheduledEventDetails: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/ScheduledEventDetails';
      },
      argsObject: function(scheduledEvent_Id, scheduledEvent_StartDate, scheduledEvent_EndDate, scheduledEvent_StartTime, scheduledEvent_EndTime, scheduledEvent_Monday, scheduledEvent_Tuesday, scheduledEvent_Wednesday, scheduledEvent_Thursday, scheduledEvent_Friday, scheduledEvent_Saturday, scheduledEvent_Sunday, scheduledEvent_RecurringEventType, scheduledEvent_Note, scheduledEvent_Active, scheduledEvent_Closed, scheduledEvent_Express, scheduledEvent_SurchargeExpress, scheduledEvent_ScheduledEventDefaultProperties, scheduledEvent_Deleted, scheduledEvent_IsNew, scheduledEvent_Further, scheduledEvent_StartTimeString, scheduledEvent_EndTimeString, scheduledEvent_RecurringInfo, scheduledEvent_AllDay) {
        var f_args = {
          scheduledEvent: {
            Id: scheduledEvent_Id,
            StartDate: scheduledEvent_StartDate,
            EndDate: scheduledEvent_EndDate,
            StartTime: scheduledEvent_StartTime,
            EndTime: scheduledEvent_EndTime,
            Monday: scheduledEvent_Monday,
            Tuesday: scheduledEvent_Tuesday,
            Wednesday: scheduledEvent_Wednesday,
            Thursday: scheduledEvent_Thursday,
            Friday: scheduledEvent_Friday,
            Saturday: scheduledEvent_Saturday,
            Sunday: scheduledEvent_Sunday,
            RecurringEventType: scheduledEvent_RecurringEventType,
            Note: scheduledEvent_Note,
            Active: scheduledEvent_Active,
            Closed: scheduledEvent_Closed,
            Express: scheduledEvent_Express,
            SurchargeExpress: scheduledEvent_SurchargeExpress,
            ScheduledEventDefaultProperties: scheduledEvent_ScheduledEventDefaultProperties,
            Deleted: scheduledEvent_Deleted,
            IsNew: scheduledEvent_IsNew,
            Further: scheduledEvent_Further,
            StartTimeString: scheduledEvent_StartTimeString,
            EndTimeString: scheduledEvent_EndTimeString,
            RecurringInfo: scheduledEvent_RecurringInfo,
            AllDay: scheduledEvent_AllDay,
          },
        };
        return f_args;
      },
      kendoWindow: function(data, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow('', kendoWindowOptions);
        f_window.refresh({
          url: f_url,
          data: JSON.stringify(data),
          contentType: 'application/json',
          type: 'POST'
        });
        return f_window;
      },
    },
    Share: {
      url: function(branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/Share';
        }
        var f_args = this.argsObject(branchId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/Share' + '?' + $.param(f_args);
      },
      argsObject: function(branchId) {
        var f_args = {
          branchId: branchId,
        };
        return f_args;
      },
      kendoWindow: function(branchId, kendoWindowOptions) {
        var f_url = this.url(branchId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(branchId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    Queues: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/Queues';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetQueues: {
      url: function(branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/GetQueues';
        }
        var f_args = this.argsObject(branchId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/GetQueues' + '?' + $.param(f_args);
      },
      argsObject: function(branchId) {
        var f_args = {
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetQueueSettings: {
      url: function(queueId, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/GetQueueSettings';
        }
        var f_args = this.argsObject(queueId, branchId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/GetQueueSettings' + '?' + $.param(f_args);
      },
      argsObject: function(queueId, branchId) {
        var f_args = {
          queueId: queueId,
          branchId: branchId,
        };
        return f_args;
      },
      kendoWindow: function(queueId, branchId, kendoWindowOptions) {
        var f_url = this.url(queueId, branchId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(queueId,branchId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SaveQueueSettings: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/SaveQueueSettings';
      },
      argsObject: function(model_BranchId, model_QueueId, model_LogoURL, model_QueueName, model_InfoText, model_EndingNote, model_CallInNote, model_QueueTabletUrl, model_WaitingLocations, model_QueuePointOfSales) {
        var f_args = {
          model: {
            BranchId: model_BranchId,
            QueueId: model_QueueId,
            LogoURL: model_LogoURL,
            QueueName: model_QueueName,
            InfoText: model_InfoText,
            EndingNote: model_EndingNote,
            CallInNote: model_CallInNote,
            QueueTabletUrl: model_QueueTabletUrl,
            WaitingLocations: model_WaitingLocations,
            QueuePointOfSales: model_QueuePointOfSales,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    SaveNewQueue: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/SaveNewQueue';
      },
      argsObject: function(model_Name, model_BranchId, model_QueueId, model_WaitingLocationName, model_BranchHasWaitingLocation) {
        var f_args = {
          model: {
            Name: model_Name,
            BranchId: model_BranchId,
            QueueId: model_QueueId,
            WaitingLocationName: model_WaitingLocationName,
            BranchHasWaitingLocation: model_BranchHasWaitingLocation,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    GetAddQueueView: {
      url: function(selectedBranch) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/GetAddQueueView';
        }
        var f_args = this.argsObject(selectedBranch);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/GetAddQueueView' + '?' + $.param(f_args);
      },
      argsObject: function(selectedBranch) {
        var f_args = {
          selectedBranch: selectedBranch,
        };
        return f_args;
      },
      kendoWindow: function(selectedBranch, kendoWindowOptions) {
        var f_url = this.url(selectedBranch);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(selectedBranch, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    BranchHasWaitingLocation: {
      url: function(branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/BranchHasWaitingLocation';
        }
        var f_args = this.argsObject(branchId);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/BranchHasWaitingLocation' + '?' + $.param(f_args);
      },
      argsObject: function(branchId) {
        var f_args = {
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    DeleteQueue: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/DeleteQueue';
      },
      argsObject: function(model_BranchId, model_QueueId, model_LogoURL, model_QueueName, model_InfoText, model_EndingNote, model_CallInNote, model_QueueTabletUrl, model_WaitingLocations, model_QueuePointOfSales) {
        var f_args = {
          model: {
            BranchId: model_BranchId,
            QueueId: model_QueueId,
            LogoURL: model_LogoURL,
            QueueName: model_QueueName,
            InfoText: model_InfoText,
            EndingNote: model_EndingNote,
            CallInNote: model_CallInNote,
            QueueTabletUrl: model_QueueTabletUrl,
            WaitingLocations: model_WaitingLocations,
            QueuePointOfSales: model_QueuePointOfSales,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    GetBigQrCodeView: {
      url: function(Url, Title) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/GetBigQrCodeView';
        }
        var f_args = this.argsObject(Url, Title);
        return $menu.getRootUrl() + '/SystemSettingsMVC/Calendar/GetBigQrCodeView' + '?' + $.param(f_args);
      },
      argsObject: function(Url, Title) {
        var f_args = {
          Url: Url,
          Title: Title,
        };
        return f_args;
      },
      browserWindow: function(Url, Title) {
        var f_url = this.url(Url, Title);
        var f_args = [];
        var f_winId = f_args.join('_')
        var f_windowName = undefined;
        if(f_winId.replace(/_/g, '') != '') {
          f_windowName = 'GetBigQrCodeView_' + f_args.join('_');
        }
        compilator.windowHandler.openWindowWithFocus(f_url, f_windowName, arguments.length > 0);
      },
    },
  },
  TyreHotel : {
    UpdateStockPlaceName: {
      url: function() {
        return $menu.getRootUrl() + '/SystemSettingsMVC/TyreHotel/UpdateStockPlaceName';
      },
      argsObject: function(stockPlaceName, stockPlaceId, stockId, sessionId) {
        var f_args = {
          stockPlaceName: stockPlaceName,
          stockPlaceId: stockPlaceId,
          stockId: stockId,
          sessionId: sessionId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
  },
};

compilator.url.StockMVC = {
  InternalTransfer : {
    Details: {
      url: function(id, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/StockMVC/InternalTransfer/Details';
        }
        var f_args = this.argsObject(id, branchId);
        return $menu.getRootUrl() + '/StockMVC/InternalTransfer/Details' + '?' + $.param(f_args);
      },
      argsObject: function(id, branchId) {
        var f_args = {
          id: id,
          branchId: branchId,
        };
        return f_args;
      },
      browserWindow: function(id, branchId) {
        var f_url = this.url(id, branchId);
        var f_args = [id, branchId];
        var f_winId = f_args.join('_')
        var f_windowName = undefined;
        if(f_winId.replace(/_/g, '') != '') {
          f_windowName = 'Details_' + f_args.join('_');
        }
        compilator.windowHandler.openWindowWithFocus(f_url, f_windowName, arguments.length > 0);
      },
    },
    PrintInternalIndeliveryReport: {
      url: function(id, senderBranchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/StockMVC/InternalTransfer/PrintInternalIndeliveryReport';
        }
        var f_args = this.argsObject(id, senderBranchId);
        return $menu.getRootUrl() + '/StockMVC/InternalTransfer/PrintInternalIndeliveryReport' + '?' + $.param(f_args);
      },
      argsObject: function(id, senderBranchId) {
        var f_args = {
          id: id,
          senderBranchId: senderBranchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    CloseInternalTransfer: {
      url: function() {
        return $menu.getRootUrl() + '/StockMVC/InternalTransfer/CloseInternalTransfer';
      },
      argsObject: function(id, senderBranchId) {
        var f_args = {
          id: id,
          senderBranchId: senderBranchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    GetCloseInternalTransferWindow: {
      url: function(id, senderBranchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/StockMVC/InternalTransfer/GetCloseInternalTransferWindow';
        }
        var f_args = this.argsObject(id, senderBranchId);
        return $menu.getRootUrl() + '/StockMVC/InternalTransfer/GetCloseInternalTransferWindow' + '?' + $.param(f_args);
      },
      argsObject: function(id, senderBranchId) {
        var f_args = {
          id: id,
          senderBranchId: senderBranchId,
        };
        return f_args;
      },
      kendoWindow: function(id, senderBranchId, kendoWindowOptions) {
        var f_url = this.url(id, senderBranchId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(id,senderBranchId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  PurchaseOrder : {
    ShoppingCart: {
      url: function(id) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/StockMVC/PurchaseOrder/ShoppingCart';
        }
        var f_args = this.argsObject(id);
        return $menu.getRootUrl() + '/StockMVC/PurchaseOrder/ShoppingCart' + '?' + $.param(f_args);
      },
      argsObject: function(id) {
        var f_args = {
          id: id,
        };
        return f_args;
      },
      kendoWindow: function(id, kendoWindowOptions) {
        var f_url = this.url(id);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(id, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    MakeCentralWarehouseReservationOrder: {
      url: function() {
        return $menu.getRootUrl() + '/StockMVC/PurchaseOrder/MakeCentralWarehouseReservationOrder';
      },
      argsObject: function(item_CacheId, item_IsExpressReservation) {
        var f_args = {
          item: {
            CacheId: item_CacheId,
            IsExpressReservation: item_IsExpressReservation,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    MakeEdiReservationOrder: {
      url: function() {
        return $menu.getRootUrl() + '/StockMVC/PurchaseOrder/MakeEdiReservationOrder';
      },
      argsObject: function(item_CacheId, item_IsExpressReservation) {
        var f_args = {
          item: {
            CacheId: item_CacheId,
            IsExpressReservation: item_IsExpressReservation,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    PrintEdiReservationOrder: {
      url: function(orderId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/StockMVC/PurchaseOrder/PrintEdiReservationOrder';
        }
        var f_args = this.argsObject(orderId);
        return $menu.getRootUrl() + '/StockMVC/PurchaseOrder/PrintEdiReservationOrder' + '?' + $.param(f_args);
      },
      argsObject: function(orderId) {
        var f_args = {
          orderId: orderId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    PrintCentralWarehouseOrder: {
      url: function(orderId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/StockMVC/PurchaseOrder/PrintCentralWarehouseOrder';
        }
        var f_args = this.argsObject(orderId);
        return $menu.getRootUrl() + '/StockMVC/PurchaseOrder/PrintCentralWarehouseOrder' + '?' + $.param(f_args);
      },
      argsObject: function(orderId) {
        var f_args = {
          orderId: orderId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    RefreshPurchaseOrderNumber: {
      url: function() {
        return $menu.getRootUrl() + '/StockMVC/PurchaseOrder/RefreshPurchaseOrderNumber';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
    CheckSelectedCustomerOrder: {
      url: function(sellerBranchId, orderNumber) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/StockMVC/PurchaseOrder/CheckSelectedCustomerOrder';
        }
        var f_args = this.argsObject(sellerBranchId, orderNumber);
        return $menu.getRootUrl() + '/StockMVC/PurchaseOrder/CheckSelectedCustomerOrder' + '?' + $.param(f_args);
      },
      argsObject: function(sellerBranchId, orderNumber) {
        var f_args = {
          sellerBranchId: sellerBranchId,
          orderNumber: orderNumber,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  ReorderPoint : {
    ReorderPointListDialog: {
      url: function() {
        return $menu.getRootUrl() + '/StockMVC/ReorderPoint/ReorderPointListDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    QueueReorderPointListReport: {
      url: function(BranchId, StockId, ArticleNoFrom, ArticleNoTo, MainGroupFrom, MainGroupTo, SubGroupFrom, SubGroupTo, NoTransactionlessArticles, ReorderPointListType, SectionWidth, AspectRatio, RimDiameter, SupplierArtNo, GroupBySubgroup, ReorderPointListSortBy, ReorderPointSuggestionType, ReportType) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/StockMVC/ReorderPoint/QueueReorderPointListReport';
        }
        var f_args = this.argsObject(BranchId, StockId, ArticleNoFrom, ArticleNoTo, MainGroupFrom, MainGroupTo, SubGroupFrom, SubGroupTo, NoTransactionlessArticles, ReorderPointListType, SectionWidth, AspectRatio, RimDiameter, SupplierArtNo, GroupBySubgroup, ReorderPointListSortBy, ReorderPointSuggestionType, ReportType);
        return $menu.getRootUrl() + '/StockMVC/ReorderPoint/QueueReorderPointListReport' + '?' + $.param(f_args);
      },
      argsObject: function(BranchId, StockId, ArticleNoFrom, ArticleNoTo, MainGroupFrom, MainGroupTo, SubGroupFrom, SubGroupTo, NoTransactionlessArticles, ReorderPointListType, SectionWidth, AspectRatio, RimDiameter, SupplierArtNo, GroupBySubgroup, ReorderPointListSortBy, ReorderPointSuggestionType, ReportType) {
        var f_args = {
          BranchId: BranchId,
          StockId: StockId,
          ArticleNoFrom: ArticleNoFrom,
          ArticleNoTo: ArticleNoTo,
          MainGroupFrom: MainGroupFrom,
          MainGroupTo: MainGroupTo,
          SubGroupFrom: SubGroupFrom,
          SubGroupTo: SubGroupTo,
          NoTransactionlessArticles: NoTransactionlessArticles,
          ReorderPointListType: ReorderPointListType,
          SectionWidth: SectionWidth,
          AspectRatio: AspectRatio,
          RimDiameter: RimDiameter,
          SupplierArtNo: SupplierArtNo,
          GroupBySubgroup: GroupBySubgroup,
          ReorderPointListSortBy: ReorderPointListSortBy,
          ReorderPointSuggestionType: ReorderPointSuggestionType,
          ReportType: ReportType,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  StockBalance : {
    PalletPlace: {
      url: function(stockId, branchId, articleId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/StockMVC/StockBalance/PalletPlace';
        }
        var f_args = this.argsObject(stockId, branchId, articleId);
        return $menu.getRootUrl() + '/StockMVC/StockBalance/PalletPlace' + '?' + $.param(f_args);
      },
      argsObject: function(stockId, branchId, articleId) {
        var f_args = {
          stockId: stockId,
          branchId: branchId,
          articleId: articleId,
        };
        return f_args;
      },
      kendoWindow: function(stockId, branchId, articleId, kendoWindowOptions) {
        var f_url = this.url(stockId, branchId, articleId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(stockId,branchId,articleId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    UpdatePalletPlace: {
      url: function() {
        return $menu.getRootUrl() + '/StockMVC/StockBalance/UpdatePalletPlace';
      },
      argsObject: function(stockBalancePalletPlace_BranchId, stockBalancePalletPlace_ArticleId, stockBalancePalletPlace_StockId, stockBalancePalletPlace_PalletPlace) {
        var f_args = {
          stockBalancePalletPlace: {
            BranchId: stockBalancePalletPlace_BranchId,
            ArticleId: stockBalancePalletPlace_ArticleId,
            StockId: stockBalancePalletPlace_StockId,
            PalletPlace: stockBalancePalletPlace_PalletPlace,
          },
        };
        return f_args;
      },
      kendoWindow: function(data, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow('', kendoWindowOptions);
        f_window.refresh({
          url: f_url,
          data: JSON.stringify(data),
          contentType: 'application/json',
          type: 'POST'
        });
        return f_window;
      },
    },
  },
  Stock : {
    GetCostPriceAndIndeliveriesForArticle: {
      url: function(articleId, stockId, quantity) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/StockMVC/Stock/GetCostPriceAndIndeliveriesForArticle';
        }
        var f_args = this.argsObject(articleId, stockId, quantity);
        return $menu.getRootUrl() + '/StockMVC/Stock/GetCostPriceAndIndeliveriesForArticle' + '?' + $.param(f_args);
      },
      argsObject: function(articleId, stockId, quantity) {
        var f_args = {
          articleId: articleId,
          stockId: stockId,
          quantity: quantity,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
};

compilator.url.Public = {
  Vehicle : {
    SearchVehicle: {
      url: function(licensePlate, branchId, companyIdCacheKey) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Public/Vehicle/SearchVehicle';
        }
        var f_args = this.argsObject(licensePlate, branchId, companyIdCacheKey);
        return $menu.getRootUrl() + '/Public/Vehicle/SearchVehicle' + '?' + $.param(f_args);
      },
      argsObject: function(licensePlate, branchId, companyIdCacheKey) {
        var f_args = {
          licensePlate: licensePlate,
          branchId: branchId,
          companyIdCacheKey: companyIdCacheKey,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetLatestEvent: {
      url: function(licensePlate, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Public/Vehicle/GetLatestEvent';
        }
        var f_args = this.argsObject(licensePlate, branchId);
        return $menu.getRootUrl() + '/Public/Vehicle/GetLatestEvent' + '?' + $.param(f_args);
      },
      argsObject: function(licensePlate, branchId) {
        var f_args = {
          licensePlate: licensePlate,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
};

compilator.url.OrderMVC = {
  CashBalance : {
    DailyCashBalanceTransactionsDialog: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/CashBalance/DailyCashBalanceTransactionsDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    DailyCashBalanceExportDialog: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/CashBalance/DailyCashBalanceExportDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    DailyReportDialog: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/CashBalance/DailyReportDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SAFTReportDialog: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/CashBalance/SAFTReportDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetPrintDailyReportInformation: {
      url: function(branchId, fromDate, toDate, onlyCashAndCreditCard, createVerification, preview) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/CashBalance/GetPrintDailyReportInformation';
        }
        var f_args = this.argsObject(branchId, fromDate, toDate, onlyCashAndCreditCard, createVerification, preview);
        return $menu.getRootUrl() + '/OrderMVC/CashBalance/GetPrintDailyReportInformation' + '?' + $.param(f_args);
      },
      argsObject: function(branchId, fromDate, toDate, onlyCashAndCreditCard, createVerification, preview) {
        var f_args = {
          branchId: branchId,
          fromDate: fromDate,
          toDate: toDate,
          onlyCashAndCreditCard: onlyCashAndCreditCard,
          createVerification: createVerification,
          preview: preview,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetCashBalanceDialog: {
      url: function(pointOfSaleId, showTransactions, showDenominations) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/CashBalance/GetCashBalanceDialog';
        }
        var f_args = this.argsObject(pointOfSaleId, showTransactions, showDenominations);
        return $menu.getRootUrl() + '/OrderMVC/CashBalance/GetCashBalanceDialog' + '?' + $.param(f_args);
      },
      argsObject: function(pointOfSaleId, showTransactions, showDenominations) {
        var f_args = {
          pointOfSaleId: pointOfSaleId,
          showTransactions: showTransactions,
          showDenominations: showDenominations,
        };
        return f_args;
      },
      kendoWindow: function(pointOfSaleId, showTransactions, showDenominations, kendoWindowOptions) {
        var f_url = this.url(pointOfSaleId, showTransactions, showDenominations);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(pointOfSaleId,showTransactions,showDenominations, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    PrintXDailyReport: {
      url: function(pointOfSaleId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/CashBalance/PrintXDailyReport';
        }
        var f_args = this.argsObject(pointOfSaleId);
        return $menu.getRootUrl() + '/OrderMVC/CashBalance/PrintXDailyReport' + '?' + $.param(f_args);
      },
      argsObject: function(pointOfSaleId) {
        var f_args = {
          pointOfSaleId: pointOfSaleId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    QueueSAFTReport: {
      url: function(fromDate, toDate) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/CashBalance/QueueSAFTReport';
        }
        var f_args = this.argsObject(fromDate, toDate);
        return $menu.getRootUrl() + '/OrderMVC/CashBalance/QueueSAFTReport' + '?' + $.param(f_args);
      },
      argsObject: function(fromDate, toDate) {
        var f_args = {
          fromDate: fromDate,
          toDate: toDate,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    Create: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/CashBalance/Create';
      },
      argsObject: function(createCashBalance_PointOfSaleId, createCashBalance_BalanceDate, createCashBalance_BalanceCheckedBy, createCashBalance_BankDepositAmount, createCashBalance_DailyCashSales, createCashBalance_BalanceCarriedForward, createCashBalance_DailyCashBalanceTransactions, createCashBalance_MeansOfPayments) {
        var f_args = {
          createCashBalance: {
            PointOfSaleId: createCashBalance_PointOfSaleId,
            BalanceDate: createCashBalance_BalanceDate,
            BalanceCheckedBy: createCashBalance_BalanceCheckedBy,
            BankDepositAmount: createCashBalance_BankDepositAmount,
            DailyCashSales: createCashBalance_DailyCashSales,
            BalanceCarriedForward: createCashBalance_BalanceCarriedForward,
            DailyCashBalanceTransactions: createCashBalance_DailyCashBalanceTransactions,
            MeansOfPayments: createCashBalance_MeansOfPayments,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    TransferAccountingQueueErrors: {
      url: function(errors) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/CashBalance/TransferAccountingQueueErrors';
        }
        var f_args = this.argsObject(errors);
        return $menu.getRootUrl() + '/OrderMVC/CashBalance/TransferAccountingQueueErrors' + '?' + $.param(f_args);
      },
      argsObject: function(errors) {
        var f_args = {
          errors: errors,
        };
        return f_args;
      },
      kendoWindow: function(errors, kendoWindowOptions) {
        var f_url = this.url(errors);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(errors, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    PrintZDailyReport: {
      url: function(cashBalanceId, pointOfSaleId, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/CashBalance/PrintZDailyReport';
        }
        var f_args = this.argsObject(cashBalanceId, pointOfSaleId, branchId);
        return $menu.getRootUrl() + '/OrderMVC/CashBalance/PrintZDailyReport' + '?' + $.param(f_args);
      },
      argsObject: function(cashBalanceId, pointOfSaleId, branchId) {
        var f_args = {
          cashBalanceId: cashBalanceId,
          pointOfSaleId: pointOfSaleId,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    InvoiceJournal: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/CashBalance/InvoiceJournal';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    CreateInvoiceJournal: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/CashBalance/CreateInvoiceJournal';
      },
      argsObject: function(createInvoiceJournal_InvoiceJournalDate, createInvoiceJournal_BranchId, createInvoiceJournal_UserId, createInvoiceJournal_Username) {
        var f_args = {
          createInvoiceJournal: {
            InvoiceJournalDate: createInvoiceJournal_InvoiceJournalDate,
            BranchId: createInvoiceJournal_BranchId,
            UserId: createInvoiceJournal_UserId,
            Username: createInvoiceJournal_Username,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    AdyenMarketReportAccounting: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/CashBalance/AdyenMarketReportAccounting';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  Contract : {
    DebitContractsPeriod: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Contract/DebitContractsPeriod';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    PandaDocWindow: {
      url: function(pandaDocDocumentName, pandaDocRecipients, pandaDocTokens, pandaDocMetaFields) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Contract/PandaDocWindow';
        }
        var f_args = this.argsObject(pandaDocDocumentName, pandaDocRecipients, pandaDocTokens, pandaDocMetaFields);
        return $menu.getRootUrl() + '/OrderMVC/Contract/PandaDocWindow' + '?' + $.param(f_args);
      },
      argsObject: function(pandaDocDocumentName, pandaDocRecipients, pandaDocTokens, pandaDocMetaFields) {
        var f_args = {
          pandaDocDocumentName: pandaDocDocumentName,
          pandaDocRecipients: pandaDocRecipients,
          pandaDocTokens: pandaDocTokens,
          pandaDocMetaFields: pandaDocMetaFields,
        };
        return f_args;
      },
      kendoWindow: function(pandaDocDocumentName, pandaDocRecipients, pandaDocTokens, pandaDocMetaFields, kendoWindowOptions) {
        var f_url = this.url(pandaDocDocumentName, pandaDocRecipients, pandaDocTokens, pandaDocMetaFields);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(pandaDocDocumentName,pandaDocRecipients,pandaDocTokens,pandaDocMetaFields, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    TerminateContract: {
      url: function(id, noticePeriod, noticePeriodStart, minimumPeriod) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Contract/TerminateContract';
        }
        var f_args = this.argsObject(id, noticePeriod, noticePeriodStart, minimumPeriod);
        return $menu.getRootUrl() + '/OrderMVC/Contract/TerminateContract' + '?' + $.param(f_args);
      },
      argsObject: function(id, noticePeriod, noticePeriodStart, minimumPeriod) {
        var f_args = {
          id: id,
          noticePeriod: noticePeriod,
          noticePeriodStart: noticePeriodStart,
          minimumPeriod: minimumPeriod,
        };
        return f_args;
      },
      kendoWindow: function(id, noticePeriod, noticePeriodStart, minimumPeriod, kendoWindowOptions) {
        var f_url = this.url(id, noticePeriod, noticePeriodStart, minimumPeriod);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(id,noticePeriod,noticePeriodStart,minimumPeriod, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetCustomerClpContractId: {
      url: function(customerNo) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Contract/GetCustomerClpContractId';
        }
        var f_args = this.argsObject(customerNo);
        return $menu.getRootUrl() + '/OrderMVC/Contract/GetCustomerClpContractId' + '?' + $.param(f_args);
      },
      argsObject: function(customerNo) {
        var f_args = {
          customerNo: customerNo,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetCustomerMeteringContractId: {
      url: function(customerNo) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Contract/GetCustomerMeteringContractId';
        }
        var f_args = this.argsObject(customerNo);
        return $menu.getRootUrl() + '/OrderMVC/Contract/GetCustomerMeteringContractId' + '?' + $.param(f_args);
      },
      argsObject: function(customerNo) {
        var f_args = {
          customerNo: customerNo,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    Delete: {
      url: function(id) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Contract/Delete';
        }
        var f_args = this.argsObject(id);
        return $menu.getRootUrl() + '/OrderMVC/Contract/Delete' + '?' + $.param(f_args);
      },
      argsObject: function(id) {
        var f_args = {
          id: id,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'DELETE', ajaxOptions, 'json', ajaxData);
      },
    },
    UpdateContractArticlesByCustomer: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Contract/UpdateContractArticlesByCustomer';
      },
      argsObject: function(customerId, branchId, currentCurrency_Id, currentCurrency_Name, currentCurrency_Code, currentCurrency_Rate, currentCurrency_RateDisplay, currentCurrency_CurrentRate, currentCurrency_RoundingFactor, orderLines, includeArticlePackage, displayVat, agreementType) {
        var f_args = {
          customerId: customerId,
          branchId: branchId,
          currentCurrency: {
            Id: currentCurrency_Id,
            Name: currentCurrency_Name,
            Code: currentCurrency_Code,
            Rate: currentCurrency_Rate,
            RateDisplay: currentCurrency_RateDisplay,
            CurrentRate: currentCurrency_CurrentRate,
            RoundingFactor: currentCurrency_RoundingFactor,
          },
          orderLines: orderLines,
          includeArticlePackage: includeArticlePackage,
          displayVat: displayVat,
          agreementType: agreementType,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    Save: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Contract/Save';
      },
      argsObject: function(contract_ContractDetails, contract_OrderDate, contract_SellerBranchId, contract_SellerBranchDisplay, contract_OrderId, contract_OrderType, contract_RowVersion, contract_IsClosed, contract_IsInvoiced, contract_FinalInvoiceNumber, contract_SalesPerson, contract_StorageCardId, contract_CompanyCurrencyCode, contract_Currency, contract_OrderTags, contract_PricelistAgreement, contract_Customer, contract_DeliveryAddressInfo, contract_Vehicle, contract_OrderLines, contract_PresetNote, contract_OrderDetailsTermsOfPayment, contract_Footer, contract_TotalAmountIncludingVat, contract_TotalAmountExcludingVat, contract_TotalVatAmount, contract_OrderStatus, contract_CloseOrderType, contract_CleanCashReceiptsPrinted, contract_MarkedDone, contract_EventId, contract_CloseOrderNumber, contract_AgreedDoneTime, contract_ReservationStatusId, contract_SaveOrderType, contract_IsWebOrder, contract_DownPayment, contract_AdyenInformation, contract_WmsId, contract_CentralWarehouseStatus, contract_CentralWarehouseWaybillNumbers, contract_OrderWarehouseHistory, contract_ShippingConditions, contract_BasketTypeId, contract_FleetAgreementId, contract_LicensePlateRequired, contract_CustomerNumberRequired, contract_YourReferenceRequired, contract_OdometerRequired, contract_WorkOrderNumberRequired, contract_DeliveryAddressRequired, contract_RequisitionOrderNumberRequired, contract_DefaultSearchArticlesStockQuantity, contract_UseEdiLite, contract_LicensePlateInactive, contract_YourReferenceInactive, contract_OdometerInactive, contract_WorkOrderNumberInactive, contract_DeliveryAddressInactive, contract_VATInactive, contract_VATChecked, contract_AllowChangeWebOrders, contract_DefaultPointOfSaleId, contract_FromResursBankCallback, contract_ResursBankPaymentSuccess) {
        var f_args = {
          contract: {
            ContractDetails: contract_ContractDetails,
            OrderDate: contract_OrderDate,
            SellerBranchId: contract_SellerBranchId,
            SellerBranchDisplay: contract_SellerBranchDisplay,
            OrderId: contract_OrderId,
            OrderType: contract_OrderType,
            RowVersion: contract_RowVersion,
            IsClosed: contract_IsClosed,
            IsInvoiced: contract_IsInvoiced,
            FinalInvoiceNumber: contract_FinalInvoiceNumber,
            SalesPerson: contract_SalesPerson,
            StorageCardId: contract_StorageCardId,
            CompanyCurrencyCode: contract_CompanyCurrencyCode,
            Currency: contract_Currency,
            OrderTags: contract_OrderTags,
            PricelistAgreement: contract_PricelistAgreement,
            Customer: contract_Customer,
            DeliveryAddressInfo: contract_DeliveryAddressInfo,
            Vehicle: contract_Vehicle,
            OrderLines: contract_OrderLines,
            PresetNote: contract_PresetNote,
            OrderDetailsTermsOfPayment: contract_OrderDetailsTermsOfPayment,
            Footer: contract_Footer,
            TotalAmountIncludingVat: contract_TotalAmountIncludingVat,
            TotalAmountExcludingVat: contract_TotalAmountExcludingVat,
            TotalVatAmount: contract_TotalVatAmount,
            OrderStatus: contract_OrderStatus,
            CloseOrderType: contract_CloseOrderType,
            CleanCashReceiptsPrinted: contract_CleanCashReceiptsPrinted,
            MarkedDone: contract_MarkedDone,
            EventId: contract_EventId,
            CloseOrderNumber: contract_CloseOrderNumber,
            AgreedDoneTime: contract_AgreedDoneTime,
            ReservationStatusId: contract_ReservationStatusId,
            SaveOrderType: contract_SaveOrderType,
            IsWebOrder: contract_IsWebOrder,
            DownPayment: contract_DownPayment,
            AdyenInformation: contract_AdyenInformation,
            WmsId: contract_WmsId,
            CentralWarehouseStatus: contract_CentralWarehouseStatus,
            CentralWarehouseWaybillNumbers: contract_CentralWarehouseWaybillNumbers,
            OrderWarehouseHistory: contract_OrderWarehouseHistory,
            ShippingConditions: contract_ShippingConditions,
            BasketTypeId: contract_BasketTypeId,
            FleetAgreementId: contract_FleetAgreementId,
            LicensePlateRequired: contract_LicensePlateRequired,
            CustomerNumberRequired: contract_CustomerNumberRequired,
            YourReferenceRequired: contract_YourReferenceRequired,
            OdometerRequired: contract_OdometerRequired,
            WorkOrderNumberRequired: contract_WorkOrderNumberRequired,
            DeliveryAddressRequired: contract_DeliveryAddressRequired,
            RequisitionOrderNumberRequired: contract_RequisitionOrderNumberRequired,
            DefaultSearchArticlesStockQuantity: contract_DefaultSearchArticlesStockQuantity,
            UseEdiLite: contract_UseEdiLite,
            LicensePlateInactive: contract_LicensePlateInactive,
            YourReferenceInactive: contract_YourReferenceInactive,
            OdometerInactive: contract_OdometerInactive,
            WorkOrderNumberInactive: contract_WorkOrderNumberInactive,
            DeliveryAddressInactive: contract_DeliveryAddressInactive,
            VATInactive: contract_VATInactive,
            VATChecked: contract_VATChecked,
            AllowChangeWebOrders: contract_AllowChangeWebOrders,
            DefaultPointOfSaleId: contract_DefaultPointOfSaleId,
            FromResursBankCallback: contract_FromResursBankCallback,
            ResursBankPaymentSuccess: contract_ResursBankPaymentSuccess,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    UpdateContract: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Contract/UpdateContract';
      },
      argsObject: function(updateContract_ContractDetails, updateContract_OrderDate, updateContract_SellerBranchId, updateContract_SellerBranchDisplay, updateContract_OrderId, updateContract_OrderType, updateContract_RowVersion, updateContract_IsClosed, updateContract_IsInvoiced, updateContract_FinalInvoiceNumber, updateContract_SalesPerson, updateContract_StorageCardId, updateContract_CompanyCurrencyCode, updateContract_Currency, updateContract_OrderTags, updateContract_PricelistAgreement, updateContract_Customer, updateContract_DeliveryAddressInfo, updateContract_Vehicle, updateContract_OrderLines, updateContract_PresetNote, updateContract_OrderDetailsTermsOfPayment, updateContract_Footer, updateContract_TotalAmountIncludingVat, updateContract_TotalAmountExcludingVat, updateContract_TotalVatAmount, updateContract_OrderStatus, updateContract_CloseOrderType, updateContract_CleanCashReceiptsPrinted, updateContract_MarkedDone, updateContract_EventId, updateContract_CloseOrderNumber, updateContract_AgreedDoneTime, updateContract_ReservationStatusId, updateContract_SaveOrderType, updateContract_IsWebOrder, updateContract_DownPayment, updateContract_AdyenInformation, updateContract_WmsId, updateContract_CentralWarehouseStatus, updateContract_CentralWarehouseWaybillNumbers, updateContract_OrderWarehouseHistory, updateContract_ShippingConditions, updateContract_BasketTypeId, updateContract_FleetAgreementId, updateContract_LicensePlateRequired, updateContract_CustomerNumberRequired, updateContract_YourReferenceRequired, updateContract_OdometerRequired, updateContract_WorkOrderNumberRequired, updateContract_DeliveryAddressRequired, updateContract_RequisitionOrderNumberRequired, updateContract_DefaultSearchArticlesStockQuantity, updateContract_UseEdiLite, updateContract_LicensePlateInactive, updateContract_YourReferenceInactive, updateContract_OdometerInactive, updateContract_WorkOrderNumberInactive, updateContract_DeliveryAddressInactive, updateContract_VATInactive, updateContract_VATChecked, updateContract_AllowChangeWebOrders, updateContract_DefaultPointOfSaleId, updateContract_FromResursBankCallback, updateContract_ResursBankPaymentSuccess) {
        var f_args = {
          updateContract: {
            ContractDetails: updateContract_ContractDetails,
            OrderDate: updateContract_OrderDate,
            SellerBranchId: updateContract_SellerBranchId,
            SellerBranchDisplay: updateContract_SellerBranchDisplay,
            OrderId: updateContract_OrderId,
            OrderType: updateContract_OrderType,
            RowVersion: updateContract_RowVersion,
            IsClosed: updateContract_IsClosed,
            IsInvoiced: updateContract_IsInvoiced,
            FinalInvoiceNumber: updateContract_FinalInvoiceNumber,
            SalesPerson: updateContract_SalesPerson,
            StorageCardId: updateContract_StorageCardId,
            CompanyCurrencyCode: updateContract_CompanyCurrencyCode,
            Currency: updateContract_Currency,
            OrderTags: updateContract_OrderTags,
            PricelistAgreement: updateContract_PricelistAgreement,
            Customer: updateContract_Customer,
            DeliveryAddressInfo: updateContract_DeliveryAddressInfo,
            Vehicle: updateContract_Vehicle,
            OrderLines: updateContract_OrderLines,
            PresetNote: updateContract_PresetNote,
            OrderDetailsTermsOfPayment: updateContract_OrderDetailsTermsOfPayment,
            Footer: updateContract_Footer,
            TotalAmountIncludingVat: updateContract_TotalAmountIncludingVat,
            TotalAmountExcludingVat: updateContract_TotalAmountExcludingVat,
            TotalVatAmount: updateContract_TotalVatAmount,
            OrderStatus: updateContract_OrderStatus,
            CloseOrderType: updateContract_CloseOrderType,
            CleanCashReceiptsPrinted: updateContract_CleanCashReceiptsPrinted,
            MarkedDone: updateContract_MarkedDone,
            EventId: updateContract_EventId,
            CloseOrderNumber: updateContract_CloseOrderNumber,
            AgreedDoneTime: updateContract_AgreedDoneTime,
            ReservationStatusId: updateContract_ReservationStatusId,
            SaveOrderType: updateContract_SaveOrderType,
            IsWebOrder: updateContract_IsWebOrder,
            DownPayment: updateContract_DownPayment,
            AdyenInformation: updateContract_AdyenInformation,
            WmsId: updateContract_WmsId,
            CentralWarehouseStatus: updateContract_CentralWarehouseStatus,
            CentralWarehouseWaybillNumbers: updateContract_CentralWarehouseWaybillNumbers,
            OrderWarehouseHistory: updateContract_OrderWarehouseHistory,
            ShippingConditions: updateContract_ShippingConditions,
            BasketTypeId: updateContract_BasketTypeId,
            FleetAgreementId: updateContract_FleetAgreementId,
            LicensePlateRequired: updateContract_LicensePlateRequired,
            CustomerNumberRequired: updateContract_CustomerNumberRequired,
            YourReferenceRequired: updateContract_YourReferenceRequired,
            OdometerRequired: updateContract_OdometerRequired,
            WorkOrderNumberRequired: updateContract_WorkOrderNumberRequired,
            DeliveryAddressRequired: updateContract_DeliveryAddressRequired,
            RequisitionOrderNumberRequired: updateContract_RequisitionOrderNumberRequired,
            DefaultSearchArticlesStockQuantity: updateContract_DefaultSearchArticlesStockQuantity,
            UseEdiLite: updateContract_UseEdiLite,
            LicensePlateInactive: updateContract_LicensePlateInactive,
            YourReferenceInactive: updateContract_YourReferenceInactive,
            OdometerInactive: updateContract_OdometerInactive,
            WorkOrderNumberInactive: updateContract_WorkOrderNumberInactive,
            DeliveryAddressInactive: updateContract_DeliveryAddressInactive,
            VATInactive: updateContract_VATInactive,
            VATChecked: updateContract_VATChecked,
            AllowChangeWebOrders: updateContract_AllowChangeWebOrders,
            DefaultPointOfSaleId: updateContract_DefaultPointOfSaleId,
            FromResursBankCallback: updateContract_FromResursBankCallback,
            ResursBankPaymentSuccess: updateContract_ResursBankPaymentSuccess,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    Details: {
      url: function(id, copyFrom, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Contract/Details';
        }
        var f_args = this.argsObject(id, copyFrom, branchId);
        return $menu.getRootUrl() + '/OrderMVC/Contract/Details' + '?' + $.param(f_args);
      },
      argsObject: function(id, copyFrom, branchId) {
        var f_args = {
          id: id,
          copyFrom: copyFrom,
          branchId: branchId,
        };
        return f_args;
      },
      browserWindow: function(id, copyFrom, branchId) {
        var f_url = this.url(id, copyFrom, branchId);
        var f_args = [id, copyFrom, branchId];
        var f_winId = f_args.join('_')
        var f_windowName = undefined;
        if(f_winId.replace(/_/g, '') != '') {
          f_windowName = 'Details_' + f_args.join('_');
        }
        compilator.windowHandler.openWindowWithFocus(f_url, f_windowName, arguments.length > 0);
      },
    },
    DeletePandaDoc: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Contract/DeletePandaDoc';
      },
      argsObject: function(contractHeadId) {
        var f_args = {
          contractHeadId: contractHeadId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    SyncContractWithPandaDoc: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Contract/SyncContractWithPandaDoc';
      },
      argsObject: function(contractId) {
        var f_args = {
          contractId: contractId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    SyncContractsWithPandaDoc: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Contract/SyncContractsWithPandaDoc';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json');
      },
    },
    UpdateContractPrices: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Contract/UpdateContractPrices';
      },
      argsObject: function(customerNumber, reference, contractNumber, description, createdBy, branches, invoiceCycle, sendToClp) {
        var f_args = {
          customerNumber: customerNumber,
          reference: reference,
          contractNumber: contractNumber,
          description: description,
          createdBy: createdBy,
          branches: branches,
          invoiceCycle: invoiceCycle,
          sendToClp: sendToClp,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    DebitContracts: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Contract/DebitContracts';
      },
      argsObject: function(customerNumber, reference, contractNumber, description, createdBy, branches, invoiceCycle, periodStartDate, periodEndDate, contractTypeId, countryId, currencyId, sendToClp) {
        var f_args = {
          customerNumber: customerNumber,
          reference: reference,
          contractNumber: contractNumber,
          description: description,
          createdBy: createdBy,
          branches: branches,
          invoiceCycle: invoiceCycle,
          periodStartDate: periodStartDate,
          periodEndDate: periodEndDate,
          contractTypeId: contractTypeId,
          countryId: countryId,
          currencyId: currencyId,
          sendToClp: sendToClp,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    ClearContractAction: {
      url: function(contractId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Contract/ClearContractAction';
        }
        var f_args = this.argsObject(contractId);
        return $menu.getRootUrl() + '/OrderMVC/Contract/ClearContractAction' + '?' + $.param(f_args);
      },
      argsObject: function(contractId) {
        var f_args = {
          contractId: contractId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetContractArticleLineSummary: {
      url: function(contractId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Contract/GetContractArticleLineSummary';
        }
        var f_args = this.argsObject(contractId);
        return $menu.getRootUrl() + '/OrderMVC/Contract/GetContractArticleLineSummary' + '?' + $.param(f_args);
      },
      argsObject: function(contractId) {
        var f_args = {
          contractId: contractId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  Basket : {
    BasketView: {
      url: function(basketType, basketId, branchId, existingOrderId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Basket/BasketView';
        }
        var f_args = this.argsObject(basketType, basketId, branchId, existingOrderId);
        return $menu.getRootUrl() + '/OrderMVC/Basket/BasketView' + '?' + $.param(f_args);
      },
      argsObject: function(basketType, basketId, branchId, existingOrderId) {
        var f_args = {
          basketType: basketType,
          basketId: basketId,
          branchId: branchId,
          existingOrderId: existingOrderId,
        };
        return f_args;
      },
      kendoWindow: function(basketType, basketId, branchId, existingOrderId, kendoWindowOptions) {
        var f_url = this.url(basketType, basketId, branchId, existingOrderId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(basketType,basketId,branchId,existingOrderId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    PrintDialog: {
      url: function(report, showEmptyBasketCheckbox, orderHeadId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Basket/PrintDialog';
        }
        var f_args = this.argsObject(report, showEmptyBasketCheckbox, orderHeadId);
        return $menu.getRootUrl() + '/OrderMVC/Basket/PrintDialog' + '?' + $.param(f_args);
      },
      argsObject: function(report, showEmptyBasketCheckbox, orderHeadId) {
        var f_args = {
          report: report,
          showEmptyBasketCheckbox: showEmptyBasketCheckbox,
          orderHeadId: orderHeadId,
        };
        return f_args;
      },
      kendoWindow: function(report, showEmptyBasketCheckbox, orderHeadId, kendoWindowOptions) {
        var f_url = this.url(report, showEmptyBasketCheckbox, orderHeadId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(report,showEmptyBasketCheckbox,orderHeadId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetReportInfo: {
      url: function(basketId, report, deleteBasket, basketType) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Basket/GetReportInfo';
        }
        var f_args = this.argsObject(basketId, report, deleteBasket, basketType);
        return $menu.getRootUrl() + '/OrderMVC/Basket/GetReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(basketId, report, deleteBasket, basketType) {
        var f_args = {
          basketId: basketId,
          report: report,
          deleteBasket: deleteBasket,
          basketType: basketType,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetWarehouses: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Basket/GetWarehouses';
      },
      argsObject: function(model_BasketType, model_LicensePlate, model_BasketBranchId, model_BasketId, model_ExistingOrderId, model_CreateSupplierOrder) {
        var f_args = {
          model: {
            BasketType: model_BasketType,
            LicensePlate: model_LicensePlate,
            BasketBranchId: model_BasketBranchId,
            BasketId: model_BasketId,
            ExistingOrderId: model_ExistingOrderId,
            CreateSupplierOrder: model_CreateSupplierOrder,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    GetBasketCart: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Basket/GetBasketCart';
      },
      argsObject: function(model_BasketType, model_LicensePlate, model_BasketBranchId, model_BasketId, model_ExistingOrderId, model_CreateSupplierOrder) {
        var f_args = {
          model: {
            BasketType: model_BasketType,
            LicensePlate: model_LicensePlate,
            BasketBranchId: model_BasketBranchId,
            BasketId: model_BasketId,
            ExistingOrderId: model_ExistingOrderId,
            CreateSupplierOrder: model_CreateSupplierOrder,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    UpdateBasket: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Basket/UpdateBasket';
      },
      argsObject: function(model_BasketType, model_LicensePlate, model_BasketBranchId, model_BasketId, model_ExistingOrderId, model_CreateSupplierOrder) {
        var f_args = {
          model: {
            BasketType: model_BasketType,
            LicensePlate: model_LicensePlate,
            BasketBranchId: model_BasketBranchId,
            BasketId: model_BasketId,
            ExistingOrderId: model_ExistingOrderId,
            CreateSupplierOrder: model_CreateSupplierOrder,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    GetBasketLines: {
      url: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, basketId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Basket/GetBasketLines';
        }
        var f_args = this.argsObject(Page, PageSize, Sorts, Filters, Groups, Aggregates, basketId);
        return $menu.getRootUrl() + '/OrderMVC/Basket/GetBasketLines' + '?' + $.param(f_args);
      },
      argsObject: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, basketId) {
        var f_args = {
          Page: Page,
          PageSize: PageSize,
          Sorts: Sorts,
          Filters: Filters,
          Groups: Groups,
          Aggregates: Aggregates,
          basketId: basketId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    UpdateBasketLine: {
      url: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, Id, ArticleNumber, ArticleName, Quantity, Stock, AvailableInWareHouse, GrossPricePrUnit, GrossPricePrUnitIncludingVat, SumGrossPricePrUnit, SumGrossPricePrUnitIncludingVat, NetPricePrUnit, NetPricePrUnitIncludingVat, SumNetPricePrUnit, SumNetPricePrUnitIncludingVat, VatPercent, BasketLineType, CheckWarehouseAvailability) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Basket/UpdateBasketLine';
        }
        var f_args = this.argsObject(Page, PageSize, Sorts, Filters, Groups, Aggregates, Id, ArticleNumber, ArticleName, Quantity, Stock, AvailableInWareHouse, GrossPricePrUnit, GrossPricePrUnitIncludingVat, SumGrossPricePrUnit, SumGrossPricePrUnitIncludingVat, NetPricePrUnit, NetPricePrUnitIncludingVat, SumNetPricePrUnit, SumNetPricePrUnitIncludingVat, VatPercent, BasketLineType, CheckWarehouseAvailability);
        return $menu.getRootUrl() + '/OrderMVC/Basket/UpdateBasketLine' + '?' + $.param(f_args);
      },
      argsObject: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, Id, ArticleNumber, ArticleName, Quantity, Stock, AvailableInWareHouse, GrossPricePrUnit, GrossPricePrUnitIncludingVat, SumGrossPricePrUnit, SumGrossPricePrUnitIncludingVat, NetPricePrUnit, NetPricePrUnitIncludingVat, SumNetPricePrUnit, SumNetPricePrUnitIncludingVat, VatPercent, BasketLineType, CheckWarehouseAvailability) {
        var f_args = {
          Page: Page,
          PageSize: PageSize,
          Sorts: Sorts,
          Filters: Filters,
          Groups: Groups,
          Aggregates: Aggregates,
          Id: Id,
          ArticleNumber: ArticleNumber,
          ArticleName: ArticleName,
          Quantity: Quantity,
          Stock: Stock,
          AvailableInWareHouse: AvailableInWareHouse,
          GrossPricePrUnit: GrossPricePrUnit,
          GrossPricePrUnitIncludingVat: GrossPricePrUnitIncludingVat,
          SumGrossPricePrUnit: SumGrossPricePrUnit,
          SumGrossPricePrUnitIncludingVat: SumGrossPricePrUnitIncludingVat,
          NetPricePrUnit: NetPricePrUnit,
          NetPricePrUnitIncludingVat: NetPricePrUnitIncludingVat,
          SumNetPricePrUnit: SumNetPricePrUnit,
          SumNetPricePrUnitIncludingVat: SumNetPricePrUnitIncludingVat,
          VatPercent: VatPercent,
          BasketLineType: BasketLineType,
          CheckWarehouseAvailability: CheckWarehouseAvailability,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    DeleteArticleLine: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Basket/DeleteArticleLine';
      },
      argsObject: function(view_Id, view_ArticleNumber, view_ArticleName, view_Quantity, view_Stock, view_AvailableInWareHouse, view_GrossPricePrUnit, view_GrossPricePrUnitIncludingVat, view_SumGrossPricePrUnit, view_SumGrossPricePrUnitIncludingVat, view_NetPricePrUnit, view_NetPricePrUnitIncludingVat, view_SumNetPricePrUnit, view_SumNetPricePrUnitIncludingVat, view_VatPercent, view_BasketLineType, view_CheckWarehouseAvailability) {
        var f_args = {
          view: {
            Id: view_Id,
            ArticleNumber: view_ArticleNumber,
            ArticleName: view_ArticleName,
            Quantity: view_Quantity,
            Stock: view_Stock,
            AvailableInWareHouse: view_AvailableInWareHouse,
            GrossPricePrUnit: view_GrossPricePrUnit,
            GrossPricePrUnitIncludingVat: view_GrossPricePrUnitIncludingVat,
            SumGrossPricePrUnit: view_SumGrossPricePrUnit,
            SumGrossPricePrUnitIncludingVat: view_SumGrossPricePrUnitIncludingVat,
            NetPricePrUnit: view_NetPricePrUnit,
            NetPricePrUnitIncludingVat: view_NetPricePrUnitIncludingVat,
            SumNetPricePrUnit: view_SumNetPricePrUnit,
            SumNetPricePrUnitIncludingVat: view_SumNetPricePrUnitIncludingVat,
            VatPercent: view_VatPercent,
            BasketLineType: view_BasketLineType,
            CheckWarehouseAvailability: view_CheckWarehouseAvailability,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    ClearBasketCart: {
      url: function(basketId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Basket/ClearBasketCart';
        }
        var f_args = this.argsObject(basketId);
        return $menu.getRootUrl() + '/OrderMVC/Basket/ClearBasketCart' + '?' + $.param(f_args);
      },
      argsObject: function(basketId) {
        var f_args = {
          basketId: basketId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    OrderBasket: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Basket/OrderBasket';
      },
      argsObject: function(model_BasketType, model_LicensePlate, model_BasketBranchId, model_BasketId, model_ExistingOrderId, model_CreateSupplierOrder) {
        var f_args = {
          model: {
            BasketType: model_BasketType,
            LicensePlate: model_LicensePlate,
            BasketBranchId: model_BasketBranchId,
            BasketId: model_BasketId,
            ExistingOrderId: model_ExistingOrderId,
            CreateSupplierOrder: model_CreateSupplierOrder,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    DebitBasket: {
      url: function(branchId, basketId, existingOrderId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Basket/DebitBasket';
        }
        var f_args = this.argsObject(branchId, basketId, existingOrderId);
        return $menu.getRootUrl() + '/OrderMVC/Basket/DebitBasket' + '?' + $.param(f_args);
      },
      argsObject: function(branchId, basketId, existingOrderId) {
        var f_args = {
          branchId: branchId,
          basketId: basketId,
          existingOrderId: existingOrderId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetBasketNotOrderedAndDebited: {
      url: function(basketType, branchId, basketId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Basket/GetBasketNotOrderedAndDebited';
        }
        var f_args = this.argsObject(basketType, branchId, basketId);
        return $menu.getRootUrl() + '/OrderMVC/Basket/GetBasketNotOrderedAndDebited' + '?' + $.param(f_args);
      },
      argsObject: function(basketType, branchId, basketId) {
        var f_args = {
          basketType: basketType,
          branchId: branchId,
          basketId: basketId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    UpdateOrderReference: {
      url: function(basketId, orderReference) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Basket/UpdateOrderReference';
        }
        var f_args = this.argsObject(basketId, orderReference);
        return $menu.getRootUrl() + '/OrderMVC/Basket/UpdateOrderReference' + '?' + $.param(f_args);
      },
      argsObject: function(basketId, orderReference) {
        var f_args = {
          basketId: basketId,
          orderReference: orderReference,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    UpdateGoodsMarking: {
      url: function(basketId, goodsMarking) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Basket/UpdateGoodsMarking';
        }
        var f_args = this.argsObject(basketId, goodsMarking);
        return $menu.getRootUrl() + '/OrderMVC/Basket/UpdateGoodsMarking' + '?' + $.param(f_args);
      },
      argsObject: function(basketId, goodsMarking) {
        var f_args = {
          basketId: basketId,
          goodsMarking: goodsMarking,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  EDI : {
    EdiLite: {
      url: function(articleId, quantity, licensePlate, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/EDI/EdiLite';
        }
        var f_args = this.argsObject(articleId, quantity, licensePlate, branchId);
        return $menu.getRootUrl() + '/OrderMVC/EDI/EdiLite' + '?' + $.param(f_args);
      },
      argsObject: function(articleId, quantity, licensePlate, branchId) {
        var f_args = {
          articleId: articleId,
          quantity: quantity,
          licensePlate: licensePlate,
          branchId: branchId,
        };
        return f_args;
      },
      kendoWindow: function(articleId, quantity, licensePlate, branchId, kendoWindowOptions) {
        var f_url = this.url(articleId, quantity, licensePlate, branchId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(articleId,quantity,licensePlate,branchId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    EDI: {
      url: function(supplierArticle, supplierId, quantity, reference, useRecyclingFee, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/EDI/EDI';
        }
        var f_args = this.argsObject(supplierArticle, supplierId, quantity, reference, useRecyclingFee, branchId);
        return $menu.getRootUrl() + '/OrderMVC/EDI/EDI' + '?' + $.param(f_args);
      },
      argsObject: function(supplierArticle, supplierId, quantity, reference, useRecyclingFee, branchId) {
        var f_args = {
          supplierArticle: supplierArticle,
          supplierId: supplierId,
          quantity: quantity,
          reference: reference,
          useRecyclingFee: useRecyclingFee,
          branchId: branchId,
        };
        return f_args;
      },
      kendoWindow: function(supplierArticle, supplierId, quantity, reference, useRecyclingFee, branchId, kendoWindowOptions) {
        var f_url = this.url(supplierArticle, supplierId, quantity, reference, useRecyclingFee, branchId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(supplierArticle,supplierId,quantity,reference,useRecyclingFee,branchId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    ClearBasket: {
      url: function(supplierId, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/EDI/ClearBasket';
        }
        var f_args = this.argsObject(supplierId, branchId);
        return $menu.getRootUrl() + '/OrderMVC/EDI/ClearBasket' + '?' + $.param(f_args);
      },
      argsObject: function(supplierId, branchId) {
        var f_args = {
          supplierId: supplierId,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, undefined, ajaxData);
      },
    },
    GetArticleInformation: {
      url: function(supplierArticleId, supplierId, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/EDI/GetArticleInformation';
        }
        var f_args = this.argsObject(supplierArticleId, supplierId, branchId);
        return $menu.getRootUrl() + '/OrderMVC/EDI/GetArticleInformation' + '?' + $.param(f_args);
      },
      argsObject: function(supplierArticleId, supplierId, branchId) {
        var f_args = {
          supplierArticleId: supplierArticleId,
          supplierId: supplierId,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetSupplierLogoUrl: {
      url: function(supplierCSID) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/EDI/GetSupplierLogoUrl';
        }
        var f_args = this.argsObject(supplierCSID);
        return $menu.getRootUrl() + '/OrderMVC/EDI/GetSupplierLogoUrl' + '?' + $.param(f_args);
      },
      argsObject: function(supplierCSID) {
        var f_args = {
          supplierCSID: supplierCSID,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    CheckMultipleAvailability: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/EDI/CheckMultipleAvailability';
      },
      argsObject: function(cartLines, supplierId, accountId, branchId) {
        var f_args = {
          cartLines: cartLines,
          supplierId: supplierId,
          accountId: accountId,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    SendOrder: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/EDI/SendOrder';
      },
      argsObject: function(items, supplierId, accountId, branchId, useCart, useRecyclingFee) {
        var f_args = {
          items: items,
          supplierId: supplierId,
          accountId: accountId,
          branchId: branchId,
          useCart: useCart,
          useRecyclingFee: useRecyclingFee,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    SendCentralWarehouseOrder: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/EDI/SendCentralWarehouseOrder';
      },
      argsObject: function(items, supplierId, branchId) {
        var f_args = {
          items: items,
          supplierId: supplierId,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    GetReportInfo: {
      url: function(orderId, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/EDI/GetReportInfo';
        }
        var f_args = this.argsObject(orderId, branchId);
        return $menu.getRootUrl() + '/OrderMVC/EDI/GetReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, branchId) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    SupplierArticleExist: {
      url: function(supplierArticleId, supplierId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/EDI/SupplierArticleExist';
        }
        var f_args = this.argsObject(supplierArticleId, supplierId);
        return $menu.getRootUrl() + '/OrderMVC/EDI/SupplierArticleExist' + '?' + $.param(f_args);
      },
      argsObject: function(supplierArticleId, supplierId) {
        var f_args = {
          supplierArticleId: supplierArticleId,
          supplierId: supplierId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  Intrastat : {
    Index: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Intrastat/Index';
      },
      argsObject: function(model_DateFrom, model_DateTo, model_CompanyName, model_PrintSalesReport, model_PrintPurchaseReport) {
        var f_args = {
          model: {
            DateFrom: model_DateFrom,
            DateTo: model_DateTo,
            CompanyName: model_CompanyName,
            PrintSalesReport: model_PrintSalesReport,
            PrintPurchaseReport: model_PrintPurchaseReport,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  LeasingSalesReport : {
    Index: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/LeasingSalesReport/Index';
      },
      argsObject: function(model_DateFrom, model_DateTo, model_ArticleNumberStart, model_ArticleNumberEnd, model_MainGroupStart, model_MainGroupEnd, model_SubGroupStart, model_SubGroupEnd, model_CustomerNumber, model_SalesPerson, model_CustomerCategory) {
        var f_args = {
          model: {
            DateFrom: model_DateFrom,
            DateTo: model_DateTo,
            ArticleNumberStart: model_ArticleNumberStart,
            ArticleNumberEnd: model_ArticleNumberEnd,
            MainGroupStart: model_MainGroupStart,
            MainGroupEnd: model_MainGroupEnd,
            SubGroupStart: model_SubGroupStart,
            SubGroupEnd: model_SubGroupEnd,
            CustomerNumber: model_CustomerNumber,
            SalesPerson: model_SalesPerson,
            CustomerCategory: model_CustomerCategory,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  Order : {
    QueueOrderOpenOrdersOrReservations: {
      url: function(selectedBranch, licensePlate, customerNo, yourRef, articleNo, orderNo, description, reservationStatusId, deliveryName, markedDoneBy, markedDoneDate, markedDone, reportType, agreedDoneFrom, agreedDoneTo, orderDateFrom, orderDateTo, mainGroupFrom, mainGroupTo, subGroupFrom, subGroupTo, onlyInStorage, changedBy, reportListType) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/QueueOrderOpenOrdersOrReservations';
        }
        var f_args = this.argsObject(selectedBranch, licensePlate, customerNo, yourRef, articleNo, orderNo, description, reservationStatusId, deliveryName, markedDoneBy, markedDoneDate, markedDone, reportType, agreedDoneFrom, agreedDoneTo, orderDateFrom, orderDateTo, mainGroupFrom, mainGroupTo, subGroupFrom, subGroupTo, onlyInStorage, changedBy, reportListType);
        return $menu.getRootUrl() + '/OrderMVC/Order/QueueOrderOpenOrdersOrReservations' + '?' + $.param(f_args);
      },
      argsObject: function(selectedBranch, licensePlate, customerNo, yourRef, articleNo, orderNo, description, reservationStatusId, deliveryName, markedDoneBy, markedDoneDate, markedDone, reportType, agreedDoneFrom, agreedDoneTo, orderDateFrom, orderDateTo, mainGroupFrom, mainGroupTo, subGroupFrom, subGroupTo, onlyInStorage, changedBy, reportListType) {
        var f_args = {
          selectedBranch: selectedBranch,
          licensePlate: licensePlate,
          customerNo: customerNo,
          yourRef: yourRef,
          articleNo: articleNo,
          orderNo: orderNo,
          description: description,
          reservationStatusId: reservationStatusId,
          deliveryName: deliveryName,
          markedDoneBy: markedDoneBy,
          markedDoneDate: markedDoneDate,
          markedDone: markedDone,
          reportType: reportType,
          agreedDoneFrom: agreedDoneFrom,
          agreedDoneTo: agreedDoneTo,
          orderDateFrom: orderDateFrom,
          orderDateTo: orderDateTo,
          mainGroupFrom: mainGroupFrom,
          mainGroupTo: mainGroupTo,
          subGroupFrom: subGroupFrom,
          subGroupTo: subGroupTo,
          onlyInStorage: onlyInStorage,
          changedBy: changedBy,
          reportListType: reportListType,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetOrderDetailsReportInfo: {
      url: function(orderId, branchId, orderTypeId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/GetOrderDetailsReportInfo';
        }
        var f_args = this.argsObject(orderId, branchId, orderTypeId);
        return $menu.getRootUrl() + '/OrderMVC/Order/GetOrderDetailsReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, branchId, orderTypeId) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
          orderTypeId: orderTypeId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GenerateOrderPdfReport: {
      url: function(orderId, branchId, licensePlate, orderTypeId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/GenerateOrderPdfReport';
        }
        var f_args = this.argsObject(orderId, branchId, licensePlate, orderTypeId);
        return $menu.getRootUrl() + '/OrderMVC/Order/GenerateOrderPdfReport' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, branchId, licensePlate, orderTypeId) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
          licensePlate: licensePlate,
          orderTypeId: orderTypeId,
        };
        return f_args;
      },
      kendoWindow: function(orderId, branchId, licensePlate, orderTypeId, kendoWindowOptions) {
        var f_url = this.url(orderId, branchId, licensePlate, orderTypeId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(orderId,branchId,licensePlate,orderTypeId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetPackingOrderReportInfo: {
      url: function(orderId, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/GetPackingOrderReportInfo';
        }
        var f_args = this.argsObject(orderId, branchId);
        return $menu.getRootUrl() + '/OrderMVC/Order/GetPackingOrderReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, branchId) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetReservationWorkorderReportInfo: {
      url: function(orderId, branchId, eventId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/GetReservationWorkorderReportInfo';
        }
        var f_args = this.argsObject(orderId, branchId, eventId);
        return $menu.getRootUrl() + '/OrderMVC/Order/GetReservationWorkorderReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, branchId, eventId) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
          eventId: eventId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetReservationLabelReportInfo: {
      url: function(orderId, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/GetReservationLabelReportInfo';
        }
        var f_args = this.argsObject(orderId, branchId);
        return $menu.getRootUrl() + '/OrderMVC/Order/GetReservationLabelReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, branchId) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetDeliveryNoteCanceledPrintScript: {
      url: function(branchId, orderId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/GetDeliveryNoteCanceledPrintScript';
        }
        var f_args = this.argsObject(branchId, orderId);
        return $menu.getRootUrl() + '/OrderMVC/Order/GetDeliveryNoteCanceledPrintScript' + '?' + $.param(f_args);
      },
      argsObject: function(branchId, orderId) {
        var f_args = {
          branchId: branchId,
          orderId: orderId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetInvoicePrintFromOrder: {
      url: function(branchId, orderId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/GetInvoicePrintFromOrder';
        }
        var f_args = this.argsObject(branchId, orderId);
        return $menu.getRootUrl() + '/OrderMVC/Order/GetInvoicePrintFromOrder' + '?' + $.param(f_args);
      },
      argsObject: function(branchId, orderId) {
        var f_args = {
          branchId: branchId,
          orderId: orderId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetWaybillPrintFromOrder: {
      url: function(branchId, orderId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/GetWaybillPrintFromOrder';
        }
        var f_args = this.argsObject(branchId, orderId);
        return $menu.getRootUrl() + '/OrderMVC/Order/GetWaybillPrintFromOrder' + '?' + $.param(f_args);
      },
      argsObject: function(branchId, orderId) {
        var f_args = {
          branchId: branchId,
          orderId: orderId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    SyncWMSOrder: {
      url: function(orderId, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/SyncWMSOrder';
        }
        var f_args = this.argsObject(orderId, branchId);
        return $menu.getRootUrl() + '/OrderMVC/Order/SyncWMSOrder' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, branchId) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    OrderHasSupplierOrderConnection: {
      url: function(orderId, sellerBranchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/OrderHasSupplierOrderConnection';
        }
        var f_args = this.argsObject(orderId, sellerBranchId);
        return $menu.getRootUrl() + '/OrderMVC/Order/OrderHasSupplierOrderConnection' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, sellerBranchId) {
        var f_args = {
          orderId: orderId,
          sellerBranchId: sellerBranchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    SendGenericButtonRequest: {
      url: function(Id, BranchId, CompanyOrganisationNumber, CompanyCountryCode, CustomerNumber, SellerBranchId, OrderNumber, LicensePlate, Odometer) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/SendGenericButtonRequest';
        }
        var f_args = this.argsObject(Id, BranchId, CompanyOrganisationNumber, CompanyCountryCode, CustomerNumber, SellerBranchId, OrderNumber, LicensePlate, Odometer);
        return $menu.getRootUrl() + '/OrderMVC/Order/SendGenericButtonRequest' + '?' + $.param(f_args);
      },
      argsObject: function(Id, BranchId, CompanyOrganisationNumber, CompanyCountryCode, CustomerNumber, SellerBranchId, OrderNumber, LicensePlate, Odometer) {
        var f_args = {
          Id: Id,
          BranchId: BranchId,
          CompanyOrganisationNumber: CompanyOrganisationNumber,
          CompanyCountryCode: CompanyCountryCode,
          CustomerNumber: CustomerNumber,
          SellerBranchId: SellerBranchId,
          OrderNumber: OrderNumber,
          LicensePlate: LicensePlate,
          Odometer: Odometer,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetFinalizeOrderResultView: {
      url: function(Finalized, DownPaymentSuccess, DownPaymentRefund, FinalizeOrderErrorCode, TranslatedFinalizeOrderExceptionMessage, OrderId, BranchId, PrintA4Receipt, PrintReceipt, PrintWorkorder, CashReceiptId, PointOfSaleId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/GetFinalizeOrderResultView';
        }
        var f_args = this.argsObject(Finalized, DownPaymentSuccess, DownPaymentRefund, FinalizeOrderErrorCode, TranslatedFinalizeOrderExceptionMessage, OrderId, BranchId, PrintA4Receipt, PrintReceipt, PrintWorkorder, CashReceiptId, PointOfSaleId);
        return $menu.getRootUrl() + '/OrderMVC/Order/GetFinalizeOrderResultView' + '?' + $.param(f_args);
      },
      argsObject: function(Finalized, DownPaymentSuccess, DownPaymentRefund, FinalizeOrderErrorCode, TranslatedFinalizeOrderExceptionMessage, OrderId, BranchId, PrintA4Receipt, PrintReceipt, PrintWorkorder, CashReceiptId, PointOfSaleId) {
        var f_args = {
          Finalized: Finalized,
          DownPaymentSuccess: DownPaymentSuccess,
          DownPaymentRefund: DownPaymentRefund,
          FinalizeOrderErrorCode: FinalizeOrderErrorCode,
          TranslatedFinalizeOrderExceptionMessage: TranslatedFinalizeOrderExceptionMessage,
          OrderId: OrderId,
          BranchId: BranchId,
          PrintA4Receipt: PrintA4Receipt,
          PrintReceipt: PrintReceipt,
          PrintWorkorder: PrintWorkorder,
          CashReceiptId: CashReceiptId,
          PointOfSaleId: PointOfSaleId,
        };
        return f_args;
      },
      kendoWindow: function(Finalized, DownPaymentSuccess, DownPaymentRefund, FinalizeOrderErrorCode, TranslatedFinalizeOrderExceptionMessage, OrderId, BranchId, PrintA4Receipt, PrintReceipt, PrintWorkorder, CashReceiptId, PointOfSaleId, kendoWindowOptions) {
        var f_url = this.url(Finalized, DownPaymentSuccess, DownPaymentRefund, FinalizeOrderErrorCode, TranslatedFinalizeOrderExceptionMessage, OrderId, BranchId, PrintA4Receipt, PrintReceipt, PrintWorkorder, CashReceiptId, PointOfSaleId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(finalizeOrderResult, kendoWindowOptions) {
        var f_url = this.url(finalizeOrderResult.Finalized, finalizeOrderResult.DownPaymentSuccess, finalizeOrderResult.DownPaymentRefund, finalizeOrderResult.FinalizeOrderErrorCode, finalizeOrderResult.TranslatedFinalizeOrderExceptionMessage, finalizeOrderResult.OrderId, finalizeOrderResult.BranchId, finalizeOrderResult.PrintA4Receipt, finalizeOrderResult.PrintReceipt, finalizeOrderResult.PrintWorkorder, finalizeOrderResult.CashReceiptId, finalizeOrderResult.PointOfSaleId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    CheckStockCoverageForOrder: {
      url: function(orderId, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/CheckStockCoverageForOrder';
        }
        var f_args = this.argsObject(orderId, branchId);
        return $menu.getRootUrl() + '/OrderMVC/Order/CheckStockCoverageForOrder' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, branchId) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    UnsetOrderCharging: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Order/UnsetOrderCharging';
      },
      argsObject: function(orderId, branchId) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    GetCloseOrderView: {
      url: function(orderId, branchId, customerId, isCashCustomer, creditLimitOverrideId, defaultPointOfSaleId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/GetCloseOrderView';
        }
        var f_args = this.argsObject(orderId, branchId, customerId, isCashCustomer, creditLimitOverrideId, defaultPointOfSaleId);
        return $menu.getRootUrl() + '/OrderMVC/Order/GetCloseOrderView' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, branchId, customerId, isCashCustomer, creditLimitOverrideId, defaultPointOfSaleId) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
          customerId: customerId,
          isCashCustomer: isCashCustomer,
          creditLimitOverrideId: creditLimitOverrideId,
          defaultPointOfSaleId: defaultPointOfSaleId,
        };
        return f_args;
      },
      kendoWindow: function(orderId, branchId, customerId, isCashCustomer, creditLimitOverrideId, defaultPointOfSaleId, kendoWindowOptions) {
        var f_url = this.url(orderId, branchId, customerId, isCashCustomer, creditLimitOverrideId, defaultPointOfSaleId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(orderId,branchId,customerId,isCashCustomer,creditLimitOverrideId,defaultPointOfSaleId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    OrderDetails: {
      url1: function(orderId, sellerBranchId, isThirdPartyOrder, eventId, licensePlate, customerNo, contactId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/OrderDetails';
        }
        var f_args = this.argsObject1(orderId, sellerBranchId, isThirdPartyOrder, eventId, licensePlate, customerNo, contactId);
        return $menu.getRootUrl() + '/OrderMVC/Order/OrderDetails' + '?' + $.param(f_args);
      },
      argsObject1: function(orderId, sellerBranchId, isThirdPartyOrder, eventId, licensePlate, customerNo, contactId) {
        var f_args = {
          orderId: orderId,
          sellerBranchId: sellerBranchId,
          isThirdPartyOrder: isThirdPartyOrder,
          eventId: eventId,
          licensePlate: licensePlate,
          customerNo: customerNo,
          contactId: contactId,
        };
        return f_args;
      },
      browserWindow1: function(orderId, sellerBranchId, isThirdPartyOrder, eventId, licensePlate, customerNo, contactId) {
        var f_url = this.url1(orderId, sellerBranchId, isThirdPartyOrder, eventId, licensePlate, customerNo, contactId);
        var f_args = [orderId, sellerBranchId, isThirdPartyOrder, eventId, licensePlate, customerNo, contactId];
        var f_winId = f_args.join('_')
        var f_windowName = undefined;
        if(f_winId.replace(/_/g, '') != '') {
          f_windowName = 'OrderDetails_' + f_args.join('_');
        }
        compilator.windowHandler.openWindowWithFocus(f_url, f_windowName, arguments.length > 0);
      },
      url2: function(storageCardId, orderId, sellerBranchId, shift, articlePackageHeadId, customerId, eventId, licensePlate, vehicleMake) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/OrderDetails';
        }
        var f_args = this.argsObject2(storageCardId, orderId, sellerBranchId, shift, articlePackageHeadId, customerId, eventId, licensePlate, vehicleMake);
        return $menu.getRootUrl() + '/OrderMVC/Order/OrderDetails' + '?' + $.param(f_args);
      },
      argsObject2: function(storageCardId, orderId, sellerBranchId, shift, articlePackageHeadId, customerId, eventId, licensePlate, vehicleMake) {
        var f_args = {
          storageCardId: storageCardId,
          orderId: orderId,
          sellerBranchId: sellerBranchId,
          shift: shift,
          articlePackageHeadId: articlePackageHeadId,
          customerId: customerId,
          eventId: eventId,
          licensePlate: licensePlate,
          vehicleMake: vehicleMake,
        };
        return f_args;
      },
      browserWindow2: function(storageCardId, orderId, sellerBranchId, shift, articlePackageHeadId, customerId, eventId, licensePlate, vehicleMake) {
        var f_url = this.url2(storageCardId, orderId, sellerBranchId, shift, articlePackageHeadId, customerId, eventId, licensePlate, vehicleMake);
        var f_args = [storageCardId, orderId];
        var f_winId = f_args.join('_')
        var f_windowName = undefined;
        if(f_winId.replace(/_/g, '') != '') {
          f_windowName = 'OrderDetails_' + f_args.join('_');
        }
        compilator.windowHandler.openWindowWithFocus(f_url, f_windowName, arguments.length > 0);
      },
    },
    ChangeCloseOrderType: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Order/ChangeCloseOrderType';
      },
      argsObject: function(orderId, branchId, isReservation) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
          isReservation: isReservation,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    SaveOrder: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Order/SaveOrder';
      },
      argsObject: function(order_OrderDate, order_SellerBranchId, order_SellerBranchDisplay, order_OrderId, order_OrderType, order_RowVersion, order_IsClosed, order_IsInvoiced, order_FinalInvoiceNumber, order_SalesPerson, order_StorageCardId, order_CompanyCurrencyCode, order_Currency, order_OrderTags, order_PricelistAgreement, order_Customer, order_DeliveryAddressInfo, order_Vehicle, order_OrderLines, order_PresetNote, order_OrderDetailsTermsOfPayment, order_Footer, order_TotalAmountIncludingVat, order_TotalAmountExcludingVat, order_TotalVatAmount, order_OrderStatus, order_CloseOrderType, order_CleanCashReceiptsPrinted, order_MarkedDone, order_EventId, order_CloseOrderNumber, order_AgreedDoneTime, order_ReservationStatusId, order_SaveOrderType, order_IsWebOrder, order_DownPayment, order_AdyenInformation, order_WmsId, order_CentralWarehouseStatus, order_CentralWarehouseWaybillNumbers, order_OrderWarehouseHistory, order_ShippingConditions, order_BasketTypeId, order_FleetAgreementId, order_LicensePlateRequired, order_CustomerNumberRequired, order_YourReferenceRequired, order_OdometerRequired, order_WorkOrderNumberRequired, order_DeliveryAddressRequired, order_RequisitionOrderNumberRequired, order_DefaultSearchArticlesStockQuantity, order_UseEdiLite, order_LicensePlateInactive, order_YourReferenceInactive, order_OdometerInactive, order_WorkOrderNumberInactive, order_DeliveryAddressInactive, order_VATInactive, order_VATChecked, order_AllowChangeWebOrders, order_DefaultPointOfSaleId, order_FromResursBankCallback, order_ResursBankPaymentSuccess, saveOrderTypeId, connectToStorageCard, connectedToStorageCardId, sendReservationToExternalWarehouse, lockExternalWarehouse) {
        var f_args = {
          order: {
            OrderDate: order_OrderDate,
            SellerBranchId: order_SellerBranchId,
            SellerBranchDisplay: order_SellerBranchDisplay,
            OrderId: order_OrderId,
            OrderType: order_OrderType,
            RowVersion: order_RowVersion,
            IsClosed: order_IsClosed,
            IsInvoiced: order_IsInvoiced,
            FinalInvoiceNumber: order_FinalInvoiceNumber,
            SalesPerson: order_SalesPerson,
            StorageCardId: order_StorageCardId,
            CompanyCurrencyCode: order_CompanyCurrencyCode,
            Currency: order_Currency,
            OrderTags: order_OrderTags,
            PricelistAgreement: order_PricelistAgreement,
            Customer: order_Customer,
            DeliveryAddressInfo: order_DeliveryAddressInfo,
            Vehicle: order_Vehicle,
            OrderLines: order_OrderLines,
            PresetNote: order_PresetNote,
            OrderDetailsTermsOfPayment: order_OrderDetailsTermsOfPayment,
            Footer: order_Footer,
            TotalAmountIncludingVat: order_TotalAmountIncludingVat,
            TotalAmountExcludingVat: order_TotalAmountExcludingVat,
            TotalVatAmount: order_TotalVatAmount,
            OrderStatus: order_OrderStatus,
            CloseOrderType: order_CloseOrderType,
            CleanCashReceiptsPrinted: order_CleanCashReceiptsPrinted,
            MarkedDone: order_MarkedDone,
            EventId: order_EventId,
            CloseOrderNumber: order_CloseOrderNumber,
            AgreedDoneTime: order_AgreedDoneTime,
            ReservationStatusId: order_ReservationStatusId,
            SaveOrderType: order_SaveOrderType,
            IsWebOrder: order_IsWebOrder,
            DownPayment: order_DownPayment,
            AdyenInformation: order_AdyenInformation,
            WmsId: order_WmsId,
            CentralWarehouseStatus: order_CentralWarehouseStatus,
            CentralWarehouseWaybillNumbers: order_CentralWarehouseWaybillNumbers,
            OrderWarehouseHistory: order_OrderWarehouseHistory,
            ShippingConditions: order_ShippingConditions,
            BasketTypeId: order_BasketTypeId,
            FleetAgreementId: order_FleetAgreementId,
            LicensePlateRequired: order_LicensePlateRequired,
            CustomerNumberRequired: order_CustomerNumberRequired,
            YourReferenceRequired: order_YourReferenceRequired,
            OdometerRequired: order_OdometerRequired,
            WorkOrderNumberRequired: order_WorkOrderNumberRequired,
            DeliveryAddressRequired: order_DeliveryAddressRequired,
            RequisitionOrderNumberRequired: order_RequisitionOrderNumberRequired,
            DefaultSearchArticlesStockQuantity: order_DefaultSearchArticlesStockQuantity,
            UseEdiLite: order_UseEdiLite,
            LicensePlateInactive: order_LicensePlateInactive,
            YourReferenceInactive: order_YourReferenceInactive,
            OdometerInactive: order_OdometerInactive,
            WorkOrderNumberInactive: order_WorkOrderNumberInactive,
            DeliveryAddressInactive: order_DeliveryAddressInactive,
            VATInactive: order_VATInactive,
            VATChecked: order_VATChecked,
            AllowChangeWebOrders: order_AllowChangeWebOrders,
            DefaultPointOfSaleId: order_DefaultPointOfSaleId,
            FromResursBankCallback: order_FromResursBankCallback,
            ResursBankPaymentSuccess: order_ResursBankPaymentSuccess,
          },
          saveOrderTypeId: saveOrderTypeId,
          connectToStorageCard: connectToStorageCard,
          connectedToStorageCardId: connectedToStorageCardId,
          sendReservationToExternalWarehouse: sendReservationToExternalWarehouse,
          lockExternalWarehouse: lockExternalWarehouse,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    CancelDeliveryNote: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Order/CancelDeliveryNote';
      },
      argsObject: function(id, branchId) {
        var f_args = {
          id: id,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    DeleteOrder: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Order/DeleteOrder';
      },
      argsObject: function(orderId, branchId, keepDownPayment) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
          keepDownPayment: keepDownPayment,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    PrintOrderOpenOrdersOrReservationsView: {
      url: function(selectedBranch, licensePlate, customerNo, yourRef, articleNo, orderNo, orderTypes, description, orderStatus, reservationStatus, deliveryName, markedDoneBy, markedDoneDate, markedDone) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/PrintOrderOpenOrdersOrReservationsView';
        }
        var f_args = this.argsObject(selectedBranch, licensePlate, customerNo, yourRef, articleNo, orderNo, orderTypes, description, orderStatus, reservationStatus, deliveryName, markedDoneBy, markedDoneDate, markedDone);
        return $menu.getRootUrl() + '/OrderMVC/Order/PrintOrderOpenOrdersOrReservationsView' + '?' + $.param(f_args);
      },
      argsObject: function(selectedBranch, licensePlate, customerNo, yourRef, articleNo, orderNo, orderTypes, description, orderStatus, reservationStatus, deliveryName, markedDoneBy, markedDoneDate, markedDone) {
        var f_args = {
          selectedBranch: selectedBranch,
          licensePlate: licensePlate,
          customerNo: customerNo,
          yourRef: yourRef,
          articleNo: articleNo,
          orderNo: orderNo,
          orderTypes: orderTypes,
          description: description,
          orderStatus: orderStatus,
          reservationStatus: reservationStatus,
          deliveryName: deliveryName,
          markedDoneBy: markedDoneBy,
          markedDoneDate: markedDoneDate,
          markedDone: markedDone,
        };
        return f_args;
      },
      kendoWindow: function(selectedBranch, licensePlate, customerNo, yourRef, articleNo, orderNo, orderTypes, description, orderStatus, reservationStatus, deliveryName, markedDoneBy, markedDoneDate, markedDone, kendoWindowOptions) {
        var f_url = this.url(selectedBranch, licensePlate, customerNo, yourRef, articleNo, orderNo, orderTypes, description, orderStatus, reservationStatus, deliveryName, markedDoneBy, markedDoneDate, markedDone);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(selectedBranch,licensePlate,customerNo,yourRef,articleNo,orderNo,orderTypes,description,orderStatus,reservationStatus,deliveryName,markedDoneBy,markedDoneDate,markedDone, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SearchExternalCentralWarehouseReservations: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Order/SearchExternalCentralWarehouseReservations';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    UnlockExternalCentralWarehouseReservations: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Order/UnlockExternalCentralWarehouseReservations';
      },
      argsObject: function(items) {
        var f_args = {
          items: items,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    LockExternalCentralWarehouseReservations: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Order/LockExternalCentralWarehouseReservations';
      },
      argsObject: function(items) {
        var f_args = {
          items: items,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    FinalizeExternalCentralWarehouseReservations: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Order/FinalizeExternalCentralWarehouseReservations';
      },
      argsObject: function(items) {
        var f_args = {
          items: items,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    SearchCustomer: {
      url: function(customerNumber, orderId, sellerBranchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/SearchCustomer';
        }
        var f_args = this.argsObject(customerNumber, orderId, sellerBranchId);
        return $menu.getRootUrl() + '/OrderMVC/Order/SearchCustomer' + '?' + $.param(f_args);
      },
      argsObject: function(customerNumber, orderId, sellerBranchId) {
        var f_args = {
          customerNumber: customerNumber,
          orderId: orderId,
          sellerBranchId: sellerBranchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    AddCustomerOrderReasonView: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Order/AddCustomerOrderReasonView';
      },
      argsObject: function(model_CustomerId, model_OrderId, model_SellerBranchId, model_CustomerOrderReasonSettings, model_OrderLines) {
        var f_args = {
          model: {
            CustomerId: model_CustomerId,
            OrderId: model_OrderId,
            SellerBranchId: model_SellerBranchId,
            CustomerOrderReasonSettings: model_CustomerOrderReasonSettings,
            OrderLines: model_OrderLines,
          },
        };
        return f_args;
      },
      kendoWindow: function(data, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow('', kendoWindowOptions);
        f_window.refresh({
          url: f_url,
          data: JSON.stringify(data),
          contentType: 'application/json',
          type: 'POST'
        });
        return f_window;
      },
    },
    OpenCashBox: {
      url: function(pointOfSaleId, reason) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/OpenCashBox';
        }
        var f_args = this.argsObject(pointOfSaleId, reason);
        return $menu.getRootUrl() + '/OrderMVC/Order/OpenCashBox' + '?' + $.param(f_args);
      },
      argsObject: function(pointOfSaleId, reason) {
        var f_args = {
          pointOfSaleId: pointOfSaleId,
          reason: reason,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    PointOfSaleHasCashBox: {
      url: function(pointOfSaleId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/PointOfSaleHasCashBox';
        }
        var f_args = this.argsObject(pointOfSaleId);
        return $menu.getRootUrl() + '/OrderMVC/Order/PointOfSaleHasCashBox' + '?' + $.param(f_args);
      },
      argsObject: function(pointOfSaleId) {
        var f_args = {
          pointOfSaleId: pointOfSaleId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetCustomerInformationByLicensePlate: {
      url: function(licensePlate, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/GetCustomerInformationByLicensePlate';
        }
        var f_args = this.argsObject(licensePlate, branchId);
        return $menu.getRootUrl() + '/OrderMVC/Order/GetCustomerInformationByLicensePlate' + '?' + $.param(f_args);
      },
      argsObject: function(licensePlate, branchId) {
        var f_args = {
          licensePlate: licensePlate,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetCustomerInformationView: {
      url: function(customerId, Note, DocumentPath) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/GetCustomerInformationView';
        }
        var f_args = this.argsObject(customerId, Note, DocumentPath);
        return $menu.getRootUrl() + '/OrderMVC/Order/GetCustomerInformationView' + '?' + $.param(f_args);
      },
      argsObject: function(customerId, Note, DocumentPath) {
        var f_args = {
          customerId: customerId,
          Note: Note,
          DocumentPath: DocumentPath,
        };
        return f_args;
      },
      kendoWindow: function(customerId, Note, DocumentPath, kendoWindowOptions) {
        var f_url = this.url(customerId, Note, DocumentPath);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(customerId,customerInformation, kendoWindowOptions) {
        var f_url = this.url(customerInformation.Note, customerInformation.DocumentPath);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetCustomerInformationViewByCustomerNumber: {
      url: function(customerNumber) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/GetCustomerInformationViewByCustomerNumber';
        }
        var f_args = this.argsObject(customerNumber);
        return $menu.getRootUrl() + '/OrderMVC/Order/GetCustomerInformationViewByCustomerNumber' + '?' + $.param(f_args);
      },
      argsObject: function(customerNumber) {
        var f_args = {
          customerNumber: customerNumber,
        };
        return f_args;
      },
      kendoWindow: function(customerNumber, kendoWindowOptions) {
        var f_url = this.url(customerNumber);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(customerNumber, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    IsCustomerInternal: {
      url: function(customerNo) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/IsCustomerInternal';
        }
        var f_args = this.argsObject(customerNo);
        return $menu.getRootUrl() + '/OrderMVC/Order/IsCustomerInternal' + '?' + $.param(f_args);
      },
      argsObject: function(customerNo) {
        var f_args = {
          customerNo: customerNo,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetCustomerFleetSettings: {
      url: function(customerNo) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/GetCustomerFleetSettings';
        }
        var f_args = this.argsObject(customerNo);
        return $menu.getRootUrl() + '/OrderMVC/Order/GetCustomerFleetSettings' + '?' + $.param(f_args);
      },
      argsObject: function(customerNo) {
        var f_args = {
          customerNo: customerNo,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    IsFleetOrderValid: {
      url: function(customerNo, fleetAgreementId, licensePlate, useAgreement, forceAgreement, useLicensePlate, forceLicensePlate) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/IsFleetOrderValid';
        }
        var f_args = this.argsObject(customerNo, fleetAgreementId, licensePlate, useAgreement, forceAgreement, useLicensePlate, forceLicensePlate);
        return $menu.getRootUrl() + '/OrderMVC/Order/IsFleetOrderValid' + '?' + $.param(f_args);
      },
      argsObject: function(customerNo, fleetAgreementId, licensePlate, useAgreement, forceAgreement, useLicensePlate, forceLicensePlate) {
        var f_args = {
          customerNo: customerNo,
          fleetAgreementId: fleetAgreementId,
          licensePlate: licensePlate,
          useAgreement: useAgreement,
          forceAgreement: forceAgreement,
          useLicensePlate: useLicensePlate,
          forceLicensePlate: forceLicensePlate,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetSaveOrderView: {
      url: function(branchId, orderId, agreedDoneTime, licensePlate, orderSumInclVAT, hasAlteredArticleDescription, printAmount, hasDeliveryAddress, isAffectingStock, connectedStorageCardId, saveOrderType) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/GetSaveOrderView';
        }
        var f_args = this.argsObject(branchId, orderId, agreedDoneTime, licensePlate, orderSumInclVAT, hasAlteredArticleDescription, printAmount, hasDeliveryAddress, isAffectingStock, connectedStorageCardId, saveOrderType);
        return $menu.getRootUrl() + '/OrderMVC/Order/GetSaveOrderView' + '?' + $.param(f_args);
      },
      argsObject: function(branchId, orderId, agreedDoneTime, licensePlate, orderSumInclVAT, hasAlteredArticleDescription, printAmount, hasDeliveryAddress, isAffectingStock, connectedStorageCardId, saveOrderType) {
        var f_args = {
          branchId: branchId,
          orderId: orderId,
          agreedDoneTime: agreedDoneTime,
          licensePlate: licensePlate,
          orderSumInclVAT: orderSumInclVAT,
          hasAlteredArticleDescription: hasAlteredArticleDescription,
          printAmount: printAmount,
          hasDeliveryAddress: hasDeliveryAddress,
          isAffectingStock: isAffectingStock,
          connectedStorageCardId: connectedStorageCardId,
          saveOrderType: saveOrderType,
        };
        return f_args;
      },
      kendoWindow: function(branchId, orderId, agreedDoneTime, licensePlate, orderSumInclVAT, hasAlteredArticleDescription, printAmount, hasDeliveryAddress, isAffectingStock, connectedStorageCardId, saveOrderType, kendoWindowOptions) {
        var f_url = this.url(branchId, orderId, agreedDoneTime, licensePlate, orderSumInclVAT, hasAlteredArticleDescription, printAmount, hasDeliveryAddress, isAffectingStock, connectedStorageCardId, saveOrderType);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(branchId,orderId,agreedDoneTime,licensePlate,orderSumInclVAT,hasAlteredArticleDescription,printAmount,hasDeliveryAddress,isAffectingStock,connectedStorageCardId,saveOrderType, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetOrderDoneView: {
      url: function(branchId, orderId, currentlyMarked) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/GetOrderDoneView';
        }
        var f_args = this.argsObject(branchId, orderId, currentlyMarked);
        return $menu.getRootUrl() + '/OrderMVC/Order/GetOrderDoneView' + '?' + $.param(f_args);
      },
      argsObject: function(branchId, orderId, currentlyMarked) {
        var f_args = {
          branchId: branchId,
          orderId: orderId,
          currentlyMarked: currentlyMarked,
        };
        return f_args;
      },
      kendoWindow: function(branchId, orderId, currentlyMarked, kendoWindowOptions) {
        var f_url = this.url(branchId, orderId, currentlyMarked);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(branchId,orderId,currentlyMarked, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    UpdateCustomerInformation: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Order/UpdateCustomerInformation';
      },
      argsObject: function(customerId, note) {
        var f_args = {
          customerId: customerId,
          note: note,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, undefined, ajaxData);
      },
    },
    SearchArticleAutoSuggest: {
      url: function(searchText, pricelistId, includeServiceArticles) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/SearchArticleAutoSuggest';
        }
        var f_args = this.argsObject(searchText, pricelistId, includeServiceArticles);
        return $menu.getRootUrl() + '/OrderMVC/Order/SearchArticleAutoSuggest' + '?' + $.param(f_args);
      },
      argsObject: function(searchText, pricelistId, includeServiceArticles) {
        var f_args = {
          searchText: searchText,
          pricelistId: pricelistId,
          includeServiceArticles: includeServiceArticles,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    AddArticleOrderLine: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Order/AddArticleOrderLine';
      },
      argsObject: function(searchCriterias_SearchText, searchCriterias_BranchId, searchCriterias_RetailPricelistId, searchCriterias_AgreementId, searchCriterias_CustomerId, searchCriterias_StockId, searchCriterias_LineNumber, searchCriterias_IncludeRecyclefee, searchCriterias_IncludeArticlePackage, searchCriterias_IncludeVat, searchCriterias_DisplayVat, searchCriterias_OrderType) {
        var f_args = {
          searchCriterias: {
            SearchText: searchCriterias_SearchText,
            BranchId: searchCriterias_BranchId,
            RetailPricelistId: searchCriterias_RetailPricelistId,
            AgreementId: searchCriterias_AgreementId,
            CustomerId: searchCriterias_CustomerId,
            StockId: searchCriterias_StockId,
            LineNumber: searchCriterias_LineNumber,
            IncludeRecyclefee: searchCriterias_IncludeRecyclefee,
            IncludeArticlePackage: searchCriterias_IncludeArticlePackage,
            IncludeVat: searchCriterias_IncludeVat,
            DisplayVat: searchCriterias_DisplayVat,
            OrderType: searchCriterias_OrderType,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    AddArticleOrderLines: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Order/AddArticleOrderLines';
      },
      argsObject: function(searchCriterias_ArticleIds, searchCriterias_BranchId, searchCriterias_RetailPricelistId, searchCriterias_AgreementId, searchCriterias_CustomerId, searchCriterias_StockId, searchCriterias_LineNumber, searchCriterias_IncludeRecyclefee, searchCriterias_IncludeArticlePackage, searchCriterias_IncludeVat, searchCriterias_DisplayVat, searchCriterias_OrderType) {
        var f_args = {
          searchCriterias: {
            ArticleIds: searchCriterias_ArticleIds,
            BranchId: searchCriterias_BranchId,
            RetailPricelistId: searchCriterias_RetailPricelistId,
            AgreementId: searchCriterias_AgreementId,
            CustomerId: searchCriterias_CustomerId,
            StockId: searchCriterias_StockId,
            LineNumber: searchCriterias_LineNumber,
            IncludeRecyclefee: searchCriterias_IncludeRecyclefee,
            IncludeArticlePackage: searchCriterias_IncludeArticlePackage,
            IncludeVat: searchCriterias_IncludeVat,
            DisplayVat: searchCriterias_DisplayVat,
            OrderType: searchCriterias_OrderType,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    UpdateOrderArticlesByCustomer: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Order/UpdateOrderArticlesByCustomer';
      },
      argsObject: function(customerId, branchId, currentCurrency_Id, currentCurrency_Name, currentCurrency_Code, currentCurrency_Rate, currentCurrency_RateDisplay, currentCurrency_CurrentRate, currentCurrency_RoundingFactor, orderLines, includeArticlePackage, displayVat, agreementType) {
        var f_args = {
          customerId: customerId,
          branchId: branchId,
          currentCurrency: {
            Id: currentCurrency_Id,
            Name: currentCurrency_Name,
            Code: currentCurrency_Code,
            Rate: currentCurrency_Rate,
            RateDisplay: currentCurrency_RateDisplay,
            CurrentRate: currentCurrency_CurrentRate,
            RoundingFactor: currentCurrency_RoundingFactor,
          },
          orderLines: orderLines,
          includeArticlePackage: includeArticlePackage,
          displayVat: displayVat,
          agreementType: agreementType,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    GetNotAllowedArticles: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Order/GetNotAllowedArticles';
      },
      argsObject: function(customerNumber, branchId, orderLines) {
        var f_args = {
          customerNumber: customerNumber,
          branchId: branchId,
          orderLines: orderLines,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    GetOrderArticleLineSummary: {
      url: function(orderNo, branch) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/GetOrderArticleLineSummary';
        }
        var f_args = this.argsObject(orderNo, branch);
        return $menu.getRootUrl() + '/OrderMVC/Order/GetOrderArticleLineSummary' + '?' + $.param(f_args);
      },
      argsObject: function(orderNo, branch) {
        var f_args = {
          orderNo: orderNo,
          branch: branch,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    SearchArticlesFilterCriteria: {
      url: function(Methods, SearchIdentifier, ArticleTemplateId, MainGroupId, BranchId, StockId, DimensionText, SectionWidth, AspectRatio, RimDiameter, SpeedRating, LoadIndex, MinimumInStock, SearchText, CustomerId, AgreementId, RetailPricelistId, RetailPriceListCurrencyRate, OrderType, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, EDISearch, RFT, ExtraLoad, Ply, RimWidth, CentreBore, CircleDiameter, Design, RimNumberOfLugs, WheelOffset, Valve) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/SearchArticlesFilterCriteria';
        }
        var f_args = this.argsObject(Methods, SearchIdentifier, ArticleTemplateId, MainGroupId, BranchId, StockId, DimensionText, SectionWidth, AspectRatio, RimDiameter, SpeedRating, LoadIndex, MinimumInStock, SearchText, CustomerId, AgreementId, RetailPricelistId, RetailPriceListCurrencyRate, OrderType, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, EDISearch, RFT, ExtraLoad, Ply, RimWidth, CentreBore, CircleDiameter, Design, RimNumberOfLugs, WheelOffset, Valve);
        return $menu.getRootUrl() + '/OrderMVC/Order/SearchArticlesFilterCriteria' + '?' + $.param(f_args);
      },
      argsObject: function(Methods, SearchIdentifier, ArticleTemplateId, MainGroupId, BranchId, StockId, DimensionText, SectionWidth, AspectRatio, RimDiameter, SpeedRating, LoadIndex, MinimumInStock, SearchText, CustomerId, AgreementId, RetailPricelistId, RetailPriceListCurrencyRate, OrderType, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, EDISearch, RFT, ExtraLoad, Ply, RimWidth, CentreBore, CircleDiameter, Design, RimNumberOfLugs, WheelOffset, Valve) {
        var f_args = {
          Methods: Methods,
          SearchIdentifier: SearchIdentifier,
          ArticleTemplateId: ArticleTemplateId,
          MainGroupId: MainGroupId,
          BranchId: BranchId,
          StockId: StockId,
          DimensionText: DimensionText,
          SectionWidth: SectionWidth,
          AspectRatio: AspectRatio,
          RimDiameter: RimDiameter,
          SpeedRating: SpeedRating,
          LoadIndex: LoadIndex,
          MinimumInStock: MinimumInStock,
          SearchText: SearchText,
          CustomerId: CustomerId,
          AgreementId: AgreementId,
          RetailPricelistId: RetailPricelistId,
          RetailPriceListCurrencyRate: RetailPriceListCurrencyRate,
          OrderType: OrderType,
          CurrencyId: CurrencyId,
          OrderCurrencyRate: OrderCurrencyRate,
          SupplierArticleNumber: SupplierArticleNumber,
          ArticleNumber: ArticleNumber,
          EanNumber: EanNumber,
          EDISearch: EDISearch,
          RFT: RFT,
          ExtraLoad: ExtraLoad,
          Ply: Ply,
          RimWidth: RimWidth,
          CentreBore: CentreBore,
          CircleDiameter: CircleDiameter,
          Design: Design,
          RimNumberOfLugs: RimNumberOfLugs,
          WheelOffset: WheelOffset,
          Valve: Valve,
        };
        return f_args;
      },
      kendoWindow: function(Methods, SearchIdentifier, ArticleTemplateId, MainGroupId, BranchId, StockId, DimensionText, SectionWidth, AspectRatio, RimDiameter, SpeedRating, LoadIndex, MinimumInStock, SearchText, CustomerId, AgreementId, RetailPricelistId, RetailPriceListCurrencyRate, OrderType, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, EDISearch, RFT, ExtraLoad, Ply, RimWidth, CentreBore, CircleDiameter, Design, RimNumberOfLugs, WheelOffset, Valve, kendoWindowOptions) {
        var f_url = this.url(Methods, SearchIdentifier, ArticleTemplateId, MainGroupId, BranchId, StockId, DimensionText, SectionWidth, AspectRatio, RimDiameter, SpeedRating, LoadIndex, MinimumInStock, SearchText, CustomerId, AgreementId, RetailPricelistId, RetailPriceListCurrencyRate, OrderType, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, EDISearch, RFT, ExtraLoad, Ply, RimWidth, CentreBore, CircleDiameter, Design, RimNumberOfLugs, WheelOffset, Valve);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(model, kendoWindowOptions) {
        var f_url = this.url(model.Methods, model.SearchIdentifier, model.ArticleTemplateId, model.MainGroupId, model.BranchId, model.StockId, model.DimensionText, model.SectionWidth, model.AspectRatio, model.RimDiameter, model.SpeedRating, model.LoadIndex, model.MinimumInStock, model.SearchText, model.CustomerId, model.AgreementId, model.RetailPricelistId, model.RetailPriceListCurrencyRate, model.OrderType, model.CurrencyId, model.OrderCurrencyRate, model.SupplierArticleNumber, model.ArticleNumber, model.EanNumber, model.EDISearch, model.RFT, model.ExtraLoad, model.Ply, model.RimWidth, model.CentreBore, model.CircleDiameter, model.Design, model.RimNumberOfLugs, model.WheelOffset, model.Valve);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SearchArticlesResultListGeneral: {
      url: function(SearchIdentifier, UsesCentralWarehouse) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/SearchArticlesResultListGeneral';
        }
        var f_args = this.argsObject(SearchIdentifier, UsesCentralWarehouse);
        return $menu.getRootUrl() + '/OrderMVC/Order/SearchArticlesResultListGeneral' + '?' + $.param(f_args);
      },
      argsObject: function(SearchIdentifier, UsesCentralWarehouse) {
        var f_args = {
          SearchIdentifier: SearchIdentifier,
          UsesCentralWarehouse: UsesCentralWarehouse,
        };
        return f_args;
      },
      kendoWindow: function(SearchIdentifier, UsesCentralWarehouse, kendoWindowOptions) {
        var f_url = this.url(SearchIdentifier, UsesCentralWarehouse);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(model, kendoWindowOptions) {
        var f_url = this.url(model.SearchIdentifier, model.UsesCentralWarehouse);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SearchArticlesResultListRim: {
      url: function(SearchIdentifier, UsesCentralWarehouse) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/SearchArticlesResultListRim';
        }
        var f_args = this.argsObject(SearchIdentifier, UsesCentralWarehouse);
        return $menu.getRootUrl() + '/OrderMVC/Order/SearchArticlesResultListRim' + '?' + $.param(f_args);
      },
      argsObject: function(SearchIdentifier, UsesCentralWarehouse) {
        var f_args = {
          SearchIdentifier: SearchIdentifier,
          UsesCentralWarehouse: UsesCentralWarehouse,
        };
        return f_args;
      },
      kendoWindow: function(SearchIdentifier, UsesCentralWarehouse, kendoWindowOptions) {
        var f_url = this.url(SearchIdentifier, UsesCentralWarehouse);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(model, kendoWindowOptions) {
        var f_url = this.url(model.SearchIdentifier, model.UsesCentralWarehouse);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SearchArticlesResultListService: {
      url: function(SearchIdentifier, UsesCentralWarehouse) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/SearchArticlesResultListService';
        }
        var f_args = this.argsObject(SearchIdentifier, UsesCentralWarehouse);
        return $menu.getRootUrl() + '/OrderMVC/Order/SearchArticlesResultListService' + '?' + $.param(f_args);
      },
      argsObject: function(SearchIdentifier, UsesCentralWarehouse) {
        var f_args = {
          SearchIdentifier: SearchIdentifier,
          UsesCentralWarehouse: UsesCentralWarehouse,
        };
        return f_args;
      },
      kendoWindow: function(SearchIdentifier, UsesCentralWarehouse, kendoWindowOptions) {
        var f_url = this.url(SearchIdentifier, UsesCentralWarehouse);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(model, kendoWindowOptions) {
        var f_url = this.url(model.SearchIdentifier, model.UsesCentralWarehouse);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SearchArticlesResultListTube: {
      url: function(SearchIdentifier, UsesCentralWarehouse) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/SearchArticlesResultListTube';
        }
        var f_args = this.argsObject(SearchIdentifier, UsesCentralWarehouse);
        return $menu.getRootUrl() + '/OrderMVC/Order/SearchArticlesResultListTube' + '?' + $.param(f_args);
      },
      argsObject: function(SearchIdentifier, UsesCentralWarehouse) {
        var f_args = {
          SearchIdentifier: SearchIdentifier,
          UsesCentralWarehouse: UsesCentralWarehouse,
        };
        return f_args;
      },
      kendoWindow: function(SearchIdentifier, UsesCentralWarehouse, kendoWindowOptions) {
        var f_url = this.url(SearchIdentifier, UsesCentralWarehouse);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(model, kendoWindowOptions) {
        var f_url = this.url(model.SearchIdentifier, model.UsesCentralWarehouse);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SearchArticlesResultListTyre: {
      url: function(SearchIdentifier, UsesCentralWarehouse) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/SearchArticlesResultListTyre';
        }
        var f_args = this.argsObject(SearchIdentifier, UsesCentralWarehouse);
        return $menu.getRootUrl() + '/OrderMVC/Order/SearchArticlesResultListTyre' + '?' + $.param(f_args);
      },
      argsObject: function(SearchIdentifier, UsesCentralWarehouse) {
        var f_args = {
          SearchIdentifier: SearchIdentifier,
          UsesCentralWarehouse: UsesCentralWarehouse,
        };
        return f_args;
      },
      kendoWindow: function(SearchIdentifier, UsesCentralWarehouse, kendoWindowOptions) {
        var f_url = this.url(SearchIdentifier, UsesCentralWarehouse);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(model, kendoWindowOptions) {
        var f_url = this.url(model.SearchIdentifier, model.UsesCentralWarehouse);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SearchArticlesResultListWheel: {
      url: function(SearchIdentifier, UsesCentralWarehouse) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/SearchArticlesResultListWheel';
        }
        var f_args = this.argsObject(SearchIdentifier, UsesCentralWarehouse);
        return $menu.getRootUrl() + '/OrderMVC/Order/SearchArticlesResultListWheel' + '?' + $.param(f_args);
      },
      argsObject: function(SearchIdentifier, UsesCentralWarehouse) {
        var f_args = {
          SearchIdentifier: SearchIdentifier,
          UsesCentralWarehouse: UsesCentralWarehouse,
        };
        return f_args;
      },
      kendoWindow: function(SearchIdentifier, UsesCentralWarehouse, kendoWindowOptions) {
        var f_url = this.url(SearchIdentifier, UsesCentralWarehouse);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(model, kendoWindowOptions) {
        var f_url = this.url(model.SearchIdentifier, model.UsesCentralWarehouse);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SearchArticles: {
      url: function(BranchId, OrderType, OrderCurrencyId, OrderCurrencyCode, OrderCurrencyRate, RetailPricelistId, RetailPricelistCurrencyRate, AgreementId, CustomerId, ShowVAT, IncludeRecycleFee, IncludeArticlePackages, ShowMargin, LicensePlate, Email, AllowShowMargin, UsesCentralWarehouse, DefaultSearchArticlesStockQuantity, UseEdiLite) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/SearchArticles';
        }
        var f_args = this.argsObject(BranchId, OrderType, OrderCurrencyId, OrderCurrencyCode, OrderCurrencyRate, RetailPricelistId, RetailPricelistCurrencyRate, AgreementId, CustomerId, ShowVAT, IncludeRecycleFee, IncludeArticlePackages, ShowMargin, LicensePlate, Email, AllowShowMargin, UsesCentralWarehouse, DefaultSearchArticlesStockQuantity, UseEdiLite);
        return $menu.getRootUrl() + '/OrderMVC/Order/SearchArticles' + '?' + $.param(f_args);
      },
      argsObject: function(BranchId, OrderType, OrderCurrencyId, OrderCurrencyCode, OrderCurrencyRate, RetailPricelistId, RetailPricelistCurrencyRate, AgreementId, CustomerId, ShowVAT, IncludeRecycleFee, IncludeArticlePackages, ShowMargin, LicensePlate, Email, AllowShowMargin, UsesCentralWarehouse, DefaultSearchArticlesStockQuantity, UseEdiLite) {
        var f_args = {
          BranchId: BranchId,
          OrderType: OrderType,
          OrderCurrencyId: OrderCurrencyId,
          OrderCurrencyCode: OrderCurrencyCode,
          OrderCurrencyRate: OrderCurrencyRate,
          RetailPricelistId: RetailPricelistId,
          RetailPricelistCurrencyRate: RetailPricelistCurrencyRate,
          AgreementId: AgreementId,
          CustomerId: CustomerId,
          ShowVAT: ShowVAT,
          IncludeRecycleFee: IncludeRecycleFee,
          IncludeArticlePackages: IncludeArticlePackages,
          ShowMargin: ShowMargin,
          LicensePlate: LicensePlate,
          Email: Email,
          AllowShowMargin: AllowShowMargin,
          UsesCentralWarehouse: UsesCentralWarehouse,
          DefaultSearchArticlesStockQuantity: DefaultSearchArticlesStockQuantity,
          UseEdiLite: UseEdiLite,
        };
        return f_args;
      },
      kendoWindow: function(BranchId, OrderType, OrderCurrencyId, OrderCurrencyCode, OrderCurrencyRate, RetailPricelistId, RetailPricelistCurrencyRate, AgreementId, CustomerId, ShowVAT, IncludeRecycleFee, IncludeArticlePackages, ShowMargin, LicensePlate, Email, AllowShowMargin, UsesCentralWarehouse, DefaultSearchArticlesStockQuantity, UseEdiLite, kendoWindowOptions) {
        var f_url = this.url(BranchId, OrderType, OrderCurrencyId, OrderCurrencyCode, OrderCurrencyRate, RetailPricelistId, RetailPricelistCurrencyRate, AgreementId, CustomerId, ShowVAT, IncludeRecycleFee, IncludeArticlePackages, ShowMargin, LicensePlate, Email, AllowShowMargin, UsesCentralWarehouse, DefaultSearchArticlesStockQuantity, UseEdiLite);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(searchArticlesModel, kendoWindowOptions) {
        var f_url = this.url(searchArticlesModel.BranchId, searchArticlesModel.OrderType, searchArticlesModel.OrderCurrencyId, searchArticlesModel.OrderCurrencyCode, searchArticlesModel.OrderCurrencyRate, searchArticlesModel.RetailPricelistId, searchArticlesModel.RetailPricelistCurrencyRate, searchArticlesModel.AgreementId, searchArticlesModel.CustomerId, searchArticlesModel.ShowVAT, searchArticlesModel.IncludeRecycleFee, searchArticlesModel.IncludeArticlePackages, searchArticlesModel.ShowMargin, searchArticlesModel.LicensePlate, searchArticlesModel.Email, searchArticlesModel.AllowShowMargin, searchArticlesModel.UsesCentralWarehouse, searchArticlesModel.DefaultSearchArticlesStockQuantity, searchArticlesModel.UseEdiLite);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    IsOrderStatusOpen: {
      url: function(sellerBranchId, orderId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/IsOrderStatusOpen';
        }
        var f_args = this.argsObject(sellerBranchId, orderId);
        return $menu.getRootUrl() + '/OrderMVC/Order/IsOrderStatusOpen' + '?' + $.param(f_args);
      },
      argsObject: function(sellerBranchId, orderId) {
        var f_args = {
          sellerBranchId: sellerBranchId,
          orderId: orderId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    ShareArticles: {
      url: function(Email, IncludeTyreScan, TyreScanDate, TyreScanFileId, ExpireDate, Reference, Message, AllSharedArticles, CompanyName, Street, PostalCode, Town, Phone, CultureId, PricesIncludingVat, PricesIncludingRecycleFee, PricesIncludingArticlePackage, BranchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/ShareArticles';
        }
        var f_args = this.argsObject(Email, IncludeTyreScan, TyreScanDate, TyreScanFileId, ExpireDate, Reference, Message, AllSharedArticles, CompanyName, Street, PostalCode, Town, Phone, CultureId, PricesIncludingVat, PricesIncludingRecycleFee, PricesIncludingArticlePackage, BranchId);
        return $menu.getRootUrl() + '/OrderMVC/Order/ShareArticles' + '?' + $.param(f_args);
      },
      argsObject: function(Email, IncludeTyreScan, TyreScanDate, TyreScanFileId, ExpireDate, Reference, Message, AllSharedArticles, CompanyName, Street, PostalCode, Town, Phone, CultureId, PricesIncludingVat, PricesIncludingRecycleFee, PricesIncludingArticlePackage, BranchId) {
        var f_args = {
          Email: Email,
          IncludeTyreScan: IncludeTyreScan,
          TyreScanDate: TyreScanDate,
          TyreScanFileId: TyreScanFileId,
          ExpireDate: ExpireDate,
          Reference: Reference,
          Message: Message,
          AllSharedArticles: AllSharedArticles,
          CompanyName: CompanyName,
          Street: Street,
          PostalCode: PostalCode,
          Town: Town,
          Phone: Phone,
          CultureId: CultureId,
          PricesIncludingVat: PricesIncludingVat,
          PricesIncludingRecycleFee: PricesIncludingRecycleFee,
          PricesIncludingArticlePackage: PricesIncludingArticlePackage,
          BranchId: BranchId,
        };
        return f_args;
      },
      kendoWindow: function(Email, IncludeTyreScan, TyreScanDate, TyreScanFileId, ExpireDate, Reference, Message, AllSharedArticles, CompanyName, Street, PostalCode, Town, Phone, CultureId, PricesIncludingVat, PricesIncludingRecycleFee, PricesIncludingArticlePackage, BranchId, kendoWindowOptions) {
        var f_url = this.url(Email, IncludeTyreScan, TyreScanDate, TyreScanFileId, ExpireDate, Reference, Message, AllSharedArticles, CompanyName, Street, PostalCode, Town, Phone, CultureId, PricesIncludingVat, PricesIncludingRecycleFee, PricesIncludingArticlePackage, BranchId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(model, kendoWindowOptions) {
        var f_url = this.url(model.Email, model.IncludeTyreScan, model.TyreScanDate, model.TyreScanFileId, model.ExpireDate, model.Reference, model.Message, model.AllSharedArticles, model.CompanyName, model.Street, model.PostalCode, model.Town, model.Phone, model.CultureId, model.PricesIncludingVat, model.PricesIncludingRecycleFee, model.PricesIncludingArticlePackage, model.BranchId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    LicenseplateHasTyreScan: {
      url: function(licenseplateNumber) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/LicenseplateHasTyreScan';
        }
        var f_args = this.argsObject(licenseplateNumber);
        return $menu.getRootUrl() + '/OrderMVC/Order/LicenseplateHasTyreScan' + '?' + $.param(f_args);
      },
      argsObject: function(licenseplateNumber) {
        var f_args = {
          licenseplateNumber: licenseplateNumber,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    PrintOrderOffer: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Order/PrintOrderOffer';
      },
      argsObject: function(model_Email, model_IncludeTyreScan, model_TyreScanDate, model_TyreScanFileId, model_ExpireDate, model_Reference, model_Message, model_AllSharedArticles, model_CompanyName, model_Street, model_PostalCode, model_Town, model_Phone, model_CultureId, model_PricesIncludingVat, model_PricesIncludingRecycleFee, model_PricesIncludingArticlePackage, model_BranchId) {
        var f_args = {
          model: {
            Email: model_Email,
            IncludeTyreScan: model_IncludeTyreScan,
            TyreScanDate: model_TyreScanDate,
            TyreScanFileId: model_TyreScanFileId,
            ExpireDate: model_ExpireDate,
            Reference: model_Reference,
            Message: model_Message,
            AllSharedArticles: model_AllSharedArticles,
            CompanyName: model_CompanyName,
            Street: model_Street,
            PostalCode: model_PostalCode,
            Town: model_Town,
            Phone: model_Phone,
            CultureId: model_CultureId,
            PricesIncludingVat: model_PricesIncludingVat,
            PricesIncludingRecycleFee: model_PricesIncludingRecycleFee,
            PricesIncludingArticlePackage: model_PricesIncludingArticlePackage,
            BranchId: model_BranchId,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    SendSharedArticles: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Order/SendSharedArticles';
      },
      argsObject: function(model_Email, model_IncludeTyreScan, model_TyreScanDate, model_TyreScanFileId, model_ExpireDate, model_Reference, model_Message, model_AllSharedArticles, model_CompanyName, model_Street, model_PostalCode, model_Town, model_Phone, model_CultureId, model_PricesIncludingVat, model_PricesIncludingRecycleFee, model_PricesIncludingArticlePackage, model_BranchId) {
        var f_args = {
          model: {
            Email: model_Email,
            IncludeTyreScan: model_IncludeTyreScan,
            TyreScanDate: model_TyreScanDate,
            TyreScanFileId: model_TyreScanFileId,
            ExpireDate: model_ExpireDate,
            Reference: model_Reference,
            Message: model_Message,
            AllSharedArticles: model_AllSharedArticles,
            CompanyName: model_CompanyName,
            Street: model_Street,
            PostalCode: model_PostalCode,
            Town: model_Town,
            Phone: model_Phone,
            CultureId: model_CultureId,
            PricesIncludingVat: model_PricesIncludingVat,
            PricesIncludingRecycleFee: model_PricesIncludingRecycleFee,
            PricesIncludingArticlePackage: model_PricesIncludingArticlePackage,
            BranchId: model_BranchId,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    GetSelectPointOfSaleView: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Order/GetSelectPointOfSaleView';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    EditReservationStatusView: {
      url: function(statusId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/EditReservationStatusView';
        }
        var f_args = this.argsObject(statusId);
        return $menu.getRootUrl() + '/OrderMVC/Order/EditReservationStatusView' + '?' + $.param(f_args);
      },
      argsObject: function(statusId) {
        var f_args = {
          statusId: statusId,
        };
        return f_args;
      },
      kendoWindow: function(statusId, kendoWindowOptions) {
        var f_url = this.url(statusId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(statusId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    UpdateOrderReservationStatus: {
      url: function(orderId, branchId, statusId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/UpdateOrderReservationStatus';
        }
        var f_args = this.argsObject(orderId, branchId, statusId);
        return $menu.getRootUrl() + '/OrderMVC/Order/UpdateOrderReservationStatus' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, branchId, statusId) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
          statusId: statusId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetDistinctMainGroupsForOpenOrdersAndReservations: {
      url: function(branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/GetDistinctMainGroupsForOpenOrdersAndReservations';
        }
        var f_args = this.argsObject(branchId);
        return $menu.getRootUrl() + '/OrderMVC/Order/GetDistinctMainGroupsForOpenOrdersAndReservations' + '?' + $.param(f_args);
      },
      argsObject: function(branchId) {
        var f_args = {
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetDistinctSubGroupsForOpenOrdersAndReservations: {
      url: function(branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/GetDistinctSubGroupsForOpenOrdersAndReservations';
        }
        var f_args = this.argsObject(branchId);
        return $menu.getRootUrl() + '/OrderMVC/Order/GetDistinctSubGroupsForOpenOrdersAndReservations' + '?' + $.param(f_args);
      },
      argsObject: function(branchId) {
        var f_args = {
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    DeleteReservationView: {
      url: function(orderId, branchId, downpaymentamount) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Order/DeleteReservationView';
        }
        var f_args = this.argsObject(orderId, branchId, downpaymentamount);
        return $menu.getRootUrl() + '/OrderMVC/Order/DeleteReservationView' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, branchId, downpaymentamount) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
          downpaymentamount: downpaymentamount,
        };
        return f_args;
      },
      kendoWindow: function(orderId, branchId, downpaymentamount, kendoWindowOptions) {
        var f_url = this.url(orderId, branchId, downpaymentamount);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(orderId,branchId,downpaymentamount, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  PayTransaction : {
    GetTransactionLog: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/PayTransaction/GetTransactionLog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  Reports : {
    FitterPerformanceDialog: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Reports/FitterPerformanceDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetFitterPerformanceReportInfo: {
      url: function(BranchId, BranchName, Start, End, IncludeInternalTransactions, SplitBy) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Reports/GetFitterPerformanceReportInfo';
        }
        var f_args = this.argsObject(BranchId, BranchName, Start, End, IncludeInternalTransactions, SplitBy);
        return $menu.getRootUrl() + '/OrderMVC/Reports/GetFitterPerformanceReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(BranchId, BranchName, Start, End, IncludeInternalTransactions, SplitBy) {
        var f_args = {
          BranchId: BranchId,
          BranchName: BranchName,
          Start: Start,
          End: End,
          IncludeInternalTransactions: IncludeInternalTransactions,
          SplitBy: SplitBy,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    ECSalesListDialog: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Reports/ECSalesListDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetECSalesListReportInfo: {
      url: function(Start, End, ViewDetails) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Reports/GetECSalesListReportInfo';
        }
        var f_args = this.argsObject(Start, End, ViewDetails);
        return $menu.getRootUrl() + '/OrderMVC/Reports/GetECSalesListReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(Start, End, ViewDetails) {
        var f_args = {
          Start: Start,
          End: End,
          ViewDetails: ViewDetails,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    TopSellersDialog: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Reports/TopSellersDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetTopSellersReportInfo: {
      url: function(BranchId, BranchName, MainGroupIdFrom, MainGroupNameFrom, MainGroupIdTo, MainGroupNameTo, SubGroupIdFrom, SubGroupNameFrom, SubGroupIdTo, SubGroupNameTo, Start, End, SalesTypes, CustomerNumber, CustomerName, PrintCount, GroupBy) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Reports/GetTopSellersReportInfo';
        }
        var f_args = this.argsObject(BranchId, BranchName, MainGroupIdFrom, MainGroupNameFrom, MainGroupIdTo, MainGroupNameTo, SubGroupIdFrom, SubGroupNameFrom, SubGroupIdTo, SubGroupNameTo, Start, End, SalesTypes, CustomerNumber, CustomerName, PrintCount, GroupBy);
        return $menu.getRootUrl() + '/OrderMVC/Reports/GetTopSellersReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(BranchId, BranchName, MainGroupIdFrom, MainGroupNameFrom, MainGroupIdTo, MainGroupNameTo, SubGroupIdFrom, SubGroupNameFrom, SubGroupIdTo, SubGroupNameTo, Start, End, SalesTypes, CustomerNumber, CustomerName, PrintCount, GroupBy) {
        var f_args = {
          BranchId: BranchId,
          BranchName: BranchName,
          MainGroupIdFrom: MainGroupIdFrom,
          MainGroupNameFrom: MainGroupNameFrom,
          MainGroupIdTo: MainGroupIdTo,
          MainGroupNameTo: MainGroupNameTo,
          SubGroupIdFrom: SubGroupIdFrom,
          SubGroupNameFrom: SubGroupNameFrom,
          SubGroupIdTo: SubGroupIdTo,
          SubGroupNameTo: SubGroupNameTo,
          Start: Start,
          End: End,
          SalesTypes: SalesTypes,
          CustomerNumber: CustomerNumber,
          CustomerName: CustomerName,
          PrintCount: PrintCount,
          GroupBy: GroupBy,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    SalesVATSummaryDialog: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Reports/SalesVATSummaryDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetSalesVATSummaryReportInfo: {
      url: function(BranchId, BranchName, StartDate, EndDate, SpecifiedResult, IncludeInternalOrders) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Reports/GetSalesVATSummaryReportInfo';
        }
        var f_args = this.argsObject(BranchId, BranchName, StartDate, EndDate, SpecifiedResult, IncludeInternalOrders);
        return $menu.getRootUrl() + '/OrderMVC/Reports/GetSalesVATSummaryReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(BranchId, BranchName, StartDate, EndDate, SpecifiedResult, IncludeInternalOrders) {
        var f_args = {
          BranchId: BranchId,
          BranchName: BranchName,
          StartDate: StartDate,
          EndDate: EndDate,
          SpecifiedResult: SpecifiedResult,
          IncludeInternalOrders: IncludeInternalOrders,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  SalesCrm : {
    Index: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/SalesCrm/Index';
      },
      argsObject: function(model_DateFrom, model_DateTo, model_ArticleNumberStart, model_ArticleNumberEnd, model_MainGroupStart, model_MainGroupEnd, model_SubGroupStart, model_SubGroupEnd, model_CustomerNumber, model_SalesPerson, model_CustomerCategory) {
        var f_args = {
          model: {
            DateFrom: model_DateFrom,
            DateTo: model_DateTo,
            ArticleNumberStart: model_ArticleNumberStart,
            ArticleNumberEnd: model_ArticleNumberEnd,
            MainGroupStart: model_MainGroupStart,
            MainGroupEnd: model_MainGroupEnd,
            SubGroupStart: model_SubGroupStart,
            SubGroupEnd: model_SubGroupEnd,
            CustomerNumber: model_CustomerNumber,
            SalesPerson: model_SalesPerson,
            CustomerCategory: model_CustomerCategory,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  OrderPlugin : {
    OrderDetails: {
      url: function(orderId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/OrderPlugin/OrderDetails';
        }
        var f_args = this.argsObject(orderId);
        return $menu.getRootUrl() + '/OrderMVC/OrderPlugin/OrderDetails' + '?' + $.param(f_args);
      },
      argsObject: function(orderId) {
        var f_args = {
          orderId: orderId,
        };
        return f_args;
      },
      browserWindow: function(orderId) {
        var f_url = this.url(orderId);
        var f_args = [orderId];
        var f_winId = f_args.join('_')
        var f_windowName = undefined;
        if(f_winId.replace(/_/g, '') != '') {
          f_windowName = 'OrderDetails_' + f_args.join('_');
        }
        compilator.windowHandler.openWindowWithFocus(f_url, f_windowName, arguments.length > 0);
      },
    },
    SearchWheel: {
      url: function(orderId, licensePlate, customerNumber, customerName, isWholesale, enableVehicleSearch, makeAndModel) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/OrderPlugin/SearchWheel';
        }
        var f_args = this.argsObject(orderId, licensePlate, customerNumber, customerName, isWholesale, enableVehicleSearch, makeAndModel);
        return $menu.getRootUrl() + '/OrderMVC/OrderPlugin/SearchWheel' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, licensePlate, customerNumber, customerName, isWholesale, enableVehicleSearch, makeAndModel) {
        var f_args = {
          orderId: orderId,
          licensePlate: licensePlate,
          customerNumber: customerNumber,
          customerName: customerName,
          isWholesale: isWholesale,
          enableVehicleSearch: enableVehicleSearch,
          makeAndModel: makeAndModel,
        };
        return f_args;
      },
      kendoWindow: function(orderId, licensePlate, customerNumber, customerName, isWholesale, enableVehicleSearch, makeAndModel, kendoWindowOptions) {
        var f_url = this.url(orderId, licensePlate, customerNumber, customerName, isWholesale, enableVehicleSearch, makeAndModel);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(orderId,licensePlate,customerNumber,customerName,isWholesale,enableVehicleSearch,makeAndModel, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SearchTyres: {
      url: function(orderId, licensePlate, customerNumber, customerName, isWholesale, enableVehicleSearch, makeAndModel) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/OrderPlugin/SearchTyres';
        }
        var f_args = this.argsObject(orderId, licensePlate, customerNumber, customerName, isWholesale, enableVehicleSearch, makeAndModel);
        return $menu.getRootUrl() + '/OrderMVC/OrderPlugin/SearchTyres' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, licensePlate, customerNumber, customerName, isWholesale, enableVehicleSearch, makeAndModel) {
        var f_args = {
          orderId: orderId,
          licensePlate: licensePlate,
          customerNumber: customerNumber,
          customerName: customerName,
          isWholesale: isWholesale,
          enableVehicleSearch: enableVehicleSearch,
          makeAndModel: makeAndModel,
        };
        return f_args;
      },
      kendoWindow: function(orderId, licensePlate, customerNumber, customerName, isWholesale, enableVehicleSearch, makeAndModel, kendoWindowOptions) {
        var f_url = this.url(orderId, licensePlate, customerNumber, customerName, isWholesale, enableVehicleSearch, makeAndModel);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(orderId,licensePlate,customerNumber,customerName,isWholesale,enableVehicleSearch,makeAndModel, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SearchArticleNo: {
      url: function(articleNo) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/OrderPlugin/SearchArticleNo';
        }
        var f_args = this.argsObject(articleNo);
        return $menu.getRootUrl() + '/OrderMVC/OrderPlugin/SearchArticleNo' + '?' + $.param(f_args);
      },
      argsObject: function(articleNo) {
        var f_args = {
          articleNo: articleNo,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    StockReplenishmentDialog: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/OrderPlugin/StockReplenishmentDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    AddStockReplenishment: {
      url: function(BranchId, ArticleId, PluginArticleNo, Description, StockQuantity, ReorderPoint, EdiWheelSupplierId, EdiWheelAccountId, EdiWheelSupplierName, EdiWheelAccountName, LastOrdered, LastOrderedQuantity, LastOrderedBy, AvailableQuantity, EAN, SupplierArticleId, LastOrderedInDays, LastOrderedInfo, Deficit) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/OrderPlugin/AddStockReplenishment';
        }
        var f_args = this.argsObject(BranchId, ArticleId, PluginArticleNo, Description, StockQuantity, ReorderPoint, EdiWheelSupplierId, EdiWheelAccountId, EdiWheelSupplierName, EdiWheelAccountName, LastOrdered, LastOrderedQuantity, LastOrderedBy, AvailableQuantity, EAN, SupplierArticleId, LastOrderedInDays, LastOrderedInfo, Deficit);
        return $menu.getRootUrl() + '/OrderMVC/OrderPlugin/AddStockReplenishment' + '?' + $.param(f_args);
      },
      argsObject: function(BranchId, ArticleId, PluginArticleNo, Description, StockQuantity, ReorderPoint, EdiWheelSupplierId, EdiWheelAccountId, EdiWheelSupplierName, EdiWheelAccountName, LastOrdered, LastOrderedQuantity, LastOrderedBy, AvailableQuantity, EAN, SupplierArticleId, LastOrderedInDays, LastOrderedInfo, Deficit) {
        var f_args = {
          BranchId: BranchId,
          ArticleId: ArticleId,
          PluginArticleNo: PluginArticleNo,
          Description: Description,
          StockQuantity: StockQuantity,
          ReorderPoint: ReorderPoint,
          EdiWheelSupplierId: EdiWheelSupplierId,
          EdiWheelAccountId: EdiWheelAccountId,
          EdiWheelSupplierName: EdiWheelSupplierName,
          EdiWheelAccountName: EdiWheelAccountName,
          LastOrdered: LastOrdered,
          LastOrderedQuantity: LastOrderedQuantity,
          LastOrderedBy: LastOrderedBy,
          AvailableQuantity: AvailableQuantity,
          EAN: EAN,
          SupplierArticleId: SupplierArticleId,
          LastOrderedInDays: LastOrderedInDays,
          LastOrderedInfo: LastOrderedInfo,
          Deficit: Deficit,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    DeleteStockReplenishment: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/OrderPlugin/DeleteStockReplenishment';
      },
      argsObject: function(view_BranchId, view_ArticleId, view_PluginArticleNo, view_Description, view_StockQuantity, view_ReorderPoint, view_EdiWheelSupplierId, view_EdiWheelAccountId, view_EdiWheelSupplierName, view_EdiWheelAccountName, view_LastOrdered, view_LastOrderedQuantity, view_LastOrderedBy, view_AvailableQuantity, view_EAN, view_SupplierArticleId, view_LastOrderedInDays, view_LastOrderedInfo, view_Deficit) {
        var f_args = {
          view: {
            BranchId: view_BranchId,
            ArticleId: view_ArticleId,
            PluginArticleNo: view_PluginArticleNo,
            Description: view_Description,
            StockQuantity: view_StockQuantity,
            ReorderPoint: view_ReorderPoint,
            EdiWheelSupplierId: view_EdiWheelSupplierId,
            EdiWheelAccountId: view_EdiWheelAccountId,
            EdiWheelSupplierName: view_EdiWheelSupplierName,
            EdiWheelAccountName: view_EdiWheelAccountName,
            LastOrdered: view_LastOrdered,
            LastOrderedQuantity: view_LastOrderedQuantity,
            LastOrderedBy: view_LastOrderedBy,
            AvailableQuantity: view_AvailableQuantity,
            EAN: view_EAN,
            SupplierArticleId: view_SupplierArticleId,
            LastOrderedInDays: view_LastOrderedInDays,
            LastOrderedInfo: view_LastOrderedInfo,
            Deficit: view_Deficit,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    UpdateLastOrderedStockReplenishment: {
      url: function(ediOrderId, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/OrderPlugin/UpdateLastOrderedStockReplenishment';
        }
        var f_args = this.argsObject(ediOrderId, branchId);
        return $menu.getRootUrl() + '/OrderMVC/OrderPlugin/UpdateLastOrderedStockReplenishment' + '?' + $.param(f_args);
      },
      argsObject: function(ediOrderId, branchId) {
        var f_args = {
          ediOrderId: ediOrderId,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  Payments : {
    SearchForReceipts: {
      url: function(cashReceiptNumber, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Payments/SearchForReceipts';
        }
        var f_args = this.argsObject(cashReceiptNumber, branchId);
        return $menu.getRootUrl() + '/OrderMVC/Payments/SearchForReceipts' + '?' + $.param(f_args);
      },
      argsObject: function(cashReceiptNumber, branchId) {
        var f_args = {
          cashReceiptNumber: cashReceiptNumber,
          branchId: branchId,
        };
        return f_args;
      },
      kendoWindow: function(cashReceiptNumber, branchId, kendoWindowOptions) {
        var f_url = this.url(cashReceiptNumber, branchId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(cashReceiptNumber,branchId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetOriginalReceipt: {
      url: function(cashReceiptId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Payments/GetOriginalReceipt';
        }
        var f_args = this.argsObject(cashReceiptId);
        return $menu.getRootUrl() + '/OrderMVC/Payments/GetOriginalReceipt' + '?' + $.param(f_args);
      },
      argsObject: function(cashReceiptId) {
        var f_args = {
          cashReceiptId: cashReceiptId,
        };
        return f_args;
      },
      kendoWindow: function(cashReceiptId, kendoWindowOptions) {
        var f_url = this.url(cashReceiptId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(cashReceiptId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetPaymentTerminalReceiptReportInfo: {
      url: function(orderId, branchId, receiptNumber) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Payments/GetPaymentTerminalReceiptReportInfo';
        }
        var f_args = this.argsObject(orderId, branchId, receiptNumber);
        return $menu.getRootUrl() + '/OrderMVC/Payments/GetPaymentTerminalReceiptReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, branchId, receiptNumber) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
          receiptNumber: receiptNumber,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetPaymentTerminalReversalReportInfo: {
      url: function(reportId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Payments/GetPaymentTerminalReversalReportInfo';
        }
        var f_args = this.argsObject(reportId);
        return $menu.getRootUrl() + '/OrderMVC/Payments/GetPaymentTerminalReversalReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(reportId) {
        var f_args = {
          reportId: reportId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetPaymentTerminalReportReportInfo: {
      url: function(reportId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Payments/GetPaymentTerminalReportReportInfo';
        }
        var f_args = this.argsObject(reportId);
        return $menu.getRootUrl() + '/OrderMVC/Payments/GetPaymentTerminalReportReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(reportId) {
        var f_args = {
          reportId: reportId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetQRCodeReportInfo: {
      url: function(id, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Payments/GetQRCodeReportInfo';
        }
        var f_args = this.argsObject(id, branchId);
        return $menu.getRootUrl() + '/OrderMVC/Payments/GetQRCodeReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(id, branchId) {
        var f_args = {
          id: id,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetOrderA4ReceiptReportInfo: {
      url: function(orderId, branchId, cashReceiptId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Payments/GetOrderA4ReceiptReportInfo';
        }
        var f_args = this.argsObject(orderId, branchId, cashReceiptId);
        return $menu.getRootUrl() + '/OrderMVC/Payments/GetOrderA4ReceiptReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, branchId, cashReceiptId) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
          cashReceiptId: cashReceiptId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetOrderReceiptReportInfo: {
      url: function(orderId, branchId, cashReceiptId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Payments/GetOrderReceiptReportInfo';
        }
        var f_args = this.argsObject(orderId, branchId, cashReceiptId);
        return $menu.getRootUrl() + '/OrderMVC/Payments/GetOrderReceiptReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, branchId, cashReceiptId) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
          cashReceiptId: cashReceiptId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetOrderReceiptCopyReportInfo: {
      url: function(orderId, branchId, a4) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Payments/GetOrderReceiptCopyReportInfo';
        }
        var f_args = this.argsObject(orderId, branchId, a4);
        return $menu.getRootUrl() + '/OrderMVC/Payments/GetOrderReceiptCopyReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, branchId, a4) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
          a4: a4,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetOrderCashWorkorderReportInfo: {
      url: function(orderId, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Payments/GetOrderCashWorkorderReportInfo';
        }
        var f_args = this.argsObject(orderId, branchId);
        return $menu.getRootUrl() + '/OrderMVC/Payments/GetOrderCashWorkorderReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(orderId, branchId) {
        var f_args = {
          orderId: orderId,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GenerateSwishQrImage: {
      url: function(pointOfSaleId, orderId, branchId, amount, message) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Payments/GenerateSwishQrImage';
        }
        var f_args = this.argsObject(pointOfSaleId, orderId, branchId, amount, message);
        return $menu.getRootUrl() + '/OrderMVC/Payments/GenerateSwishQrImage' + '?' + $.param(f_args);
      },
      argsObject: function(pointOfSaleId, orderId, branchId, amount, message) {
        var f_args = {
          pointOfSaleId: pointOfSaleId,
          orderId: orderId,
          branchId: branchId,
          amount: amount,
          message: message,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetQrImage: {
      url: function(id) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Payments/GetQrImage';
        }
        var f_args = this.argsObject(id);
        return $menu.getRootUrl() + '/OrderMVC/Payments/GetQrImage' + '?' + $.param(f_args);
      },
      argsObject: function(id) {
        var f_args = {
          id: id,
        };
        return f_args;
      },
      kendoWindow: function(id, kendoWindowOptions) {
        var f_url = this.url(id);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(id, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    CashDownPayment: {
      url: function(PaymentTypeId, OrderId, BranchId, SalesPerson, DownPaymentAmount, PrintA4Receipt, PrintReceipt, PointOfSaleId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/OrderMVC/Payments/CashDownPayment';
        }
        var f_args = this.argsObject(PaymentTypeId, OrderId, BranchId, SalesPerson, DownPaymentAmount, PrintA4Receipt, PrintReceipt, PointOfSaleId);
        return $menu.getRootUrl() + '/OrderMVC/Payments/CashDownPayment' + '?' + $.param(f_args);
      },
      argsObject: function(PaymentTypeId, OrderId, BranchId, SalesPerson, DownPaymentAmount, PrintA4Receipt, PrintReceipt, PointOfSaleId) {
        var f_args = {
          PaymentTypeId: PaymentTypeId,
          OrderId: OrderId,
          BranchId: BranchId,
          SalesPerson: SalesPerson,
          DownPaymentAmount: DownPaymentAmount,
          PrintA4Receipt: PrintA4Receipt,
          PrintReceipt: PrintReceipt,
          PointOfSaleId: PointOfSaleId,
        };
        return f_args;
      },
      kendoWindow: function(PaymentTypeId, OrderId, BranchId, SalesPerson, DownPaymentAmount, PrintA4Receipt, PrintReceipt, PointOfSaleId, kendoWindowOptions) {
        var f_url = this.url(PaymentTypeId, OrderId, BranchId, SalesPerson, DownPaymentAmount, PrintA4Receipt, PrintReceipt, PointOfSaleId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(model, kendoWindowOptions) {
        var f_url = this.url(model.PaymentTypeId, model.OrderId, model.BranchId, model.SalesPerson, model.DownPaymentAmount, model.PrintA4Receipt, model.PrintReceipt, model.PointOfSaleId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  Search : {
    GetEDIArticlesAvailability: {
      url: function() {
        return $menu.getRootUrl() + '/OrderMVC/Search/GetEDIArticlesAvailability';
      },
      argsObject: function(request_TransportPriority, request_SerialNumber, request_Identification, request_Password, request_UserName, request_Caller, request_CustomerId, request_CustomerReference, request_ArticleIdentifierType, request_UseSubstituteArticles, request_OrganizationId, request_URL, request_Csid, request_RequestItems, request_EdiWheelBranchInfo, branchId) {
        var f_args = {
          request: {
            TransportPriority: request_TransportPriority,
            SerialNumber: request_SerialNumber,
            Identification: request_Identification,
            Password: request_Password,
            UserName: request_UserName,
            Caller: request_Caller,
            CustomerId: request_CustomerId,
            CustomerReference: request_CustomerReference,
            ArticleIdentifierType: request_ArticleIdentifierType,
            UseSubstituteArticles: request_UseSubstituteArticles,
            OrganizationId: request_OrganizationId,
            URL: request_URL,
            Csid: request_Csid,
            RequestItems: request_RequestItems,
            EdiWheelBranchInfo: request_EdiWheelBranchInfo,
          },
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
  },
};

compilator.url.Login = {
  ChangePassword : {
    Index: {
      url: function(username) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Login/ChangePassword/Index';
        }
        var f_args = this.argsObject(username);
        return $menu.getRootUrl() + '/Login/ChangePassword/Index' + '?' + $.param(f_args);
      },
      argsObject: function(username) {
        var f_args = {
          username: username,
        };
        return f_args;
      },
      kendoWindow: function(username, kendoWindowOptions) {
        var f_url = this.url(username);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(username, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  Login : {
    CancelLogin: {
      url: function() {
        return $menu.getRootUrl() + '/Login/Login/CancelLogin';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
  },
  Logon : {
    Index: {
      url: function() {
        return $menu.getRootUrl() + '/Login/Logon/Index';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    LogonCurrentUser: {
      url: function(branchId, departmentId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Login/Logon/LogonCurrentUser';
        }
        var f_args = this.argsObject(branchId, departmentId);
        return $menu.getRootUrl() + '/Login/Logon/LogonCurrentUser' + '?' + $.param(f_args);
      },
      argsObject: function(branchId, departmentId) {
        var f_args = {
          branchId: branchId,
          departmentId: departmentId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
};

compilator.url.Layout = {
  Dialog : {
    ConfirmDialog: {
      url: function(useOkAndCancelButtons) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Layout/Dialog/ConfirmDialog';
        }
        var f_args = this.argsObject(useOkAndCancelButtons);
        return $menu.getRootUrl() + '/Layout/Dialog/ConfirmDialog' + '?' + $.param(f_args);
      },
      argsObject: function(useOkAndCancelButtons) {
        var f_args = {
          useOkAndCancelButtons: useOkAndCancelButtons,
        };
        return f_args;
      },
      kendoWindow: function(useOkAndCancelButtons, kendoWindowOptions) {
        var f_url = this.url(useOkAndCancelButtons);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(useOkAndCancelButtons, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
};

compilator.url.Example = {
  Start : {
    GetDates: {
      url: function() {
        return $menu.getRootUrl() + '/Example/Start/GetDates';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
};

compilator.url.Common = {
  Document : {
    SaveFile: {
      url: function(files) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/Document/SaveFile';
        }
        var f_args = this.argsObject(files);
        return $menu.getRootUrl() + '/Common/Document/SaveFile' + '?' + $.param(f_args);
      },
      argsObject: function(files) {
        var f_args = {
          files: files,
        };
        return f_args;
      },
      kendoWindow: function(files, kendoWindowOptions) {
        var f_url = this.url(files);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(files, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    RemoveFile: {
      url: function(fileNames) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/Document/RemoveFile';
        }
        var f_args = this.argsObject(fileNames);
        return $menu.getRootUrl() + '/Common/Document/RemoveFile' + '?' + $.param(f_args);
      },
      argsObject: function(fileNames) {
        var f_args = {
          fileNames: fileNames,
        };
        return f_args;
      },
      kendoWindow: function(fileNames, kendoWindowOptions) {
        var f_url = this.url(fileNames);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(fileNames, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  Email : {
    EmailDialog: {
      url: function(sellerBranchId, orderId, type, licensePlate) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/Email/EmailDialog';
        }
        var f_args = this.argsObject(sellerBranchId, orderId, type, licensePlate);
        return $menu.getRootUrl() + '/Common/Email/EmailDialog' + '?' + $.param(f_args);
      },
      argsObject: function(sellerBranchId, orderId, type, licensePlate) {
        var f_args = {
          sellerBranchId: sellerBranchId,
          orderId: orderId,
          type: type,
          licensePlate: licensePlate,
        };
        return f_args;
      },
      kendoWindow: function(sellerBranchId, orderId, type, licensePlate, kendoWindowOptions) {
        var f_url = this.url(sellerBranchId, orderId, type, licensePlate);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(sellerBranchId,orderId,type,licensePlate, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SendOrderEmail: {
      url: function() {
        return $menu.getRootUrl() + '/Common/Email/SendOrderEmail';
      },
      argsObject: function(orderMail_SellerBranchId, orderMail_OrderNumber, orderMail_Type, orderMail_Reference, orderMail_EmailAddress, orderMail_Message, orderMail_LicensePlate) {
        var f_args = {
          orderMail: {
            SellerBranchId: orderMail_SellerBranchId,
            OrderNumber: orderMail_OrderNumber,
            Type: orderMail_Type,
            Reference: orderMail_Reference,
            EmailAddress: orderMail_EmailAddress,
            Message: orderMail_Message,
            LicensePlate: orderMail_LicensePlate,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  ExternalWarehouseSync : {
    GetExternalWarehouseSyncDialog: {
      url: function(callModuleId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/ExternalWarehouseSync/GetExternalWarehouseSyncDialog';
        }
        var f_args = this.argsObject(callModuleId);
        return $menu.getRootUrl() + '/Common/ExternalWarehouseSync/GetExternalWarehouseSyncDialog' + '?' + $.param(f_args);
      },
      argsObject: function(callModuleId) {
        var f_args = {
          callModuleId: callModuleId,
        };
        return f_args;
      },
      kendoWindow: function(callModuleId, kendoWindowOptions) {
        var f_url = this.url(callModuleId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(callModuleId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  SMS : {
    SMSDialog: {
      url: function(phoneNumberReceiver, phoneNumberSender, PresetNoteTypeId, BranchId, IsReplyable) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/SMS/SMSDialog';
        }
        var f_args = this.argsObject(phoneNumberReceiver, phoneNumberSender, PresetNoteTypeId, BranchId, IsReplyable);
        return $menu.getRootUrl() + '/Common/SMS/SMSDialog' + '?' + $.param(f_args);
      },
      argsObject: function(phoneNumberReceiver, phoneNumberSender, PresetNoteTypeId, BranchId, IsReplyable) {
        var f_args = {
          phoneNumberReceiver: phoneNumberReceiver,
          phoneNumberSender: phoneNumberSender,
          PresetNoteTypeId: PresetNoteTypeId,
          BranchId: BranchId,
          IsReplyable: IsReplyable,
        };
        return f_args;
      },
      kendoWindow: function(phoneNumberReceiver, phoneNumberSender, PresetNoteTypeId, BranchId, IsReplyable, kendoWindowOptions) {
        var f_url = this.url(phoneNumberReceiver, phoneNumberSender, PresetNoteTypeId, BranchId, IsReplyable);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(sendSMS, kendoWindowOptions) {
        var f_url = this.url(sendSMS.phoneNumberReceiver, sendSMS.phoneNumberSender, sendSMS.PresetNoteTypeId, sendSMS.BranchId, sendSMS.IsReplyable);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SendSMS: {
      url: function() {
        return $menu.getRootUrl() + '/Common/SMS/SendSMS';
      },
      argsObject: function(sendSMS_BranchId, sendSMS_PhoneNumberReceiver, sendSMS_PhoneNumberSender, sendSMS_IsReplyable, sendSMS_Message, sendSMS_bodyText) {
        var f_args = {
          sendSMS: {
            BranchId: sendSMS_BranchId,
            PhoneNumberReceiver: sendSMS_PhoneNumberReceiver,
            PhoneNumberSender: sendSMS_PhoneNumberSender,
            IsReplyable: sendSMS_IsReplyable,
            Message: sendSMS_Message,
            bodyText: sendSMS_bodyText,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  TransportCarrier : {
    GetAllTransportCarrier: {
      url: function() {
        return $menu.getRootUrl() + '/Common/TransportCarrier/GetAllTransportCarrier';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
  },
  GDPRPolicy : {
    Index: {
      url: function() {
        return $menu.getRootUrl() + '/Common/GDPRPolicy/Index';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  HistoryText : {
    Add: {
      url: function() {
        return $menu.getRootUrl() + '/Common/HistoryText/Add';
      },
      argsObject: function(historyText_Text, historyText_ComponentId) {
        var f_args = {
          historyText: {
            Text: historyText_Text,
            ComponentId: historyText_ComponentId,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    Delete: {
      url: function(id) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/HistoryText/Delete';
        }
        var f_args = this.argsObject(id);
        return $menu.getRootUrl() + '/Common/HistoryText/Delete' + '?' + $.param(f_args);
      },
      argsObject: function(id) {
        var f_args = {
          id: id,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'DELETE', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  Payment : {
    GetPaymentTypes: {
      url: function(allowInvoicing, allowCash, allowSwish, pointOfSaleId, allowInvoice, allowCreditCardForAdyen, allowResursBank, allowVipps) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/Payment/GetPaymentTypes';
        }
        var f_args = this.argsObject(allowInvoicing, allowCash, allowSwish, pointOfSaleId, allowInvoice, allowCreditCardForAdyen, allowResursBank, allowVipps);
        return $menu.getRootUrl() + '/Common/Payment/GetPaymentTypes' + '?' + $.param(f_args);
      },
      argsObject: function(allowInvoicing, allowCash, allowSwish, pointOfSaleId, allowInvoice, allowCreditCardForAdyen, allowResursBank, allowVipps) {
        var f_args = {
          allowInvoicing: allowInvoicing,
          allowCash: allowCash,
          allowSwish: allowSwish,
          pointOfSaleId: pointOfSaleId,
          allowInvoice: allowInvoice,
          allowCreditCardForAdyen: allowCreditCardForAdyen,
          allowResursBank: allowResursBank,
          allowVipps: allowVipps,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  PresetNote : {
    GetPresetNoteConfigurationView: {
      url: function(presetNoteTypeId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/PresetNote/GetPresetNoteConfigurationView';
        }
        var f_args = this.argsObject(presetNoteTypeId);
        return $menu.getRootUrl() + '/Common/PresetNote/GetPresetNoteConfigurationView' + '?' + $.param(f_args);
      },
      argsObject: function(presetNoteTypeId) {
        var f_args = {
          presetNoteTypeId: presetNoteTypeId,
        };
        return f_args;
      },
      kendoWindow: function(presetNoteTypeId, kendoWindowOptions) {
        var f_url = this.url(presetNoteTypeId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(presetNoteTypeId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    UpsertPresetNote: {
      url: function() {
        return $menu.getRootUrl() + '/Common/PresetNote/UpsertPresetNote';
      },
      argsObject: function(presetNoteId, presetNoteTypeId, headerText, bodyText) {
        var f_args = {
          presetNoteId: presetNoteId,
          presetNoteTypeId: presetNoteTypeId,
          headerText: headerText,
          bodyText: bodyText,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    DeletePresetNote: {
      url: function(presetNoteId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/PresetNote/DeletePresetNote';
        }
        var f_args = this.argsObject(presetNoteId);
        return $menu.getRootUrl() + '/Common/PresetNote/DeletePresetNote' + '?' + $.param(f_args);
      },
      argsObject: function(presetNoteId) {
        var f_args = {
          presetNoteId: presetNoteId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'DELETE', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  PrinterDetection : {
    Update: {
      url: function(printers) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/PrinterDetection/Update';
        }
        var f_args = this.argsObject(printers);
        return $menu.getRootUrl() + '/Common/PrinterDetection/Update' + '?' + $.param(f_args);
      },
      argsObject: function(printers) {
        var f_args = {
          printers: printers,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  Security : {
    ValidateUserDialog: {
      url: function() {
        return $menu.getRootUrl() + '/Common/Security/ValidateUserDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    ValidateUser: {
      url: function() {
        return $menu.getRootUrl() + '/Common/Security/ValidateUser';
      },
      argsObject: function(validateUser_Username, validateUser_Password) {
        var f_args = {
          validateUser: {
            Username: validateUser_Username,
            Password: validateUser_Password,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  Cache : {
    UpdatePrinterSettings: {
      url: function(currentSessionId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/Cache/UpdatePrinterSettings';
        }
        var f_args = this.argsObject(currentSessionId);
        return $menu.getRootUrl() + '/Common/Cache/UpdatePrinterSettings' + '?' + $.param(f_args);
      },
      argsObject: function(currentSessionId) {
        var f_args = {
          currentSessionId: currentSessionId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    SetCacheKey: {
      url: function(cacheKey) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/Cache/SetCacheKey';
        }
        var f_args = this.argsObject(cacheKey);
        return $menu.getRootUrl() + '/Common/Cache/SetCacheKey' + '?' + $.param(f_args);
      },
      argsObject: function(cacheKey) {
        var f_args = {
          cacheKey: cacheKey,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  TyreHotelStorageCardActions : {
    TyreHotelStorageCardActions: {
      url: function(plate, scId, orderId, sellerBranchId, orderLines, eventId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/TyreHotelStorageCardActions/TyreHotelStorageCardActions';
        }
        var f_args = this.argsObject(plate, scId, orderId, sellerBranchId, orderLines, eventId);
        return $menu.getRootUrl() + '/Common/TyreHotelStorageCardActions/TyreHotelStorageCardActions' + '?' + $.param(f_args);
      },
      argsObject: function(plate, scId, orderId, sellerBranchId, orderLines, eventId) {
        var f_args = {
          plate: plate,
          scId: scId,
          orderId: orderId,
          sellerBranchId: sellerBranchId,
          orderLines: orderLines,
          eventId: eventId,
        };
        return f_args;
      },
      kendoWindow: function(plate, scId, orderId, sellerBranchId, orderLines, eventId, kendoWindowOptions) {
        var f_url = this.url(plate, scId, orderId, sellerBranchId, orderLines, eventId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(plate,scId,orderId,sellerBranchId,orderLines,eventId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetStorageCardDebitModel: {
      url: function(plate, scId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/TyreHotelStorageCardActions/GetStorageCardDebitModel';
        }
        var f_args = this.argsObject(plate, scId);
        return $menu.getRootUrl() + '/Common/TyreHotelStorageCardActions/GetStorageCardDebitModel' + '?' + $.param(f_args);
      },
      argsObject: function(plate, scId) {
        var f_args = {
          plate: plate,
          scId: scId,
        };
        return f_args;
      },
      kendoWindow: function(plate, scId, kendoWindowOptions) {
        var f_url = this.url(plate, scId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(plate,scId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  UserSettings : {
    Index: {
      url: function() {
        return $menu.getRootUrl() + '/Common/UserSettings/Index';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    Post: {
      url: function() {
        return $menu.getRootUrl() + '/Common/UserSettings/Post';
      },
      argsObject: function(user_Id, user_Username, user_DisplayName, user_LastLogin, user_Created, user_CreatedBy, user_Changed, user_ChangedBy, user_Language, user_BranchId, user_Department, user_StartPage, user_AutoLogin, user_Phone, user_MobilePhone, user_Email, user_RoleId, user_IsActive, user_Image, user_ImageStr, user_UploadImageFilename, user_AutoDeactivatePeriod, user_RoleSettings, user_Password, user_PasswordConfirmation, user_ToggleActiveStatus, user_UnlockUser, user_IsLockedOut, user_Enabled, user_BranchAccesses, user_CurrentUserEditing, user_PasswordExpirationDate, user_AllowBackofficeLogin, user_UserAliases, user_TacdisUserId) {
        var f_args = {
          user: {
            Id: user_Id,
            Username: user_Username,
            DisplayName: user_DisplayName,
            LastLogin: user_LastLogin,
            Created: user_Created,
            CreatedBy: user_CreatedBy,
            Changed: user_Changed,
            ChangedBy: user_ChangedBy,
            Language: user_Language,
            BranchId: user_BranchId,
            Department: user_Department,
            StartPage: user_StartPage,
            AutoLogin: user_AutoLogin,
            Phone: user_Phone,
            MobilePhone: user_MobilePhone,
            Email: user_Email,
            RoleId: user_RoleId,
            IsActive: user_IsActive,
            Image: user_Image,
            ImageStr: user_ImageStr,
            UploadImageFilename: user_UploadImageFilename,
            AutoDeactivatePeriod: user_AutoDeactivatePeriod,
            RoleSettings: user_RoleSettings,
            Password: user_Password,
            PasswordConfirmation: user_PasswordConfirmation,
            ToggleActiveStatus: user_ToggleActiveStatus,
            UnlockUser: user_UnlockUser,
            IsLockedOut: user_IsLockedOut,
            Enabled: user_Enabled,
            BranchAccesses: user_BranchAccesses,
            CurrentUserEditing: user_CurrentUserEditing,
            PasswordExpirationDate: user_PasswordExpirationDate,
            AllowBackofficeLogin: user_AllowBackofficeLogin,
            UserAliases: user_UserAliases,
            TacdisUserId: user_TacdisUserId,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    SaveFile: {
      url: function(files) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/UserSettings/SaveFile';
        }
        var f_args = this.argsObject(files);
        return $menu.getRootUrl() + '/Common/UserSettings/SaveFile' + '?' + $.param(f_args);
      },
      argsObject: function(files) {
        var f_args = {
          files: files,
        };
        return f_args;
      },
      kendoWindow: function(files, kendoWindowOptions) {
        var f_url = this.url(files);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(files, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    RemoveFile: {
      url: function(fileNames) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/UserSettings/RemoveFile';
        }
        var f_args = this.argsObject(fileNames);
        return $menu.getRootUrl() + '/Common/UserSettings/RemoveFile' + '?' + $.param(f_args);
      },
      argsObject: function(fileNames) {
        var f_args = {
          fileNames: fileNames,
        };
        return f_args;
      },
      kendoWindow: function(fileNames, kendoWindowOptions) {
        var f_url = this.url(fileNames);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(fileNames, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  Print : {
    Index: {
      url: function(companyId, cacheIds) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/Print/Index';
        }
        var f_args = this.argsObject(companyId, cacheIds);
        return $menu.getRootUrl() + '/Common/Print/Index' + '?' + $.param(f_args);
      },
      argsObject: function(companyId, cacheIds) {
        var f_args = {
          companyId: companyId,
          cacheIds: cacheIds,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, undefined, ajaxData);
      },
    },
    Info: {
      url: function() {
        return $menu.getRootUrl() + '/Common/Print/Info';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  Vehicle : {
    SearchVehicle: {
      url: function(licensePlate, branchId, forceRefresh) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/Vehicle/SearchVehicle';
        }
        var f_args = this.argsObject(licensePlate, branchId, forceRefresh);
        return $menu.getRootUrl() + '/Common/Vehicle/SearchVehicle' + '?' + $.param(f_args);
      },
      argsObject: function(licensePlate, branchId, forceRefresh) {
        var f_args = {
          licensePlate: licensePlate,
          branchId: branchId,
          forceRefresh: forceRefresh,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    SearchVehicleDimensions: {
      url: function(licensePlate) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/Vehicle/SearchVehicleDimensions';
        }
        var f_args = this.argsObject(licensePlate);
        return $menu.getRootUrl() + '/Common/Vehicle/SearchVehicleDimensions' + '?' + $.param(f_args);
      },
      argsObject: function(licensePlate) {
        var f_args = {
          licensePlate: licensePlate,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetTreadDepth: {
      url: function(licensePlate) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/Vehicle/GetTreadDepth';
        }
        var f_args = this.argsObject(licensePlate);
        return $menu.getRootUrl() + '/Common/Vehicle/GetTreadDepth' + '?' + $.param(f_args);
      },
      argsObject: function(licensePlate) {
        var f_args = {
          licensePlate: licensePlate,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetOwnerDetails: {
      url: function(licensePlate, branchId, forceRefresh) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Common/Vehicle/GetOwnerDetails';
        }
        var f_args = this.argsObject(licensePlate, branchId, forceRefresh);
        return $menu.getRootUrl() + '/Common/Vehicle/GetOwnerDetails' + '?' + $.param(f_args);
      },
      argsObject: function(licensePlate, branchId, forceRefresh) {
        var f_args = {
          licensePlate: licensePlate,
          branchId: branchId,
          forceRefresh: forceRefresh,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
};

compilator.url.Calendar = {
  SharedCalendars : {
    Index: {
      url: function(branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Calendar/SharedCalendars/Index';
        }
        var f_args = this.argsObject(branchId);
        return $menu.getRootUrl() + '/Calendar/SharedCalendars/Index' + '?' + $.param(f_args);
      },
      argsObject: function(branchId) {
        var f_args = {
          branchId: branchId,
        };
        return f_args;
      },
      kendoWindow: function(branchId, kendoWindowOptions) {
        var f_url = this.url(branchId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(branchId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    AddNewSharedCalendar: {
      url: function() {
        return $menu.getRootUrl() + '/Calendar/SharedCalendars/AddNewSharedCalendar';
      },
      argsObject: function(key, colorCode, branchId) {
        var f_args = {
          key: key,
          colorCode: colorCode,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    ConnectSharedCalendar: {
      url: function() {
        return $menu.getRootUrl() + '/Calendar/SharedCalendars/ConnectSharedCalendar';
      },
      argsObject: function(model_Identifier, model_Name, model_DefaultColorCode, model_ColorCodes, model_OwningBranchId, model_AuthorizationLevel, model_Status) {
        var f_args = {
          model: {
            Identifier: model_Identifier,
            Name: model_Name,
            DefaultColorCode: model_DefaultColorCode,
            ColorCodes: model_ColorCodes,
            OwningBranchId: model_OwningBranchId,
            AuthorizationLevel: model_AuthorizationLevel,
            Status: model_Status,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  Timebook : {
    UpdateWaitingLocation: {
      url: function() {
        return $menu.getRootUrl() + '/Calendar/Timebook/UpdateWaitingLocation';
      },
      argsObject: function(waitingPersonId, waitingLocationId) {
        var f_args = {
          waitingPersonId: waitingPersonId,
          waitingLocationId: waitingLocationId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    GetQueuePointOfSales: {
      url: function(queueId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Calendar/Timebook/GetQueuePointOfSales';
        }
        var f_args = this.argsObject(queueId);
        return $menu.getRootUrl() + '/Calendar/Timebook/GetQueuePointOfSales' + '?' + $.param(f_args);
      },
      argsObject: function(queueId) {
        var f_args = {
          queueId: queueId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    UpdateDefaultPointOfSale: {
      url: function(pointOfSaleId, queueId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Calendar/Timebook/UpdateDefaultPointOfSale';
        }
        var f_args = this.argsObject(pointOfSaleId, queueId);
        return $menu.getRootUrl() + '/Calendar/Timebook/UpdateDefaultPointOfSale' + '?' + $.param(f_args);
      },
      argsObject: function(pointOfSaleId, queueId) {
        var f_args = {
          pointOfSaleId: pointOfSaleId,
          queueId: queueId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    SearchEventsWindow: {
      url: function(searchText, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Calendar/Timebook/SearchEventsWindow';
        }
        var f_args = this.argsObject(searchText, branchId);
        return $menu.getRootUrl() + '/Calendar/Timebook/SearchEventsWindow' + '?' + $.param(f_args);
      },
      argsObject: function(searchText, branchId) {
        var f_args = {
          searchText: searchText,
          branchId: branchId,
        };
        return f_args;
      },
      kendoWindow: function(searchText, branchId, kendoWindowOptions) {
        var f_url = this.url(searchText, branchId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(searchText,branchId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    SearchEvents: {
      url: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, searchText, branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Calendar/Timebook/SearchEvents';
        }
        var f_args = this.argsObject(Page, PageSize, Sorts, Filters, Groups, Aggregates, searchText, branchId);
        return $menu.getRootUrl() + '/Calendar/Timebook/SearchEvents' + '?' + $.param(f_args);
      },
      argsObject: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, searchText, branchId) {
        var f_args = {
          Page: Page,
          PageSize: PageSize,
          Sorts: Sorts,
          Filters: Filters,
          Groups: Groups,
          Aggregates: Aggregates,
          searchText: searchText,
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    DeleteBookingRequest: {
      url: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, Id, Subject, EventReference, StartDateTime, EndDateTime, BranchId, BranchName, CalendarId, CalendarName, ContactName, LicensePlate, LastChanged, LastChangedBy, Created, CreatedBy) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Calendar/Timebook/DeleteBookingRequest';
        }
        var f_args = this.argsObject(Page, PageSize, Sorts, Filters, Groups, Aggregates, Id, Subject, EventReference, StartDateTime, EndDateTime, BranchId, BranchName, CalendarId, CalendarName, ContactName, LicensePlate, LastChanged, LastChangedBy, Created, CreatedBy);
        return $menu.getRootUrl() + '/Calendar/Timebook/DeleteBookingRequest' + '?' + $.param(f_args);
      },
      argsObject: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, Id, Subject, EventReference, StartDateTime, EndDateTime, BranchId, BranchName, CalendarId, CalendarName, ContactName, LicensePlate, LastChanged, LastChangedBy, Created, CreatedBy) {
        var f_args = {
          Page: Page,
          PageSize: PageSize,
          Sorts: Sorts,
          Filters: Filters,
          Groups: Groups,
          Aggregates: Aggregates,
          Id: Id,
          Subject: Subject,
          EventReference: EventReference,
          StartDateTime: StartDateTime,
          EndDateTime: EndDateTime,
          BranchId: BranchId,
          BranchName: BranchName,
          CalendarId: CalendarId,
          CalendarName: CalendarName,
          ContactName: ContactName,
          LicensePlate: LicensePlate,
          LastChanged: LastChanged,
          LastChangedBy: LastChangedBy,
          Created: Created,
          CreatedBy: CreatedBy,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    DeleteEvents: {
      url: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, events) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Calendar/Timebook/DeleteEvents';
        }
        var f_args = this.argsObject(Page, PageSize, Sorts, Filters, Groups, Aggregates, events);
        return $menu.getRootUrl() + '/Calendar/Timebook/DeleteEvents' + '?' + $.param(f_args);
      },
      argsObject: function(Page, PageSize, Sorts, Filters, Groups, Aggregates, events) {
        var f_args = {
          Page: Page,
          PageSize: PageSize,
          Sorts: Sorts,
          Filters: Filters,
          Groups: Groups,
          Aggregates: Aggregates,
          events: events,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'DELETE', ajaxOptions, 'json', ajaxData);
      },
    },
    RestoreStorageCardWorkOrder: {
      url: function() {
        return $menu.getRootUrl() + '/Calendar/Timebook/RestoreStorageCardWorkOrder';
      },
      argsObject: function(storageCardId, eventId, resetWorkOrder) {
        var f_args = {
          storageCardId: storageCardId,
          eventId: eventId,
          resetWorkOrder: resetWorkOrder,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    TyreHotelCalendar: {
      url: function(storageCardId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Calendar/Timebook/TyreHotelCalendar';
        }
        var f_args = this.argsObject(storageCardId);
        return $menu.getRootUrl() + '/Calendar/Timebook/TyreHotelCalendar' + '?' + $.param(f_args);
      },
      argsObject: function(storageCardId) {
        var f_args = {
          storageCardId: storageCardId,
        };
        return f_args;
      },
      kendoWindow: function(storageCardId, kendoWindowOptions) {
        var f_url = this.url(storageCardId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(storageCardId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    OrderCalendar: {
      url: function(SellerBranchId, OrderId, LicensePlate, VehicleDisplayMake, Subject, DurationInMinutes, EventId, CustomerId, CustomerNumber, CustomerName, MarkedDone) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Calendar/Timebook/OrderCalendar';
        }
        var f_args = this.argsObject(SellerBranchId, OrderId, LicensePlate, VehicleDisplayMake, Subject, DurationInMinutes, EventId, CustomerId, CustomerNumber, CustomerName, MarkedDone);
        return $menu.getRootUrl() + '/Calendar/Timebook/OrderCalendar' + '?' + $.param(f_args);
      },
      argsObject: function(SellerBranchId, OrderId, LicensePlate, VehicleDisplayMake, Subject, DurationInMinutes, EventId, CustomerId, CustomerNumber, CustomerName, MarkedDone) {
        var f_args = {
          SellerBranchId: SellerBranchId,
          OrderId: OrderId,
          LicensePlate: LicensePlate,
          VehicleDisplayMake: VehicleDisplayMake,
          Subject: Subject,
          DurationInMinutes: DurationInMinutes,
          EventId: EventId,
          CustomerId: CustomerId,
          CustomerNumber: CustomerNumber,
          CustomerName: CustomerName,
          MarkedDone: MarkedDone,
        };
        return f_args;
      },
      kendoWindow: function(SellerBranchId, OrderId, LicensePlate, VehicleDisplayMake, Subject, DurationInMinutes, EventId, CustomerId, CustomerNumber, CustomerName, MarkedDone, kendoWindowOptions) {
        var f_url = this.url(SellerBranchId, OrderId, LicensePlate, VehicleDisplayMake, Subject, DurationInMinutes, EventId, CustomerId, CustomerNumber, CustomerName, MarkedDone);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(request, kendoWindowOptions) {
        var f_url = this.url(request.SellerBranchId, request.OrderId, request.LicensePlate, request.VehicleDisplayMake, request.Subject, request.DurationInMinutes, request.EventId, request.CustomerId, request.CustomerNumber, request.CustomerName, request.MarkedDone);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetSlimmedIndexView: {
      url: function(branchId, eventId, orderDetailsIsParent) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Calendar/Timebook/GetSlimmedIndexView';
        }
        var f_args = this.argsObject(branchId, eventId, orderDetailsIsParent);
        return $menu.getRootUrl() + '/Calendar/Timebook/GetSlimmedIndexView' + '?' + $.param(f_args);
      },
      argsObject: function(branchId, eventId, orderDetailsIsParent) {
        var f_args = {
          branchId: branchId,
          eventId: eventId,
          orderDetailsIsParent: orderDetailsIsParent,
        };
        return f_args;
      },
      kendoWindow: function(branchId, eventId, orderDetailsIsParent, kendoWindowOptions) {
        var f_url = this.url(branchId, eventId, orderDetailsIsParent);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(branchId,eventId,orderDetailsIsParent, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    Create: {
      url: function() {
        return $menu.getRootUrl() + '/Calendar/Timebook/Create';
      },
      argsObject: function(request_Page, request_PageSize, request_Sorts, request_Filters, request_Groups, request_Aggregates, calendarEvent_Id, calendarEvent_CalendarId, calendarEvent_OriginalCalendarId, calendarEvent_LicensePlate, calendarEvent_VehicleModel, calendarEvent_TyreHotelStorageCardId, calendarEvent_TyreHotelStockPlaceName, calendarEvent_TyreHotelCheckedIn, calendarEvent_TyreHotelReady, calendarEvent_TyreHotelCharged, calendarEvent_TyreHotelCheckedOut, calendarEvent_SummerSeason, calendarEvent_CurrentWorkOrderHasEventId, calendarEvent_Shift, calendarEvent_ParkingLot, calendarEvent_CollectDateTime, calendarEvent_PhoneNumber, calendarEvent_Email, calendarEvent_ArticlePackageHeadIdForEquipmentSet, calendarEvent_ArticlePackageHeadIdForPreviousEquipmentSet, calendarEvent_ArticlePackageHeadId, calendarEvent_ArticlePackageName, calendarEvent_ArticlePackageDuration, calendarEvent_ArticlePackageVariableQuantity, calendarEvent_ReminderTimeSMS, calendarEvent_ReminderTimeEmail, calendarEvent_SendConfirmationEmail, calendarEvent_SendConfirmationSms, calendarEvent_CustomerId, calendarEvent_CustomerName, calendarEvent_ContactId, calendarEvent_ContactName, calendarEvent_Description, calendarEvent_Note, calendarEvent_Subject, calendarEvent_Start, calendarEvent_End, calendarEvent_OriginalStart, calendarEvent_OriginalEnd, calendarEvent_TrueStartDateTime, calendarEvent_TrueEndDateTime, calendarEvent_Express, calendarEvent_IsExternal, calendarEvent_Properties, calendarEvent_EventReference, calendarEvent_ColorCodeKey, calendarEvent_Histories, calendarEvent_CheckInStorageCard, calendarEvent_SendReminders, calendarEvent_UpdateDataSource, calendarEvent_OrderSellerBranchId, calendarEvent_OrderId, calendarEvent_HasOrder, calendarEvent_OrderIsPaid, calendarEvent_OrderMarkedAsDone, calendarEvent_Title, calendarEvent_StartTimezone, calendarEvent_EndTimezone, calendarEvent_RecurrenceRule, calendarEvent_RecurrenceException, calendarEvent_IsAllDay, calendarEvent_PublicBookingName, calendarEvent_PublicBookingEmail, calendarEvent_PublicBookingMobilePhoneNumber, timeZoneId, keys, sharedCalendar, convertedQueueId) {
        var f_args = {
          request: {
            Page: request_Page,
            PageSize: request_PageSize,
            Sorts: request_Sorts,
            Filters: request_Filters,
            Groups: request_Groups,
            Aggregates: request_Aggregates,
          },
          calendarEvent: {
            Id: calendarEvent_Id,
            CalendarId: calendarEvent_CalendarId,
            OriginalCalendarId: calendarEvent_OriginalCalendarId,
            LicensePlate: calendarEvent_LicensePlate,
            VehicleModel: calendarEvent_VehicleModel,
            TyreHotelStorageCardId: calendarEvent_TyreHotelStorageCardId,
            TyreHotelStockPlaceName: calendarEvent_TyreHotelStockPlaceName,
            TyreHotelCheckedIn: calendarEvent_TyreHotelCheckedIn,
            TyreHotelReady: calendarEvent_TyreHotelReady,
            TyreHotelCharged: calendarEvent_TyreHotelCharged,
            TyreHotelCheckedOut: calendarEvent_TyreHotelCheckedOut,
            SummerSeason: calendarEvent_SummerSeason,
            CurrentWorkOrderHasEventId: calendarEvent_CurrentWorkOrderHasEventId,
            Shift: calendarEvent_Shift,
            ParkingLot: calendarEvent_ParkingLot,
            CollectDateTime: calendarEvent_CollectDateTime,
            PhoneNumber: calendarEvent_PhoneNumber,
            Email: calendarEvent_Email,
            ArticlePackageHeadIdForEquipmentSet: calendarEvent_ArticlePackageHeadIdForEquipmentSet,
            ArticlePackageHeadIdForPreviousEquipmentSet: calendarEvent_ArticlePackageHeadIdForPreviousEquipmentSet,
            ArticlePackageHeadId: calendarEvent_ArticlePackageHeadId,
            ArticlePackageName: calendarEvent_ArticlePackageName,
            ArticlePackageDuration: calendarEvent_ArticlePackageDuration,
            ArticlePackageVariableQuantity: calendarEvent_ArticlePackageVariableQuantity,
            ReminderTimeSMS: calendarEvent_ReminderTimeSMS,
            ReminderTimeEmail: calendarEvent_ReminderTimeEmail,
            SendConfirmationEmail: calendarEvent_SendConfirmationEmail,
            SendConfirmationSms: calendarEvent_SendConfirmationSms,
            CustomerId: calendarEvent_CustomerId,
            CustomerName: calendarEvent_CustomerName,
            ContactId: calendarEvent_ContactId,
            ContactName: calendarEvent_ContactName,
            Description: calendarEvent_Description,
            Note: calendarEvent_Note,
            Subject: calendarEvent_Subject,
            Start: calendarEvent_Start,
            End: calendarEvent_End,
            OriginalStart: calendarEvent_OriginalStart,
            OriginalEnd: calendarEvent_OriginalEnd,
            TrueStartDateTime: calendarEvent_TrueStartDateTime,
            TrueEndDateTime: calendarEvent_TrueEndDateTime,
            Express: calendarEvent_Express,
            IsExternal: calendarEvent_IsExternal,
            Properties: calendarEvent_Properties,
            EventReference: calendarEvent_EventReference,
            ColorCodeKey: calendarEvent_ColorCodeKey,
            Histories: calendarEvent_Histories,
            CheckInStorageCard: calendarEvent_CheckInStorageCard,
            SendReminders: calendarEvent_SendReminders,
            UpdateDataSource: calendarEvent_UpdateDataSource,
            OrderSellerBranchId: calendarEvent_OrderSellerBranchId,
            OrderId: calendarEvent_OrderId,
            HasOrder: calendarEvent_HasOrder,
            OrderIsPaid: calendarEvent_OrderIsPaid,
            OrderMarkedAsDone: calendarEvent_OrderMarkedAsDone,
            Title: calendarEvent_Title,
            StartTimezone: calendarEvent_StartTimezone,
            EndTimezone: calendarEvent_EndTimezone,
            RecurrenceRule: calendarEvent_RecurrenceRule,
            RecurrenceException: calendarEvent_RecurrenceException,
            IsAllDay: calendarEvent_IsAllDay,
            PublicBookingName: calendarEvent_PublicBookingName,
            PublicBookingEmail: calendarEvent_PublicBookingEmail,
            PublicBookingMobilePhoneNumber: calendarEvent_PublicBookingMobilePhoneNumber,
          },
          timeZoneId: timeZoneId,
          keys: keys,
          sharedCalendar: sharedCalendar,
          convertedQueueId: convertedQueueId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    GetStartAndEnd: {
      url: function() {
        return $menu.getRootUrl() + '/Calendar/Timebook/GetStartAndEnd';
      },
      argsObject: function(request_Page, request_PageSize, request_Sorts, request_Filters, request_Groups, request_Aggregates, calendarEvent_Id, calendarEvent_CalendarId, calendarEvent_OriginalCalendarId, calendarEvent_LicensePlate, calendarEvent_VehicleModel, calendarEvent_TyreHotelStorageCardId, calendarEvent_TyreHotelStockPlaceName, calendarEvent_TyreHotelCheckedIn, calendarEvent_TyreHotelReady, calendarEvent_TyreHotelCharged, calendarEvent_TyreHotelCheckedOut, calendarEvent_SummerSeason, calendarEvent_CurrentWorkOrderHasEventId, calendarEvent_Shift, calendarEvent_ParkingLot, calendarEvent_CollectDateTime, calendarEvent_PhoneNumber, calendarEvent_Email, calendarEvent_ArticlePackageHeadIdForEquipmentSet, calendarEvent_ArticlePackageHeadIdForPreviousEquipmentSet, calendarEvent_ArticlePackageHeadId, calendarEvent_ArticlePackageName, calendarEvent_ArticlePackageDuration, calendarEvent_ArticlePackageVariableQuantity, calendarEvent_ReminderTimeSMS, calendarEvent_ReminderTimeEmail, calendarEvent_SendConfirmationEmail, calendarEvent_SendConfirmationSms, calendarEvent_CustomerId, calendarEvent_CustomerName, calendarEvent_ContactId, calendarEvent_ContactName, calendarEvent_Description, calendarEvent_Note, calendarEvent_Subject, calendarEvent_Start, calendarEvent_End, calendarEvent_OriginalStart, calendarEvent_OriginalEnd, calendarEvent_TrueStartDateTime, calendarEvent_TrueEndDateTime, calendarEvent_Express, calendarEvent_IsExternal, calendarEvent_Properties, calendarEvent_EventReference, calendarEvent_ColorCodeKey, calendarEvent_Histories, calendarEvent_CheckInStorageCard, calendarEvent_SendReminders, calendarEvent_UpdateDataSource, calendarEvent_OrderSellerBranchId, calendarEvent_OrderId, calendarEvent_HasOrder, calendarEvent_OrderIsPaid, calendarEvent_OrderMarkedAsDone, calendarEvent_Title, calendarEvent_StartTimezone, calendarEvent_EndTimezone, calendarEvent_RecurrenceRule, calendarEvent_RecurrenceException, calendarEvent_IsAllDay, calendarEvent_PublicBookingName, calendarEvent_PublicBookingEmail, calendarEvent_PublicBookingMobilePhoneNumber, timeZoneId, keys, sharedCalendar) {
        var f_args = {
          request: {
            Page: request_Page,
            PageSize: request_PageSize,
            Sorts: request_Sorts,
            Filters: request_Filters,
            Groups: request_Groups,
            Aggregates: request_Aggregates,
          },
          calendarEvent: {
            Id: calendarEvent_Id,
            CalendarId: calendarEvent_CalendarId,
            OriginalCalendarId: calendarEvent_OriginalCalendarId,
            LicensePlate: calendarEvent_LicensePlate,
            VehicleModel: calendarEvent_VehicleModel,
            TyreHotelStorageCardId: calendarEvent_TyreHotelStorageCardId,
            TyreHotelStockPlaceName: calendarEvent_TyreHotelStockPlaceName,
            TyreHotelCheckedIn: calendarEvent_TyreHotelCheckedIn,
            TyreHotelReady: calendarEvent_TyreHotelReady,
            TyreHotelCharged: calendarEvent_TyreHotelCharged,
            TyreHotelCheckedOut: calendarEvent_TyreHotelCheckedOut,
            SummerSeason: calendarEvent_SummerSeason,
            CurrentWorkOrderHasEventId: calendarEvent_CurrentWorkOrderHasEventId,
            Shift: calendarEvent_Shift,
            ParkingLot: calendarEvent_ParkingLot,
            CollectDateTime: calendarEvent_CollectDateTime,
            PhoneNumber: calendarEvent_PhoneNumber,
            Email: calendarEvent_Email,
            ArticlePackageHeadIdForEquipmentSet: calendarEvent_ArticlePackageHeadIdForEquipmentSet,
            ArticlePackageHeadIdForPreviousEquipmentSet: calendarEvent_ArticlePackageHeadIdForPreviousEquipmentSet,
            ArticlePackageHeadId: calendarEvent_ArticlePackageHeadId,
            ArticlePackageName: calendarEvent_ArticlePackageName,
            ArticlePackageDuration: calendarEvent_ArticlePackageDuration,
            ArticlePackageVariableQuantity: calendarEvent_ArticlePackageVariableQuantity,
            ReminderTimeSMS: calendarEvent_ReminderTimeSMS,
            ReminderTimeEmail: calendarEvent_ReminderTimeEmail,
            SendConfirmationEmail: calendarEvent_SendConfirmationEmail,
            SendConfirmationSms: calendarEvent_SendConfirmationSms,
            CustomerId: calendarEvent_CustomerId,
            CustomerName: calendarEvent_CustomerName,
            ContactId: calendarEvent_ContactId,
            ContactName: calendarEvent_ContactName,
            Description: calendarEvent_Description,
            Note: calendarEvent_Note,
            Subject: calendarEvent_Subject,
            Start: calendarEvent_Start,
            End: calendarEvent_End,
            OriginalStart: calendarEvent_OriginalStart,
            OriginalEnd: calendarEvent_OriginalEnd,
            TrueStartDateTime: calendarEvent_TrueStartDateTime,
            TrueEndDateTime: calendarEvent_TrueEndDateTime,
            Express: calendarEvent_Express,
            IsExternal: calendarEvent_IsExternal,
            Properties: calendarEvent_Properties,
            EventReference: calendarEvent_EventReference,
            ColorCodeKey: calendarEvent_ColorCodeKey,
            Histories: calendarEvent_Histories,
            CheckInStorageCard: calendarEvent_CheckInStorageCard,
            SendReminders: calendarEvent_SendReminders,
            UpdateDataSource: calendarEvent_UpdateDataSource,
            OrderSellerBranchId: calendarEvent_OrderSellerBranchId,
            OrderId: calendarEvent_OrderId,
            HasOrder: calendarEvent_HasOrder,
            OrderIsPaid: calendarEvent_OrderIsPaid,
            OrderMarkedAsDone: calendarEvent_OrderMarkedAsDone,
            Title: calendarEvent_Title,
            StartTimezone: calendarEvent_StartTimezone,
            EndTimezone: calendarEvent_EndTimezone,
            RecurrenceRule: calendarEvent_RecurrenceRule,
            RecurrenceException: calendarEvent_RecurrenceException,
            IsAllDay: calendarEvent_IsAllDay,
            PublicBookingName: calendarEvent_PublicBookingName,
            PublicBookingEmail: calendarEvent_PublicBookingEmail,
            PublicBookingMobilePhoneNumber: calendarEvent_PublicBookingMobilePhoneNumber,
          },
          timeZoneId: timeZoneId,
          keys: keys,
          sharedCalendar: sharedCalendar,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    PostBookingColor: {
      url: function() {
        return $menu.getRootUrl() + '/Calendar/Timebook/PostBookingColor';
      },
      argsObject: function(request_Page, request_PageSize, request_Sorts, request_Filters, request_Groups, request_Aggregates, event_Id, event_CalendarId, event_OriginalCalendarId, event_LicensePlate, event_VehicleModel, event_TyreHotelStorageCardId, event_TyreHotelStockPlaceName, event_TyreHotelCheckedIn, event_TyreHotelReady, event_TyreHotelCharged, event_TyreHotelCheckedOut, event_SummerSeason, event_CurrentWorkOrderHasEventId, event_Shift, event_ParkingLot, event_CollectDateTime, event_PhoneNumber, event_Email, event_ArticlePackageHeadIdForEquipmentSet, event_ArticlePackageHeadIdForPreviousEquipmentSet, event_ArticlePackageHeadId, event_ArticlePackageName, event_ArticlePackageDuration, event_ArticlePackageVariableQuantity, event_ReminderTimeSMS, event_ReminderTimeEmail, event_SendConfirmationEmail, event_SendConfirmationSms, event_CustomerId, event_CustomerName, event_ContactId, event_ContactName, event_Description, event_Note, event_Subject, event_Start, event_End, event_OriginalStart, event_OriginalEnd, event_TrueStartDateTime, event_TrueEndDateTime, event_Express, event_IsExternal, event_Properties, event_EventReference, event_ColorCodeKey, event_Histories, event_CheckInStorageCard, event_SendReminders, event_UpdateDataSource, event_OrderSellerBranchId, event_OrderId, event_HasOrder, event_OrderIsPaid, event_OrderMarkedAsDone, event_Title, event_StartTimezone, event_EndTimezone, event_RecurrenceRule, event_RecurrenceException, event_IsAllDay, event_PublicBookingName, event_PublicBookingEmail, event_PublicBookingMobilePhoneNumber, keys) {
        var f_args = {
          request: {
            Page: request_Page,
            PageSize: request_PageSize,
            Sorts: request_Sorts,
            Filters: request_Filters,
            Groups: request_Groups,
            Aggregates: request_Aggregates,
          },
          event: {
            Id: event_Id,
            CalendarId: event_CalendarId,
            OriginalCalendarId: event_OriginalCalendarId,
            LicensePlate: event_LicensePlate,
            VehicleModel: event_VehicleModel,
            TyreHotelStorageCardId: event_TyreHotelStorageCardId,
            TyreHotelStockPlaceName: event_TyreHotelStockPlaceName,
            TyreHotelCheckedIn: event_TyreHotelCheckedIn,
            TyreHotelReady: event_TyreHotelReady,
            TyreHotelCharged: event_TyreHotelCharged,
            TyreHotelCheckedOut: event_TyreHotelCheckedOut,
            SummerSeason: event_SummerSeason,
            CurrentWorkOrderHasEventId: event_CurrentWorkOrderHasEventId,
            Shift: event_Shift,
            ParkingLot: event_ParkingLot,
            CollectDateTime: event_CollectDateTime,
            PhoneNumber: event_PhoneNumber,
            Email: event_Email,
            ArticlePackageHeadIdForEquipmentSet: event_ArticlePackageHeadIdForEquipmentSet,
            ArticlePackageHeadIdForPreviousEquipmentSet: event_ArticlePackageHeadIdForPreviousEquipmentSet,
            ArticlePackageHeadId: event_ArticlePackageHeadId,
            ArticlePackageName: event_ArticlePackageName,
            ArticlePackageDuration: event_ArticlePackageDuration,
            ArticlePackageVariableQuantity: event_ArticlePackageVariableQuantity,
            ReminderTimeSMS: event_ReminderTimeSMS,
            ReminderTimeEmail: event_ReminderTimeEmail,
            SendConfirmationEmail: event_SendConfirmationEmail,
            SendConfirmationSms: event_SendConfirmationSms,
            CustomerId: event_CustomerId,
            CustomerName: event_CustomerName,
            ContactId: event_ContactId,
            ContactName: event_ContactName,
            Description: event_Description,
            Note: event_Note,
            Subject: event_Subject,
            Start: event_Start,
            End: event_End,
            OriginalStart: event_OriginalStart,
            OriginalEnd: event_OriginalEnd,
            TrueStartDateTime: event_TrueStartDateTime,
            TrueEndDateTime: event_TrueEndDateTime,
            Express: event_Express,
            IsExternal: event_IsExternal,
            Properties: event_Properties,
            EventReference: event_EventReference,
            ColorCodeKey: event_ColorCodeKey,
            Histories: event_Histories,
            CheckInStorageCard: event_CheckInStorageCard,
            SendReminders: event_SendReminders,
            UpdateDataSource: event_UpdateDataSource,
            OrderSellerBranchId: event_OrderSellerBranchId,
            OrderId: event_OrderId,
            HasOrder: event_HasOrder,
            OrderIsPaid: event_OrderIsPaid,
            OrderMarkedAsDone: event_OrderMarkedAsDone,
            Title: event_Title,
            StartTimezone: event_StartTimezone,
            EndTimezone: event_EndTimezone,
            RecurrenceRule: event_RecurrenceRule,
            RecurrenceException: event_RecurrenceException,
            IsAllDay: event_IsAllDay,
            PublicBookingName: event_PublicBookingName,
            PublicBookingEmail: event_PublicBookingEmail,
            PublicBookingMobilePhoneNumber: event_PublicBookingMobilePhoneNumber,
          },
          keys: keys,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    Update: {
      url: function() {
        return $menu.getRootUrl() + '/Calendar/Timebook/Update';
      },
      argsObject: function(request_Page, request_PageSize, request_Sorts, request_Filters, request_Groups, request_Aggregates, event_Id, event_CalendarId, event_OriginalCalendarId, event_LicensePlate, event_VehicleModel, event_TyreHotelStorageCardId, event_TyreHotelStockPlaceName, event_TyreHotelCheckedIn, event_TyreHotelReady, event_TyreHotelCharged, event_TyreHotelCheckedOut, event_SummerSeason, event_CurrentWorkOrderHasEventId, event_Shift, event_ParkingLot, event_CollectDateTime, event_PhoneNumber, event_Email, event_ArticlePackageHeadIdForEquipmentSet, event_ArticlePackageHeadIdForPreviousEquipmentSet, event_ArticlePackageHeadId, event_ArticlePackageName, event_ArticlePackageDuration, event_ArticlePackageVariableQuantity, event_ReminderTimeSMS, event_ReminderTimeEmail, event_SendConfirmationEmail, event_SendConfirmationSms, event_CustomerId, event_CustomerName, event_ContactId, event_ContactName, event_Description, event_Note, event_Subject, event_Start, event_End, event_OriginalStart, event_OriginalEnd, event_TrueStartDateTime, event_TrueEndDateTime, event_Express, event_IsExternal, event_Properties, event_EventReference, event_ColorCodeKey, event_Histories, event_CheckInStorageCard, event_SendReminders, event_UpdateDataSource, event_OrderSellerBranchId, event_OrderId, event_HasOrder, event_OrderIsPaid, event_OrderMarkedAsDone, event_Title, event_StartTimezone, event_EndTimezone, event_RecurrenceRule, event_RecurrenceException, event_IsAllDay, event_PublicBookingName, event_PublicBookingEmail, event_PublicBookingMobilePhoneNumber, timeZoneId, keys, sharedCalendar) {
        var f_args = {
          request: {
            Page: request_Page,
            PageSize: request_PageSize,
            Sorts: request_Sorts,
            Filters: request_Filters,
            Groups: request_Groups,
            Aggregates: request_Aggregates,
          },
          event: {
            Id: event_Id,
            CalendarId: event_CalendarId,
            OriginalCalendarId: event_OriginalCalendarId,
            LicensePlate: event_LicensePlate,
            VehicleModel: event_VehicleModel,
            TyreHotelStorageCardId: event_TyreHotelStorageCardId,
            TyreHotelStockPlaceName: event_TyreHotelStockPlaceName,
            TyreHotelCheckedIn: event_TyreHotelCheckedIn,
            TyreHotelReady: event_TyreHotelReady,
            TyreHotelCharged: event_TyreHotelCharged,
            TyreHotelCheckedOut: event_TyreHotelCheckedOut,
            SummerSeason: event_SummerSeason,
            CurrentWorkOrderHasEventId: event_CurrentWorkOrderHasEventId,
            Shift: event_Shift,
            ParkingLot: event_ParkingLot,
            CollectDateTime: event_CollectDateTime,
            PhoneNumber: event_PhoneNumber,
            Email: event_Email,
            ArticlePackageHeadIdForEquipmentSet: event_ArticlePackageHeadIdForEquipmentSet,
            ArticlePackageHeadIdForPreviousEquipmentSet: event_ArticlePackageHeadIdForPreviousEquipmentSet,
            ArticlePackageHeadId: event_ArticlePackageHeadId,
            ArticlePackageName: event_ArticlePackageName,
            ArticlePackageDuration: event_ArticlePackageDuration,
            ArticlePackageVariableQuantity: event_ArticlePackageVariableQuantity,
            ReminderTimeSMS: event_ReminderTimeSMS,
            ReminderTimeEmail: event_ReminderTimeEmail,
            SendConfirmationEmail: event_SendConfirmationEmail,
            SendConfirmationSms: event_SendConfirmationSms,
            CustomerId: event_CustomerId,
            CustomerName: event_CustomerName,
            ContactId: event_ContactId,
            ContactName: event_ContactName,
            Description: event_Description,
            Note: event_Note,
            Subject: event_Subject,
            Start: event_Start,
            End: event_End,
            OriginalStart: event_OriginalStart,
            OriginalEnd: event_OriginalEnd,
            TrueStartDateTime: event_TrueStartDateTime,
            TrueEndDateTime: event_TrueEndDateTime,
            Express: event_Express,
            IsExternal: event_IsExternal,
            Properties: event_Properties,
            EventReference: event_EventReference,
            ColorCodeKey: event_ColorCodeKey,
            Histories: event_Histories,
            CheckInStorageCard: event_CheckInStorageCard,
            SendReminders: event_SendReminders,
            UpdateDataSource: event_UpdateDataSource,
            OrderSellerBranchId: event_OrderSellerBranchId,
            OrderId: event_OrderId,
            HasOrder: event_HasOrder,
            OrderIsPaid: event_OrderIsPaid,
            OrderMarkedAsDone: event_OrderMarkedAsDone,
            Title: event_Title,
            StartTimezone: event_StartTimezone,
            EndTimezone: event_EndTimezone,
            RecurrenceRule: event_RecurrenceRule,
            RecurrenceException: event_RecurrenceException,
            IsAllDay: event_IsAllDay,
            PublicBookingName: event_PublicBookingName,
            PublicBookingEmail: event_PublicBookingEmail,
            PublicBookingMobilePhoneNumber: event_PublicBookingMobilePhoneNumber,
          },
          timeZoneId: timeZoneId,
          keys: keys,
          sharedCalendar: sharedCalendar,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'PUT', ajaxOptions, 'json', ajaxData);
      },
    },
    Destroy: {
      url: function() {
        return $menu.getRootUrl() + '/Calendar/Timebook/Destroy';
      },
      argsObject: function(request_Page, request_PageSize, request_Sorts, request_Filters, request_Groups, request_Aggregates, event_Id, event_CalendarId, event_OriginalCalendarId, event_LicensePlate, event_VehicleModel, event_TyreHotelStorageCardId, event_TyreHotelStockPlaceName, event_TyreHotelCheckedIn, event_TyreHotelReady, event_TyreHotelCharged, event_TyreHotelCheckedOut, event_SummerSeason, event_CurrentWorkOrderHasEventId, event_Shift, event_ParkingLot, event_CollectDateTime, event_PhoneNumber, event_Email, event_ArticlePackageHeadIdForEquipmentSet, event_ArticlePackageHeadIdForPreviousEquipmentSet, event_ArticlePackageHeadId, event_ArticlePackageName, event_ArticlePackageDuration, event_ArticlePackageVariableQuantity, event_ReminderTimeSMS, event_ReminderTimeEmail, event_SendConfirmationEmail, event_SendConfirmationSms, event_CustomerId, event_CustomerName, event_ContactId, event_ContactName, event_Description, event_Note, event_Subject, event_Start, event_End, event_OriginalStart, event_OriginalEnd, event_TrueStartDateTime, event_TrueEndDateTime, event_Express, event_IsExternal, event_Properties, event_EventReference, event_ColorCodeKey, event_Histories, event_CheckInStorageCard, event_SendReminders, event_UpdateDataSource, event_OrderSellerBranchId, event_OrderId, event_HasOrder, event_OrderIsPaid, event_OrderMarkedAsDone, event_Title, event_StartTimezone, event_EndTimezone, event_RecurrenceRule, event_RecurrenceException, event_IsAllDay, event_PublicBookingName, event_PublicBookingEmail, event_PublicBookingMobilePhoneNumber, keys) {
        var f_args = {
          request: {
            Page: request_Page,
            PageSize: request_PageSize,
            Sorts: request_Sorts,
            Filters: request_Filters,
            Groups: request_Groups,
            Aggregates: request_Aggregates,
          },
          event: {
            Id: event_Id,
            CalendarId: event_CalendarId,
            OriginalCalendarId: event_OriginalCalendarId,
            LicensePlate: event_LicensePlate,
            VehicleModel: event_VehicleModel,
            TyreHotelStorageCardId: event_TyreHotelStorageCardId,
            TyreHotelStockPlaceName: event_TyreHotelStockPlaceName,
            TyreHotelCheckedIn: event_TyreHotelCheckedIn,
            TyreHotelReady: event_TyreHotelReady,
            TyreHotelCharged: event_TyreHotelCharged,
            TyreHotelCheckedOut: event_TyreHotelCheckedOut,
            SummerSeason: event_SummerSeason,
            CurrentWorkOrderHasEventId: event_CurrentWorkOrderHasEventId,
            Shift: event_Shift,
            ParkingLot: event_ParkingLot,
            CollectDateTime: event_CollectDateTime,
            PhoneNumber: event_PhoneNumber,
            Email: event_Email,
            ArticlePackageHeadIdForEquipmentSet: event_ArticlePackageHeadIdForEquipmentSet,
            ArticlePackageHeadIdForPreviousEquipmentSet: event_ArticlePackageHeadIdForPreviousEquipmentSet,
            ArticlePackageHeadId: event_ArticlePackageHeadId,
            ArticlePackageName: event_ArticlePackageName,
            ArticlePackageDuration: event_ArticlePackageDuration,
            ArticlePackageVariableQuantity: event_ArticlePackageVariableQuantity,
            ReminderTimeSMS: event_ReminderTimeSMS,
            ReminderTimeEmail: event_ReminderTimeEmail,
            SendConfirmationEmail: event_SendConfirmationEmail,
            SendConfirmationSms: event_SendConfirmationSms,
            CustomerId: event_CustomerId,
            CustomerName: event_CustomerName,
            ContactId: event_ContactId,
            ContactName: event_ContactName,
            Description: event_Description,
            Note: event_Note,
            Subject: event_Subject,
            Start: event_Start,
            End: event_End,
            OriginalStart: event_OriginalStart,
            OriginalEnd: event_OriginalEnd,
            TrueStartDateTime: event_TrueStartDateTime,
            TrueEndDateTime: event_TrueEndDateTime,
            Express: event_Express,
            IsExternal: event_IsExternal,
            Properties: event_Properties,
            EventReference: event_EventReference,
            ColorCodeKey: event_ColorCodeKey,
            Histories: event_Histories,
            CheckInStorageCard: event_CheckInStorageCard,
            SendReminders: event_SendReminders,
            UpdateDataSource: event_UpdateDataSource,
            OrderSellerBranchId: event_OrderSellerBranchId,
            OrderId: event_OrderId,
            HasOrder: event_HasOrder,
            OrderIsPaid: event_OrderIsPaid,
            OrderMarkedAsDone: event_OrderMarkedAsDone,
            Title: event_Title,
            StartTimezone: event_StartTimezone,
            EndTimezone: event_EndTimezone,
            RecurrenceRule: event_RecurrenceRule,
            RecurrenceException: event_RecurrenceException,
            IsAllDay: event_IsAllDay,
            PublicBookingName: event_PublicBookingName,
            PublicBookingEmail: event_PublicBookingEmail,
            PublicBookingMobilePhoneNumber: event_PublicBookingMobilePhoneNumber,
          },
          keys: keys,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    Read: {
      url: function() {
        return $menu.getRootUrl() + '/Calendar/Timebook/Read';
      },
      argsObject: function(request_Page, request_PageSize, request_Sorts, request_Filters, request_Groups, request_Aggregates, start, end, branchId, ids, keys) {
        var f_args = {
          request: {
            Page: request_Page,
            PageSize: request_PageSize,
            Sorts: request_Sorts,
            Filters: request_Filters,
            Groups: request_Groups,
            Aggregates: request_Aggregates,
          },
          start: start,
          end: end,
          branchId: branchId,
          ids: ids,
          keys: keys,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    GetCalendarDetails: {
      url: function(calendarIds, from, to, keys) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Calendar/Timebook/GetCalendarDetails';
        }
        var f_args = this.argsObject(calendarIds, from, to, keys);
        return $menu.getRootUrl() + '/Calendar/Timebook/GetCalendarDetails' + '?' + $.param(f_args);
      },
      argsObject: function(calendarIds, from, to, keys) {
        var f_args = {
          calendarIds: calendarIds,
          from: from,
          to: to,
          keys: keys,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetDaysWithEvents: {
      url: function(start, end, branchId, ids, keys) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Calendar/Timebook/GetDaysWithEvents';
        }
        var f_args = this.argsObject(start, end, branchId, ids, keys);
        return $menu.getRootUrl() + '/Calendar/Timebook/GetDaysWithEvents' + '?' + $.param(f_args);
      },
      argsObject: function(start, end, branchId, ids, keys) {
        var f_args = {
          start: start,
          end: end,
          branchId: branchId,
          ids: ids,
          keys: keys,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetServices: {
      url: function(branchCalendarId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Calendar/Timebook/GetServices';
        }
        var f_args = this.argsObject(branchCalendarId);
        return $menu.getRootUrl() + '/Calendar/Timebook/GetServices' + '?' + $.param(f_args);
      },
      argsObject: function(branchCalendarId) {
        var f_args = {
          branchCalendarId: branchCalendarId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetService: {
      url: function(articlePackageHeadId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Calendar/Timebook/GetService';
        }
        var f_args = this.argsObject(articlePackageHeadId);
        return $menu.getRootUrl() + '/Calendar/Timebook/GetService' + '?' + $.param(f_args);
      },
      argsObject: function(articlePackageHeadId) {
        var f_args = {
          articlePackageHeadId: articlePackageHeadId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetWeek: {
      url: function(date) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Calendar/Timebook/GetWeek';
        }
        var f_args = this.argsObject(date);
        return $menu.getRootUrl() + '/Calendar/Timebook/GetWeek' + '?' + $.param(f_args);
      },
      argsObject: function(date) {
        var f_args = {
          date: date,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    PrintDialog: {
      url: function(printDate) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Calendar/Timebook/PrintDialog';
        }
        var f_args = this.argsObject(printDate);
        return $menu.getRootUrl() + '/Calendar/Timebook/PrintDialog' + '?' + $.param(f_args);
      },
      argsObject: function(printDate) {
        var f_args = {
          printDate: printDate,
        };
        return f_args;
      },
      kendoWindow: function(printDate, kendoWindowOptions) {
        var f_url = this.url(printDate);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(printDate, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    PrintDailyBookings: {
      url: function() {
        return $menu.getRootUrl() + '/Calendar/Timebook/PrintDailyBookings';
      },
      argsObject: function(branchId, printDate, startTime, endTime, events, calendars, includeBookingNote) {
        var f_args = {
          branchId: branchId,
          printDate: printDate,
          startTime: startTime,
          endTime: endTime,
          events: events,
          calendars: calendars,
          includeBookingNote: includeBookingNote,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    PrintStorageCardLabels: {
      url: function() {
        return $menu.getRootUrl() + '/Calendar/Timebook/PrintStorageCardLabels';
      },
      argsObject: function(branchId, printDate, startTime, endTime, events, calendars) {
        var f_args = {
          branchId: branchId,
          printDate: printDate,
          startTime: startTime,
          endTime: endTime,
          events: events,
          calendars: calendars,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    GetRefreshTimes: {
      url: function() {
        return $menu.getRootUrl() + '/Calendar/Timebook/GetRefreshTimes';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
  },
};

compilator.url.Business = {
  Contact : {
    GETGDPRExcerptReport: {
      url: function(id) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/Contact/GETGDPRExcerptReport';
        }
        var f_args = this.argsObject(id);
        return $menu.getRootUrl() + '/Business/Contact/GETGDPRExcerptReport' + '?' + $.param(f_args);
      },
      argsObject: function(id) {
        var f_args = {
          id: id,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    ContactDetails: {
      url: function(id, customerId, allowCreate, allowEdit, saveOnPost, readonly, functionToLoadContact, allowDelete, isPurchaser) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/Contact/ContactDetails';
        }
        var f_args = this.argsObject(id, customerId, allowCreate, allowEdit, saveOnPost, readonly, functionToLoadContact, allowDelete, isPurchaser);
        return $menu.getRootUrl() + '/Business/Contact/ContactDetails' + '?' + $.param(f_args);
      },
      argsObject: function(id, customerId, allowCreate, allowEdit, saveOnPost, readonly, functionToLoadContact, allowDelete, isPurchaser) {
        var f_args = {
          id: id,
          customerId: customerId,
          allowCreate: allowCreate,
          allowEdit: allowEdit,
          saveOnPost: saveOnPost,
          readonly: readonly,
          functionToLoadContact: functionToLoadContact,
          allowDelete: allowDelete,
          isPurchaser: isPurchaser,
        };
        return f_args;
      },
      kendoWindow: function(id, customerId, allowCreate, allowEdit, saveOnPost, readonly, functionToLoadContact, allowDelete, isPurchaser, kendoWindowOptions) {
        var f_url = this.url(id, customerId, allowCreate, allowEdit, saveOnPost, readonly, functionToLoadContact, allowDelete, isPurchaser);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(id,customerId,allowCreate,allowEdit,saveOnPost,readonly,functionToLoadContact,allowDelete,isPurchaser, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetContact: {
      url: function(id) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/Contact/GetContact';
        }
        var f_args = this.argsObject(id);
        return $menu.getRootUrl() + '/Business/Contact/GetContact' + '?' + $.param(f_args);
      },
      argsObject: function(id) {
        var f_args = {
          id: id,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    SearchContactsByName: {
      url: function(name, customerId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/Contact/SearchContactsByName';
        }
        var f_args = this.argsObject(name, customerId);
        return $menu.getRootUrl() + '/Business/Contact/SearchContactsByName' + '?' + $.param(f_args);
      },
      argsObject: function(name, customerId) {
        var f_args = {
          name: name,
          customerId: customerId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    SearchContactViewsByNameAndCustomer: {
      url: function(name, customerId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/Contact/SearchContactViewsByNameAndCustomer';
        }
        var f_args = this.argsObject(name, customerId);
        return $menu.getRootUrl() + '/Business/Contact/SearchContactViewsByNameAndCustomer' + '?' + $.param(f_args);
      },
      argsObject: function(name, customerId) {
        var f_args = {
          name: name,
          customerId: customerId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    SearchContactsByMobilePhoneNumber: {
      url: function(mobilePhoneNumber, customerId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/Contact/SearchContactsByMobilePhoneNumber';
        }
        var f_args = this.argsObject(mobilePhoneNumber, customerId);
        return $menu.getRootUrl() + '/Business/Contact/SearchContactsByMobilePhoneNumber' + '?' + $.param(f_args);
      },
      argsObject: function(mobilePhoneNumber, customerId) {
        var f_args = {
          mobilePhoneNumber: mobilePhoneNumber,
          customerId: customerId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    SearchContactsByEmail: {
      url: function(emails, customerId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/Contact/SearchContactsByEmail';
        }
        var f_args = this.argsObject(emails, customerId);
        return $menu.getRootUrl() + '/Business/Contact/SearchContactsByEmail' + '?' + $.param(f_args);
      },
      argsObject: function(emails, customerId) {
        var f_args = {
          emails: emails,
          customerId: customerId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    AddOrUpdateContact: {
      url: function() {
        return $menu.getRootUrl() + '/Business/Contact/AddOrUpdateContact';
      },
      argsObject: function(contact_Id, contact_Identification, contact_Name, contact_Address1, contact_Address2, contact_Address3, contact_PostalCode, contact_Town, contact_Phone, contact_Mobile, contact_BranchId, contact_CountryId, contact_CountryName, contact_IsPurchaser, contact_Email, contact_BusinessPosition, contact_CustomerId, contact_UseCustomerAddress, contact_PreferredCultureId, contact_Note, contact_GDPRConsentDate, contact_GDPRConsentGiven) {
        var f_args = {
          contact: {
            Id: contact_Id,
            Identification: contact_Identification,
            Name: contact_Name,
            Address1: contact_Address1,
            Address2: contact_Address2,
            Address3: contact_Address3,
            PostalCode: contact_PostalCode,
            Town: contact_Town,
            Phone: contact_Phone,
            Mobile: contact_Mobile,
            BranchId: contact_BranchId,
            CountryId: contact_CountryId,
            CountryName: contact_CountryName,
            IsPurchaser: contact_IsPurchaser,
            Email: contact_Email,
            BusinessPosition: contact_BusinessPosition,
            CustomerId: contact_CustomerId,
            UseCustomerAddress: contact_UseCustomerAddress,
            PreferredCultureId: contact_PreferredCultureId,
            Note: contact_Note,
            GDPRConsentDate: contact_GDPRConsentDate,
            GDPRConsentGiven: contact_GDPRConsentGiven,
          },
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    CheckContactForRemoval: {
      url: function(contactId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/Contact/CheckContactForRemoval';
        }
        var f_args = this.argsObject(contactId);
        return $menu.getRootUrl() + '/Business/Contact/CheckContactForRemoval' + '?' + $.param(f_args);
      },
      argsObject: function(contactId) {
        var f_args = {
          contactId: contactId,
        };
        return f_args;
      },
      kendoWindow: function(contactId, kendoWindowOptions) {
        var f_url = this.url(contactId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(contactId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    RemoveContact: {
      url: function(contactId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/Contact/RemoveContact';
        }
        var f_args = this.argsObject(contactId);
        return $menu.getRootUrl() + '/Business/Contact/RemoveContact' + '?' + $.param(f_args);
      },
      argsObject: function(contactId) {
        var f_args = {
          contactId: contactId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'DELETE', ajaxOptions, undefined, ajaxData);
      },
    },
  },
  CreditInformation : {
    CreditInformationDetails: {
      url: function(id, customerId, editId, state, functionToLoadCreditInformationDetails) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/CreditInformation/CreditInformationDetails';
        }
        var f_args = this.argsObject(id, customerId, editId, state, functionToLoadCreditInformationDetails);
        return $menu.getRootUrl() + '/Business/CreditInformation/CreditInformationDetails' + '?' + $.param(f_args);
      },
      argsObject: function(id, customerId, editId, state, functionToLoadCreditInformationDetails) {
        var f_args = {
          id: id,
          customerId: customerId,
          editId: editId,
          state: state,
          functionToLoadCreditInformationDetails: functionToLoadCreditInformationDetails,
        };
        return f_args;
      },
      kendoWindow: function(id, customerId, editId, state, functionToLoadCreditInformationDetails, kendoWindowOptions) {
        var f_url = this.url(id, customerId, editId, state, functionToLoadCreditInformationDetails);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(id,customerId,editId,state,functionToLoadCreditInformationDetails, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  Customer : {
    VerifyOrgNr: {
      url: function(customerId, orgNr) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/Customer/VerifyOrgNr';
        }
        var f_args = this.argsObject(customerId, orgNr);
        return $menu.getRootUrl() + '/Business/Customer/VerifyOrgNr' + '?' + $.param(f_args);
      },
      argsObject: function(customerId, orgNr) {
        var f_args = {
          customerId: customerId,
          orgNr: orgNr,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    CheckCustomerForRemoval: {
      url: function(customerId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/Customer/CheckCustomerForRemoval';
        }
        var f_args = this.argsObject(customerId);
        return $menu.getRootUrl() + '/Business/Customer/CheckCustomerForRemoval' + '?' + $.param(f_args);
      },
      argsObject: function(customerId) {
        var f_args = {
          customerId: customerId,
        };
        return f_args;
      },
      kendoWindow: function(customerId, kendoWindowOptions) {
        var f_url = this.url(customerId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(customerId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GETGDPRExcerptReport: {
      url: function(id) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/Customer/GETGDPRExcerptReport';
        }
        var f_args = this.argsObject(id);
        return $menu.getRootUrl() + '/Business/Customer/GETGDPRExcerptReport' + '?' + $.param(f_args);
      },
      argsObject: function(id) {
        var f_args = {
          id: id,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetCustomer: {
      url: function(customerId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/Customer/GetCustomer';
        }
        var f_args = this.argsObject(customerId);
        return $menu.getRootUrl() + '/Business/Customer/GetCustomer' + '?' + $.param(f_args);
      },
      argsObject: function(customerId) {
        var f_args = {
          customerId: customerId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetContacts: {
      url: function(customerId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/Customer/GetContacts';
        }
        var f_args = this.argsObject(customerId);
        return $menu.getRootUrl() + '/Business/Customer/GetContacts' + '?' + $.param(f_args);
      },
      argsObject: function(customerId) {
        var f_args = {
          customerId: customerId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetContactsForCombobox: {
      url: function(customerId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/Customer/GetContactsForCombobox';
        }
        var f_args = this.argsObject(customerId);
        return $menu.getRootUrl() + '/Business/Customer/GetContactsForCombobox' + '?' + $.param(f_args);
      },
      argsObject: function(customerId) {
        var f_args = {
          customerId: customerId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetContactsForComboboxSmall: {
      url: function(customerId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/Customer/GetContactsForComboboxSmall';
        }
        var f_args = this.argsObject(customerId);
        return $menu.getRootUrl() + '/Business/Customer/GetContactsForComboboxSmall' + '?' + $.param(f_args);
      },
      argsObject: function(customerId) {
        var f_args = {
          customerId: customerId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetCustomerDeliveryAddresses: {
      url: function(customerId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/Customer/GetCustomerDeliveryAddresses';
        }
        var f_args = this.argsObject(customerId);
        return $menu.getRootUrl() + '/Business/Customer/GetCustomerDeliveryAddresses' + '?' + $.param(f_args);
      },
      argsObject: function(customerId) {
        var f_args = {
          customerId: customerId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    RemoveCustomer: {
      url: function(customerId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/Customer/RemoveCustomer';
        }
        var f_args = this.argsObject(customerId);
        return $menu.getRootUrl() + '/Business/Customer/RemoveCustomer' + '?' + $.param(f_args);
      },
      argsObject: function(customerId) {
        var f_args = {
          customerId: customerId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'DELETE', ajaxOptions, undefined, ajaxData);
      },
    },
  },
  CustomerReports : {
    AgedDebtorsDialog: {
      url: function() {
        return $menu.getRootUrl() + '/Business/CustomerReports/AgedDebtorsDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetCustomerStopListReportInfo: {
      url: function(parameterNotUsed) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/CustomerReports/GetCustomerStopListReportInfo';
        }
        var f_args = this.argsObject(parameterNotUsed);
        return $menu.getRootUrl() + '/Business/CustomerReports/GetCustomerStopListReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(parameterNotUsed) {
        var f_args = {
          parameterNotUsed: parameterNotUsed,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetCustomerAgedDebtorReportInfo: {
      url: function(ShowTotalsOnly, GenerateStopList, ExcludeCreditlockedCustomers, OnlyCreditlockedCustomers, Detailed, BalanceFilter, OrderBy, BalanceAmount, SalesTypes, CustomerCategoryId, ExcludeSelectedCustomerCategory, Show4MonthColumn) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/CustomerReports/GetCustomerAgedDebtorReportInfo';
        }
        var f_args = this.argsObject(ShowTotalsOnly, GenerateStopList, ExcludeCreditlockedCustomers, OnlyCreditlockedCustomers, Detailed, BalanceFilter, OrderBy, BalanceAmount, SalesTypes, CustomerCategoryId, ExcludeSelectedCustomerCategory, Show4MonthColumn);
        return $menu.getRootUrl() + '/Business/CustomerReports/GetCustomerAgedDebtorReportInfo' + '?' + $.param(f_args);
      },
      argsObject: function(ShowTotalsOnly, GenerateStopList, ExcludeCreditlockedCustomers, OnlyCreditlockedCustomers, Detailed, BalanceFilter, OrderBy, BalanceAmount, SalesTypes, CustomerCategoryId, ExcludeSelectedCustomerCategory, Show4MonthColumn) {
        var f_args = {
          ShowTotalsOnly: ShowTotalsOnly,
          GenerateStopList: GenerateStopList,
          ExcludeCreditlockedCustomers: ExcludeCreditlockedCustomers,
          OnlyCreditlockedCustomers: OnlyCreditlockedCustomers,
          Detailed: Detailed,
          BalanceFilter: BalanceFilter,
          OrderBy: OrderBy,
          BalanceAmount: BalanceAmount,
          SalesTypes: SalesTypes,
          CustomerCategoryId: CustomerCategoryId,
          ExcludeSelectedCustomerCategory: ExcludeSelectedCustomerCategory,
          Show4MonthColumn: Show4MonthColumn,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  Supplier : {
    GetAllSuppliers: {
      url: function() {
        return $menu.getRootUrl() + '/Business/Supplier/GetAllSuppliers';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
  },
  Branch : {
    GetSMSBranchSettings: {
      url: function(branchId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Business/Branch/GetSMSBranchSettings';
        }
        var f_args = this.argsObject(branchId);
        return $menu.getRootUrl() + '/Business/Branch/GetSMSBranchSettings' + '?' + $.param(f_args);
      },
      argsObject: function(branchId) {
        var f_args = {
          branchId: branchId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetBranchesWithAdyenStoreConnection: {
      url: function() {
        return $menu.getRootUrl() + '/Business/Branch/GetBranchesWithAdyenStoreConnection';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
  },
};

compilator.url.Article = {
  Article : {
    SearchArticleAutoSuggest: {
      url: function(searchText) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Article/Article/SearchArticleAutoSuggest';
        }
        var f_args = this.argsObject(searchText);
        return $menu.getRootUrl() + '/Article/Article/SearchArticleAutoSuggest' + '?' + $.param(f_args);
      },
      argsObject: function(searchText) {
        var f_args = {
          searchText: searchText,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetArticleInformationForAccountPayable: {
      url: function(articleNumber) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Article/Article/GetArticleInformationForAccountPayable';
        }
        var f_args = this.argsObject(articleNumber);
        return $menu.getRootUrl() + '/Article/Article/GetArticleInformationForAccountPayable' + '?' + $.param(f_args);
      },
      argsObject: function(articleNumber) {
        var f_args = {
          articleNumber: articleNumber,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  ArticleGeneral : {
    SearchGeneral: {
      url: function(DisplayText, SearchId, BranchId, AgreementId, RetailPricelistId, RetailPricelistCurrencyRate, MainGroupId, SubGroups, CustomerId, OrderType, MinimumInStock, StockId, SearchText, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, UseAllBranchesStockBalance, EDISearch) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Article/ArticleGeneral/SearchGeneral';
        }
        var f_args = this.argsObject(DisplayText, SearchId, BranchId, AgreementId, RetailPricelistId, RetailPricelistCurrencyRate, MainGroupId, SubGroups, CustomerId, OrderType, MinimumInStock, StockId, SearchText, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, UseAllBranchesStockBalance, EDISearch);
        return $menu.getRootUrl() + '/Article/ArticleGeneral/SearchGeneral' + '?' + $.param(f_args);
      },
      argsObject: function(DisplayText, SearchId, BranchId, AgreementId, RetailPricelistId, RetailPricelistCurrencyRate, MainGroupId, SubGroups, CustomerId, OrderType, MinimumInStock, StockId, SearchText, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, UseAllBranchesStockBalance, EDISearch) {
        var f_args = {
          DisplayText: DisplayText,
          SearchId: SearchId,
          BranchId: BranchId,
          AgreementId: AgreementId,
          RetailPricelistId: RetailPricelistId,
          RetailPricelistCurrencyRate: RetailPricelistCurrencyRate,
          MainGroupId: MainGroupId,
          SubGroups: SubGroups,
          CustomerId: CustomerId,
          OrderType: OrderType,
          MinimumInStock: MinimumInStock,
          StockId: StockId,
          SearchText: SearchText,
          CurrencyId: CurrencyId,
          OrderCurrencyRate: OrderCurrencyRate,
          SupplierArticleNumber: SupplierArticleNumber,
          ArticleNumber: ArticleNumber,
          EanNumber: EanNumber,
          UseAllBranchesStockBalance: UseAllBranchesStockBalance,
          EDISearch: EDISearch,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  ArticleRim : {
    SearchRims: {
      url: function(SearchHeaderRimDiameter, SearchHeaderCentreBore, SearchHeaderWheelOffset, SearchHeaderCircleDiameter, SearchHeaderDesign, SearchHeaderRimNumberOfLugs, SearchHeaderRimWidth, FilterRimDiameters, FilterCircleDiameters, FilterBackspacings, FilterLugs, FilterCentreBore, FilterMake, FilterWheelOffset, DisplayText, SearchId, BranchId, AgreementId, RetailPricelistId, RetailPricelistCurrencyRate, MainGroupId, SubGroups, CustomerId, OrderType, MinimumInStock, StockId, SearchText, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, UseAllBranchesStockBalance, EDISearch) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Article/ArticleRim/SearchRims';
        }
        var f_args = this.argsObject(SearchHeaderRimDiameter, SearchHeaderCentreBore, SearchHeaderWheelOffset, SearchHeaderCircleDiameter, SearchHeaderDesign, SearchHeaderRimNumberOfLugs, SearchHeaderRimWidth, FilterRimDiameters, FilterCircleDiameters, FilterBackspacings, FilterLugs, FilterCentreBore, FilterMake, FilterWheelOffset, DisplayText, SearchId, BranchId, AgreementId, RetailPricelistId, RetailPricelistCurrencyRate, MainGroupId, SubGroups, CustomerId, OrderType, MinimumInStock, StockId, SearchText, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, UseAllBranchesStockBalance, EDISearch);
        return $menu.getRootUrl() + '/Article/ArticleRim/SearchRims' + '?' + $.param(f_args);
      },
      argsObject: function(SearchHeaderRimDiameter, SearchHeaderCentreBore, SearchHeaderWheelOffset, SearchHeaderCircleDiameter, SearchHeaderDesign, SearchHeaderRimNumberOfLugs, SearchHeaderRimWidth, FilterRimDiameters, FilterCircleDiameters, FilterBackspacings, FilterLugs, FilterCentreBore, FilterMake, FilterWheelOffset, DisplayText, SearchId, BranchId, AgreementId, RetailPricelistId, RetailPricelistCurrencyRate, MainGroupId, SubGroups, CustomerId, OrderType, MinimumInStock, StockId, SearchText, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, UseAllBranchesStockBalance, EDISearch) {
        var f_args = {
          SearchHeaderRimDiameter: SearchHeaderRimDiameter,
          SearchHeaderCentreBore: SearchHeaderCentreBore,
          SearchHeaderWheelOffset: SearchHeaderWheelOffset,
          SearchHeaderCircleDiameter: SearchHeaderCircleDiameter,
          SearchHeaderDesign: SearchHeaderDesign,
          SearchHeaderRimNumberOfLugs: SearchHeaderRimNumberOfLugs,
          SearchHeaderRimWidth: SearchHeaderRimWidth,
          FilterRimDiameters: FilterRimDiameters,
          FilterCircleDiameters: FilterCircleDiameters,
          FilterBackspacings: FilterBackspacings,
          FilterLugs: FilterLugs,
          FilterCentreBore: FilterCentreBore,
          FilterMake: FilterMake,
          FilterWheelOffset: FilterWheelOffset,
          DisplayText: DisplayText,
          SearchId: SearchId,
          BranchId: BranchId,
          AgreementId: AgreementId,
          RetailPricelistId: RetailPricelistId,
          RetailPricelistCurrencyRate: RetailPricelistCurrencyRate,
          MainGroupId: MainGroupId,
          SubGroups: SubGroups,
          CustomerId: CustomerId,
          OrderType: OrderType,
          MinimumInStock: MinimumInStock,
          StockId: StockId,
          SearchText: SearchText,
          CurrencyId: CurrencyId,
          OrderCurrencyRate: OrderCurrencyRate,
          SupplierArticleNumber: SupplierArticleNumber,
          ArticleNumber: ArticleNumber,
          EanNumber: EanNumber,
          UseAllBranchesStockBalance: UseAllBranchesStockBalance,
          EDISearch: EDISearch,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  ArticleService : {
    SearchServices: {
      url: function(DisplayText, SearchId, BranchId, AgreementId, RetailPricelistId, RetailPricelistCurrencyRate, MainGroupId, SubGroups, CustomerId, OrderType, MinimumInStock, StockId, SearchText, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, UseAllBranchesStockBalance, EDISearch) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Article/ArticleService/SearchServices';
        }
        var f_args = this.argsObject(DisplayText, SearchId, BranchId, AgreementId, RetailPricelistId, RetailPricelistCurrencyRate, MainGroupId, SubGroups, CustomerId, OrderType, MinimumInStock, StockId, SearchText, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, UseAllBranchesStockBalance, EDISearch);
        return $menu.getRootUrl() + '/Article/ArticleService/SearchServices' + '?' + $.param(f_args);
      },
      argsObject: function(DisplayText, SearchId, BranchId, AgreementId, RetailPricelistId, RetailPricelistCurrencyRate, MainGroupId, SubGroups, CustomerId, OrderType, MinimumInStock, StockId, SearchText, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, UseAllBranchesStockBalance, EDISearch) {
        var f_args = {
          DisplayText: DisplayText,
          SearchId: SearchId,
          BranchId: BranchId,
          AgreementId: AgreementId,
          RetailPricelistId: RetailPricelistId,
          RetailPricelistCurrencyRate: RetailPricelistCurrencyRate,
          MainGroupId: MainGroupId,
          SubGroups: SubGroups,
          CustomerId: CustomerId,
          OrderType: OrderType,
          MinimumInStock: MinimumInStock,
          StockId: StockId,
          SearchText: SearchText,
          CurrencyId: CurrencyId,
          OrderCurrencyRate: OrderCurrencyRate,
          SupplierArticleNumber: SupplierArticleNumber,
          ArticleNumber: ArticleNumber,
          EanNumber: EanNumber,
          UseAllBranchesStockBalance: UseAllBranchesStockBalance,
          EDISearch: EDISearch,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  ArticleTube : {
    SearchTubes: {
      url: function(SearchHeaderSectionWidth, SearchHeaderAspectRatio, SearchHeaderRimDiameter, SearchHeaderValve, FilterSectionWidths, FilterAspectRatios, FilterRimDiameters, FilterValves, DisplayText, SearchId, BranchId, AgreementId, RetailPricelistId, RetailPricelistCurrencyRate, MainGroupId, SubGroups, CustomerId, OrderType, MinimumInStock, StockId, SearchText, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, UseAllBranchesStockBalance, EDISearch) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Article/ArticleTube/SearchTubes';
        }
        var f_args = this.argsObject(SearchHeaderSectionWidth, SearchHeaderAspectRatio, SearchHeaderRimDiameter, SearchHeaderValve, FilterSectionWidths, FilterAspectRatios, FilterRimDiameters, FilterValves, DisplayText, SearchId, BranchId, AgreementId, RetailPricelistId, RetailPricelistCurrencyRate, MainGroupId, SubGroups, CustomerId, OrderType, MinimumInStock, StockId, SearchText, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, UseAllBranchesStockBalance, EDISearch);
        return $menu.getRootUrl() + '/Article/ArticleTube/SearchTubes' + '?' + $.param(f_args);
      },
      argsObject: function(SearchHeaderSectionWidth, SearchHeaderAspectRatio, SearchHeaderRimDiameter, SearchHeaderValve, FilterSectionWidths, FilterAspectRatios, FilterRimDiameters, FilterValves, DisplayText, SearchId, BranchId, AgreementId, RetailPricelistId, RetailPricelistCurrencyRate, MainGroupId, SubGroups, CustomerId, OrderType, MinimumInStock, StockId, SearchText, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, UseAllBranchesStockBalance, EDISearch) {
        var f_args = {
          SearchHeaderSectionWidth: SearchHeaderSectionWidth,
          SearchHeaderAspectRatio: SearchHeaderAspectRatio,
          SearchHeaderRimDiameter: SearchHeaderRimDiameter,
          SearchHeaderValve: SearchHeaderValve,
          FilterSectionWidths: FilterSectionWidths,
          FilterAspectRatios: FilterAspectRatios,
          FilterRimDiameters: FilterRimDiameters,
          FilterValves: FilterValves,
          DisplayText: DisplayText,
          SearchId: SearchId,
          BranchId: BranchId,
          AgreementId: AgreementId,
          RetailPricelistId: RetailPricelistId,
          RetailPricelistCurrencyRate: RetailPricelistCurrencyRate,
          MainGroupId: MainGroupId,
          SubGroups: SubGroups,
          CustomerId: CustomerId,
          OrderType: OrderType,
          MinimumInStock: MinimumInStock,
          StockId: StockId,
          SearchText: SearchText,
          CurrencyId: CurrencyId,
          OrderCurrencyRate: OrderCurrencyRate,
          SupplierArticleNumber: SupplierArticleNumber,
          ArticleNumber: ArticleNumber,
          EanNumber: EanNumber,
          UseAllBranchesStockBalance: UseAllBranchesStockBalance,
          EDISearch: EDISearch,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  ArticleTyre : {
    SearchTyres: {
      url: function(SearchHeaderSectionWidth, SearchHeaderAspectRatio, SearchHeaderRimDiameter, SearchHeaderSpeedRating, SearchHeaderLoadIndex, SearchHeaderPly, SearchHeaderRFT, SearchHeaderExtraLoad, FilterSpeedRatings, FilterLoadIndexes, FilterTreadPatterns, FilterNoiseClasses, FilterWetGrips, FilterFuelEconomies, FilterPlys, FilterMake, FilterOther, FilterWinter, DisplayText, SearchId, BranchId, AgreementId, RetailPricelistId, RetailPricelistCurrencyRate, MainGroupId, SubGroups, CustomerId, OrderType, MinimumInStock, StockId, SearchText, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, UseAllBranchesStockBalance, EDISearch, isExtendedSearch) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Article/ArticleTyre/SearchTyres';
        }
        var f_args = this.argsObject(SearchHeaderSectionWidth, SearchHeaderAspectRatio, SearchHeaderRimDiameter, SearchHeaderSpeedRating, SearchHeaderLoadIndex, SearchHeaderPly, SearchHeaderRFT, SearchHeaderExtraLoad, FilterSpeedRatings, FilterLoadIndexes, FilterTreadPatterns, FilterNoiseClasses, FilterWetGrips, FilterFuelEconomies, FilterPlys, FilterMake, FilterOther, FilterWinter, DisplayText, SearchId, BranchId, AgreementId, RetailPricelistId, RetailPricelistCurrencyRate, MainGroupId, SubGroups, CustomerId, OrderType, MinimumInStock, StockId, SearchText, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, UseAllBranchesStockBalance, EDISearch, isExtendedSearch);
        return $menu.getRootUrl() + '/Article/ArticleTyre/SearchTyres' + '?' + $.param(f_args);
      },
      argsObject: function(SearchHeaderSectionWidth, SearchHeaderAspectRatio, SearchHeaderRimDiameter, SearchHeaderSpeedRating, SearchHeaderLoadIndex, SearchHeaderPly, SearchHeaderRFT, SearchHeaderExtraLoad, FilterSpeedRatings, FilterLoadIndexes, FilterTreadPatterns, FilterNoiseClasses, FilterWetGrips, FilterFuelEconomies, FilterPlys, FilterMake, FilterOther, FilterWinter, DisplayText, SearchId, BranchId, AgreementId, RetailPricelistId, RetailPricelistCurrencyRate, MainGroupId, SubGroups, CustomerId, OrderType, MinimumInStock, StockId, SearchText, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, UseAllBranchesStockBalance, EDISearch, isExtendedSearch) {
        var f_args = {
          SearchHeaderSectionWidth: SearchHeaderSectionWidth,
          SearchHeaderAspectRatio: SearchHeaderAspectRatio,
          SearchHeaderRimDiameter: SearchHeaderRimDiameter,
          SearchHeaderSpeedRating: SearchHeaderSpeedRating,
          SearchHeaderLoadIndex: SearchHeaderLoadIndex,
          SearchHeaderPly: SearchHeaderPly,
          SearchHeaderRFT: SearchHeaderRFT,
          SearchHeaderExtraLoad: SearchHeaderExtraLoad,
          FilterSpeedRatings: FilterSpeedRatings,
          FilterLoadIndexes: FilterLoadIndexes,
          FilterTreadPatterns: FilterTreadPatterns,
          FilterNoiseClasses: FilterNoiseClasses,
          FilterWetGrips: FilterWetGrips,
          FilterFuelEconomies: FilterFuelEconomies,
          FilterPlys: FilterPlys,
          FilterMake: FilterMake,
          FilterOther: FilterOther,
          FilterWinter: FilterWinter,
          DisplayText: DisplayText,
          SearchId: SearchId,
          BranchId: BranchId,
          AgreementId: AgreementId,
          RetailPricelistId: RetailPricelistId,
          RetailPricelistCurrencyRate: RetailPricelistCurrencyRate,
          MainGroupId: MainGroupId,
          SubGroups: SubGroups,
          CustomerId: CustomerId,
          OrderType: OrderType,
          MinimumInStock: MinimumInStock,
          StockId: StockId,
          SearchText: SearchText,
          CurrencyId: CurrencyId,
          OrderCurrencyRate: OrderCurrencyRate,
          SupplierArticleNumber: SupplierArticleNumber,
          ArticleNumber: ArticleNumber,
          EanNumber: EanNumber,
          UseAllBranchesStockBalance: UseAllBranchesStockBalance,
          EDISearch: EDISearch,
          isExtendedSearch: isExtendedSearch,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  ArticleWheel : {
    SearchWheels: {
      url: function(FilterRimDiameters, FilterDesigns, FilterCircleDiameters, FilterBackspacings, FilterLugs, FilterCentreBores, FilterMakes, FilterOthers, FilterWinter, FilterFuelEconomies, FilterWetGrips, FilterNoiseClasses, SearchHeaderSectionWidth, SearchHeaderAspectRatio, SearchHeaderRimDiameter, DisplayText, SearchId, BranchId, AgreementId, RetailPricelistId, RetailPricelistCurrencyRate, MainGroupId, SubGroups, CustomerId, OrderType, MinimumInStock, StockId, SearchText, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, UseAllBranchesStockBalance, EDISearch) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Article/ArticleWheel/SearchWheels';
        }
        var f_args = this.argsObject(FilterRimDiameters, FilterDesigns, FilterCircleDiameters, FilterBackspacings, FilterLugs, FilterCentreBores, FilterMakes, FilterOthers, FilterWinter, FilterFuelEconomies, FilterWetGrips, FilterNoiseClasses, SearchHeaderSectionWidth, SearchHeaderAspectRatio, SearchHeaderRimDiameter, DisplayText, SearchId, BranchId, AgreementId, RetailPricelistId, RetailPricelistCurrencyRate, MainGroupId, SubGroups, CustomerId, OrderType, MinimumInStock, StockId, SearchText, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, UseAllBranchesStockBalance, EDISearch);
        return $menu.getRootUrl() + '/Article/ArticleWheel/SearchWheels' + '?' + $.param(f_args);
      },
      argsObject: function(FilterRimDiameters, FilterDesigns, FilterCircleDiameters, FilterBackspacings, FilterLugs, FilterCentreBores, FilterMakes, FilterOthers, FilterWinter, FilterFuelEconomies, FilterWetGrips, FilterNoiseClasses, SearchHeaderSectionWidth, SearchHeaderAspectRatio, SearchHeaderRimDiameter, DisplayText, SearchId, BranchId, AgreementId, RetailPricelistId, RetailPricelistCurrencyRate, MainGroupId, SubGroups, CustomerId, OrderType, MinimumInStock, StockId, SearchText, CurrencyId, OrderCurrencyRate, SupplierArticleNumber, ArticleNumber, EanNumber, UseAllBranchesStockBalance, EDISearch) {
        var f_args = {
          FilterRimDiameters: FilterRimDiameters,
          FilterDesigns: FilterDesigns,
          FilterCircleDiameters: FilterCircleDiameters,
          FilterBackspacings: FilterBackspacings,
          FilterLugs: FilterLugs,
          FilterCentreBores: FilterCentreBores,
          FilterMakes: FilterMakes,
          FilterOthers: FilterOthers,
          FilterWinter: FilterWinter,
          FilterFuelEconomies: FilterFuelEconomies,
          FilterWetGrips: FilterWetGrips,
          FilterNoiseClasses: FilterNoiseClasses,
          SearchHeaderSectionWidth: SearchHeaderSectionWidth,
          SearchHeaderAspectRatio: SearchHeaderAspectRatio,
          SearchHeaderRimDiameter: SearchHeaderRimDiameter,
          DisplayText: DisplayText,
          SearchId: SearchId,
          BranchId: BranchId,
          AgreementId: AgreementId,
          RetailPricelistId: RetailPricelistId,
          RetailPricelistCurrencyRate: RetailPricelistCurrencyRate,
          MainGroupId: MainGroupId,
          SubGroups: SubGroups,
          CustomerId: CustomerId,
          OrderType: OrderType,
          MinimumInStock: MinimumInStock,
          StockId: StockId,
          SearchText: SearchText,
          CurrencyId: CurrencyId,
          OrderCurrencyRate: OrderCurrencyRate,
          SupplierArticleNumber: SupplierArticleNumber,
          ArticleNumber: ArticleNumber,
          EanNumber: EanNumber,
          UseAllBranchesStockBalance: UseAllBranchesStockBalance,
          EDISearch: EDISearch,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
};

compilator.url.Addons = {
  MissedCalls : {
    Index: {
      url: function() {
        return $menu.getRootUrl() + '/Addons/MissedCalls/Index';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetMissedCalls: {
      url: function() {
        return $menu.getRootUrl() + '/Addons/MissedCalls/GetMissedCalls';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
    Details: {
      url: function(callRecordId, info, isLocked, lockedBy) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Addons/MissedCalls/Details';
        }
        var f_args = this.argsObject(callRecordId, info, isLocked, lockedBy);
        return $menu.getRootUrl() + '/Addons/MissedCalls/Details' + '?' + $.param(f_args);
      },
      argsObject: function(callRecordId, info, isLocked, lockedBy) {
        var f_args = {
          callRecordId: callRecordId,
          info: info,
          isLocked: isLocked,
          lockedBy: lockedBy,
        };
        return f_args;
      },
      kendoWindow: function(callRecordId, info, isLocked, lockedBy, kendoWindowOptions) {
        var f_url = this.url(callRecordId, info, isLocked, lockedBy);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(callRecordId,info,isLocked,lockedBy, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  MichelinFenX : {
    Index: {
      url: function() {
        return $menu.getRootUrl() + '/Addons/MichelinFenX/Index';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    ServiceCenterMappingIndex: {
      url: function() {
        return $menu.getRootUrl() + '/Addons/MichelinFenX/ServiceCenterMappingIndex';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    ArticleMappingIndex: {
      url: function() {
        return $menu.getRootUrl() + '/Addons/MichelinFenX/ArticleMappingIndex';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    ApproveMapping: {
      url: function() {
        return $menu.getRootUrl() + '/Addons/MichelinFenX/ApproveMapping';
      },
      argsObject: function(fenXArticleCode) {
        var f_args = {
          fenXArticleCode: fenXArticleCode,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    CustomerMapping: {
      url: function() {
        return $menu.getRootUrl() + '/Addons/MichelinFenX/CustomerMapping';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    CurrencyMapping: {
      url: function() {
        return $menu.getRootUrl() + '/Addons/MichelinFenX/CurrencyMapping';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
};

compilator.url.AccountsPayable = {
  Print : {
    ReprintDialog: {
      url: function(reprinttype) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/AccountsPayable/Print/ReprintDialog';
        }
        var f_args = this.argsObject(reprinttype);
        return $menu.getRootUrl() + '/AccountsPayable/Print/ReprintDialog' + '?' + $.param(f_args);
      },
      argsObject: function(reprinttype) {
        var f_args = {
          reprinttype: reprinttype,
        };
        return f_args;
      },
      kendoWindow: function(reprinttype, kendoWindowOptions) {
        var f_url = this.url(reprinttype);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(reprinttype, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    PrintAccountsPayableJournal: {
      url: function() {
        return $menu.getRootUrl() + '/AccountsPayable/Print/PrintAccountsPayableJournal';
      },
      argsObject: function(journalNumber, verificationDate, preview) {
        var f_args = {
          journalNumber: journalNumber,
          verificationDate: verificationDate,
          preview: preview,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    PrintAccountsPayableJournalAccounting: {
      url: function() {
        return $menu.getRootUrl() + '/AccountsPayable/Print/PrintAccountsPayableJournalAccounting';
      },
      argsObject: function(journalNumber, verificationDate, preview) {
        var f_args = {
          journalNumber: journalNumber,
          verificationDate: verificationDate,
          preview: preview,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    PrintAccountsPayablePaymentJournals: {
      url: function() {
        return $menu.getRootUrl() + '/AccountsPayable/Print/PrintAccountsPayablePaymentJournals';
      },
      argsObject: function(journalNumbers, preview) {
        var f_args = {
          journalNumbers: journalNumbers,
          preview: preview,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    PrintAccountsPayablePaymentsAccounting: {
      url: function() {
        return $menu.getRootUrl() + '/AccountsPayable/Print/PrintAccountsPayablePaymentsAccounting';
      },
      argsObject: function(journalNumbers, preview) {
        var f_args = {
          journalNumbers: journalNumbers,
          preview: preview,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    PrintAccountsPayableJournalAccountingAccumulated: {
      url: function() {
        return $menu.getRootUrl() + '/AccountsPayable/Print/PrintAccountsPayableJournalAccountingAccumulated';
      },
      argsObject: function(verificationStartDate, verificationEndDate, preview) {
        var f_args = {
          verificationStartDate: verificationStartDate,
          verificationEndDate: verificationEndDate,
          preview: preview,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    PrintAccountsPayablePaymentAccountingAccumulated: {
      url: function() {
        return $menu.getRootUrl() + '/AccountsPayable/Print/PrintAccountsPayablePaymentAccountingAccumulated';
      },
      argsObject: function(verificationStartDate, verificationEndDate, preview) {
        var f_args = {
          verificationStartDate: verificationStartDate,
          verificationEndDate: verificationEndDate,
          preview: preview,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    PrintAccountsPayableDebtByDate: {
      url: function(date, preview) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/AccountsPayable/Print/PrintAccountsPayableDebtByDate';
        }
        var f_args = this.argsObject(date, preview);
        return $menu.getRootUrl() + '/AccountsPayable/Print/PrintAccountsPayableDebtByDate' + '?' + $.param(f_args);
      },
      argsObject: function(date, preview) {
        var f_args = {
          date: date,
          preview: preview,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
  },
  Register : {
    InvoiceDetails: {
      url: function(voucherNumber, lastSupplierId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/AccountsPayable/Register/InvoiceDetails';
        }
        var f_args = this.argsObject(voucherNumber, lastSupplierId);
        return $menu.getRootUrl() + '/AccountsPayable/Register/InvoiceDetails' + '?' + $.param(f_args);
      },
      argsObject: function(voucherNumber, lastSupplierId) {
        var f_args = {
          voucherNumber: voucherNumber,
          lastSupplierId: lastSupplierId,
        };
        return f_args;
      },
      browserWindow: function(voucherNumber, lastSupplierId) {
        var f_url = this.url(voucherNumber, lastSupplierId);
        var f_args = [voucherNumber, lastSupplierId];
        var f_winId = f_args.join('_')
        var f_windowName = undefined;
        if(f_winId.replace(/_/g, '') != '') {
          f_windowName = 'InvoiceDetails_' + f_args.join('_');
        }
        compilator.windowHandler.openWindowWithFocus(f_url, f_windowName, arguments.length > 0);
      },
    },
    InvoiceNumberAlreadyExists: {
      url: function() {
        return $menu.getRootUrl() + '/AccountsPayable/Register/InvoiceNumberAlreadyExists';
      },
      argsObject: function(invoiceNumber, supplierId) {
        var f_args = {
          invoiceNumber: invoiceNumber,
          supplierId: supplierId,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'POST', ajaxOptions, 'json', ajaxData);
      },
    },
    PostPaymentFile: {
      url: function(exportId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/AccountsPayable/Register/PostPaymentFile';
        }
        var f_args = this.argsObject(exportId);
        return $menu.getRootUrl() + '/AccountsPayable/Register/PostPaymentFile' + '?' + $.param(f_args);
      },
      argsObject: function(exportId) {
        var f_args = {
          exportId: exportId,
        };
        return f_args;
      },
      kendoWindow: function(exportId, kendoWindowOptions) {
        var f_url = this.url(exportId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(exportId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
    GetInvoiceDetailsDefaultSettings: {
      url: function() {
        return $menu.getRootUrl() + '/AccountsPayable/Register/GetInvoiceDetailsDefaultSettings';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
    AccountsPayableDebtByDateDialog: {
      url: function() {
        return $menu.getRootUrl() + '/AccountsPayable/Register/AccountsPayableDebtByDateDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  Search : {
    GetPaymentsForInvoiceTooltip: {
      url: function(voucherNumber) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/AccountsPayable/Search/GetPaymentsForInvoiceTooltip';
        }
        var f_args = this.argsObject(voucherNumber);
        return $menu.getRootUrl() + '/AccountsPayable/Search/GetPaymentsForInvoiceTooltip' + '?' + $.param(f_args);
      },
      argsObject: function(voucherNumber) {
        var f_args = {
          voucherNumber: voucherNumber,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    AccumulatedReportsDialog: {
      url: function() {
        return $menu.getRootUrl() + '/AccountsPayable/Search/AccumulatedReportsDialog';
      },
      kendoWindow: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
};

compilator.url.Accounting = {
  Account : {
    SearchAccountAutoSuggest: {
      url: function(searchText) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Accounting/Account/SearchAccountAutoSuggest';
        }
        var f_args = this.argsObject(searchText);
        return $menu.getRootUrl() + '/Accounting/Account/SearchAccountAutoSuggest' + '?' + $.param(f_args);
      },
      argsObject: function(searchText) {
        var f_args = {
          searchText: searchText,
        };
        return f_args;
      },
      ajax: function(ajaxData, ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json', ajaxData);
      },
    },
    GetAccount: {
      url: function(accountId) {
        if(arguments.length === 0 || $.grep(arguments, function(a) { return a != undefined; }).length === 0) {
          return $menu.getRootUrl() + '/Accounting/Account/GetAccount';
        }
        var f_args = this.argsObject(accountId);
        return $menu.getRootUrl() + '/Accounting/Account/GetAccount' + '?' + $.param(f_args);
      },
      argsObject: function(accountId) {
        var f_args = {
          accountId: accountId,
        };
        return f_args;
      },
      kendoWindow: function(accountId, kendoWindowOptions) {
        var f_url = this.url(accountId);
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
      kendoWindow_argsAsObjects: function(accountId, kendoWindowOptions) {
        var f_url = this.url();
        var f_window = $kendo.openNewKendoWindow(f_url, kendoWindowOptions);
        return f_window;
      },
    },
  },
  Accounting : {
    GetProjects: {
      url: function() {
        return $menu.getRootUrl() + '/Accounting/Accounting/GetProjects';
      },
      ajax: function(ajaxOptions) {
        var f_url = this.url();
        return compilator.url._Ajax(f_url, 'GET', ajaxOptions, 'json');
      },
    },
  },
};

